const en = {
  // Login related
  login: {
    title: 'SS.AI Customer Service',
    platformTitle: 'CUI Platform',
    platformTitlePrefix: '',
    platformTitleHighlight: 'CUI',
    platformTitleSuffix: ' Platform for SMEs',
    userId: 'User ID',
    email: 'Email',
    accountOrEmail: 'Account or Email',
    password: 'Password',
    loginButton: 'Login',
    loginSuccess: 'Login successful!',
    loginFailed: 'Login failed',
    userIdRequired: 'Please enter User ID!',
    passwordRequired: 'Please enter password!',
    accountPasswordError: 'Incorrect account or password',
    networkError: 'Login failed, please check network connection',
    welcome: 'Welcome to SS.AI Customer Service, {name}!',
    userIdLabel: 'User ID',
    logout: 'Logout',
    logoutSuccess: 'Logged out'
  },
  wpaLogin: {
    loginName: 'Login name',
    password: 'Password',
    passwordPlaceholder: 'Enter password',
    rememberLogin: 'Remember me',
    rememberLoginHint: 'Saves your login name on this device. We do not store your password here—use the browser password manager or enter it each time. If you did not sign out, you will be taken into the store automatically.',
    sessionRestoring: 'Restoring your session…',
    forgotPassword: 'Forgot password',
    forgotPasswordTitle: 'Forgot password',
    login: 'Log in',
    loggingIn: 'Signing in...',
    validatingWhatsappLink: 'Validating WhatsApp link...',
    otpSentTo: 'Code sent to',
    otpCode: 'OTP code',
    verify: 'Verify',
    verifying: 'Verifying...',
    useAccountPassword: 'Use account & password',
    backToLogin: 'Back to login',
    selectCompany: 'Select company',
    whatsappOtpLogin: 'WhatsApp OTP login',
    networkError: 'Network error, try again',
    loginFailed: 'Login failed, check account and password',
    otpFailed: 'OTP failed, try again',
    companySelectFailed: 'Company selection failed',
    linkValidateFailed: 'Link validation failed, please reopen from WhatsApp',
    enterLoginNameFirst: 'Please enter login name before clicking forgot password',
    forgotPasswordGuide: 'Enter your login name on the sign-in page first, then choose a reset option below (only channels registered on your account are shown).',
    forgotPasswordNoChannels: 'No phone or email is registered for this account. Contact your administrator.',
    forgotPasswordChooseMethod: 'How to reset',
    forgotPasswordPhoneOnlyHint: 'Enter your login ID and the system will send an OTP to your registered phone.',
    forgotPasswordByEmail: 'Receive OTP by email',
    forgotPasswordEmailUnavailable: 'Account not found, no email on file, or email OTP template is not configured. Try WhatsApp or contact your administrator.',
    forgotPasswordByPhone: 'Phone OTP',
    forgotPasswordEmailDone: 'If this account exists and has an email on file, you will receive a reset link.',
    forgotPasswordPhoneUnavailable: 'No matching account, no phone on file, or OTP could not be sent. Try email or contact admin.',
    forgotPasswordNewPassword: 'New password',
    forgotPasswordConfirmPassword: 'Confirm new password',
    forgotPasswordSubmitPhone: 'Verify and reset password',
    forgotPasswordPhoneSuccess: 'Password updated. Return to login.',
    forgotPasswordMismatch: 'Passwords do not match',
    resetPasswordTitle: 'Reset password',
    resetPasswordSubmit: 'Set new password',
    resetPasswordSuccess: 'Password updated. Return to login.',
    resetPasswordBackToLogin: 'Back to login',
    resetPasswordTokenMissing: 'Invalid or expired link. Request a new reset.',
    passwordMinLength: 'Password must be at least 8 characters',
    brandSubtitle: 'WhatoCommerce',
    languageAria: 'Interface language',
    otpLoginSeparator: 'Or continue with',
    sendWhatsappOtp: 'Send WhatsApp OTP',
    sendEmailOtp: 'Send Email OTP',
    emailOtpLogin: 'Email OTP Login',
    sendingOtp: 'Sending...',
    emailOtpSentTo: 'OTP sent to email',
  },
  wpa: {
    changePassword: {
      title: 'Change Password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm New Password',
      submit: 'Save New Password',
      success: 'Password updated successfully.',
      errorMismatch: 'Passwords do not match',
      errorMinLength: 'Password must be at least 8 characters',
      errorWrongCurrent: 'Current password is incorrect',
      errorNetwork: 'Network error, please try again',
    },
    common: {
      loading: 'Loading...',
      loadMore: 'Load more...',
      noProducts: 'No products',
      noCategories: 'No categories',
      noOrders: 'No orders',
      priceInquire: 'Contact for price',
      outOfStock: 'Out of stock',
      noStock: 'No stock',
      addToCartAria: 'Add to cart',
      search: 'Search',
      allCategories: 'All categories',
      searchPlaceholder: 'Search products...',
      noSearchResults: 'No matching products',
      cannotOrderOutOfStock: 'This product is out of stock. You cannot place an order.',
      cannotOrderInactiveStatus: 'This product\'s status is "{status}". You cannot place an order.',
      catalogStatusDisplay: 'Status: {status}',
      catalogStatusLabels: {
        outOfStock: 'Out of stock',
        stopOrdering: 'Stop ordering',
        suspend: 'Suspend',
      },
      emDash: '—',
      forbiddenAction: 'You do not have permission to perform this action.',
      requestFailedStatus: 'Request failed ({status})',
      customerSuspendedBlock:
        'Sorry, your account has been suspended. Please contact your salesman for detail.\n\nSalesman: {sales}\nCode: {code}\nTel no: {whatsapp}\n\nError Code: C',
      cannotAddToCartTitle: 'Cannot add to cart',
      moqSubmitBlocked: 'Some line quantities are below the minimum order quantity (MOQ). Please adjust before submitting:',
      moqSubmitLineFmt: '{label}: minimum {moq}, current {qty}',
      moqSubmitDocPrefix: 'Document {cartNo}',
    },
    titles: {
      home: 'Home',
      categories: 'Categories',
      products: 'Products',
      cart: 'Cart',
      cartDetail: 'Order info',
      orders: 'Orders',
      account: 'Account',
      orderDetail: 'Order detail',
    },
    layout: {
      menuHome: 'Home',
      menuCategories: 'Categories',
      menuCart: 'Cart',
      menuOrders: 'Orders',
      menuAccount: 'Account',
      menuChangePassword: 'Change Password',
      ariaMenu: 'Menu',
      ariaBack: 'Back',
      ariaSearch: 'Search',
      ariaCart: 'Shopping cart',
      logout: 'Logout',
      selectCustomer: 'Select customer',
      current: 'Current',
      cancel: 'Cancel',
      installTitle: 'Install WhatoCommerce on home screen',
      installBodyAndroid: 'For the best experience, add to home screen. Tap “Install now” below.',
      installBodyIos: 'For the best experience, add to home screen. On iPhone, use Safari’s Share button and choose “Add to Home Screen”.',
      installBodyAndroidManual: 'If “Install now” does not appear, open Chrome’s menu (⋮) → “Install app” or “Add to Home screen”. The shortcut opens this store’s login page.',
      installLater: 'Later',
      installNow: 'Install now',
      installGotIt: 'Got it',
    },
    home: {
      banner: 'Featured recommended products',
      recommended: 'Recommended',
      allCategoriesBtn: 'All product categories',
      toastAddedLatest: 'Added to latest cart: {name} x{qty}',
      toastNewCart: 'New cart created and added: {name} x{qty}',
      promoClose: 'Close',
      promoAddToCart: 'Add to cart',
      promoNoProduct: 'No purchasable product linked',
      promoOutOfStock: 'Unavailable',
      ariaFullscreenAd: 'Fullscreen promotion',
      promoCarouselDots: 'Promotion carousel',
      promoPrev: 'Previous promotion',
      promoNext: 'Next promotion',
      recommendDelete: 'Delete',
      recommendDeleted: 'Removed from recommended list: {name}',
      recommendDeleteFailed: 'Could not delete recommended price card',
      recommendDeleteConfirmTitle: 'Confirm delete?',
      recommendDeleteConfirmMsg: 'Remove "{name}" from the recommended list? This cannot be undone.',
      recommendDeleteConfirmBtn: 'Confirm delete',
    },
    addToCart: {
      defaultUnit: 'unit',
      perQtyFmt: 'Per {unit} {price}',
      qtyWithUnitFmt: '{qty} {unit}',
      fastStepMinus: '- {step}',
      fastStepPlus: '+ {step}',
      unitStepMinus: '-1',
      unitStepPlus: '+1',
      createNewOrder: 'Create new order',
      cancel: 'Cancel',
      addToCart: 'Add to cart',
    },
    productList: {
      recommendAdded: 'Added to recommend price list (Order App): {name}',
      recommendFailed: 'Could not add recommendation',
      recommendNeedCustomer: 'Select a customer profile first',
      addRecommendAria: 'Add to recommend price list',
      backToRecommended: 'Back to recommended',
    },
    categories: {
      itemsCount: '{count} items',
      featuredBtn: 'Featured products',
    },
    cartDocs: {
      section: 'Cart documents ({count})',
      notSubmitted: 'Not submitted',
      empty: 'No cart documents yet',
      submitAll: 'Submit all',
      submitting: 'Submitting...',
      toastSubmitted: 'Submitted {count} order(s)',
      toastNothing: 'Nothing to submit',
      toastFail: 'Submit failed, please try again',
    },
    cartDetail: {
      orderSubmitted: 'Order submitted',
      submitFail: 'Submit failed',
      notFound: 'Cart document not found',
      orderNo: 'Order no.',
      total: 'Total',
      deliveryDate: 'Delivery date',
      poNo: 'PO no.',
      remark: 'Remark',
      address: 'Address',
      addressPlaceholder: 'Delivery address (multiple lines)',
      errorTitle: 'Could not submit',
      errorOk: 'OK',
      updated: 'Updated',
      update: 'Update',
      submit: 'Submit',
      submitting: 'Submitting...',
      deleteOrder: 'Delete order',
      confirmRemoveItemTitle: 'Remove this item?',
      confirmRemoveItemMsg: 'Remove this product from the cart?',
      confirmDeleteOrderTitle: 'This will delete the entire order',
      confirmDeleteOrderMsg: 'This is the last item in the order. Removing it will delete the whole order. Continue?',
      confirmDeleteOrderBtnTitle: 'Delete this order?',
      confirmDeleteOrderBtnMsg: 'This order will be deleted and cannot be recovered.',
      confirmLeaveTitle: 'Unsaved changes',
      confirmLeaveMsg: 'Your changes have not been saved with "Update". They will be lost if you leave. Leave anyway?',
      confirmYes: 'Confirm',
      confirmNo: 'Cancel',
      confirmLeave: 'Leave',
      confirmStay: 'Stay',
      confirmRemove: 'Remove',
      confirmDelete: 'Delete',
      confirmKeep: 'Keep',
    },
    orders: {
      tabAll: 'All',
      tabSubmitted: 'Submitted',
      tabProcessing: 'Processing',
      statusPending: 'Pending',
      statusSubmitted: 'Submitted',
      statusProcessing: 'Processing',
      statusCompleted: 'Completed',
      statusCancelled: 'Cancelled',
    },
    orderDetail: {
      orderUpdated: 'Order updated',
      updateFailed: 'Update failed',
      orderSubmitted: 'Order submitted',
      submitFailed: 'Submit failed',
      orderDeleted: 'Order deleted',
      deleteFailed: 'Delete failed',
      loading: 'Loading...',
      notFound: 'Order not found',
      orderInfo: 'Order info',
      orderNo: 'Order no.',
      status: 'Status',
      orderDate: 'Submitted At',
      deliveryDate: 'Delivery date',
      customerNo: 'Customer No.',
      poNo: 'PO no.',
      poPlaceholder: 'Enter PO no.',
      remark: 'Remark',
      remarkPlaceholder: 'Enter remark',
      address: 'Address',
      addressPlaceholder: 'Enter address',
      orderLines: 'Order lines',
      lineSubtotal: 'Subtotal',
      deleteLineAria: 'Remove line',
      total: 'Total',
      processing: 'Processing...',
      updateOrder: 'Update order',
      submitOrder: 'Submit order',
      deleteOrder: 'Delete order',
      confirmDelete: 'Confirm delete',
      confirmDeleteMsg: 'Delete this order? This cannot be undone.',
      cancel: 'Cancel',
      confirmDeleteBtn: 'Delete',
      titleWithNo: 'Order {orderNo}',
      lineSubtotalFmt: 'Subtotal: {amount}',
      errorTitle: 'Could not complete',
      errorOk: 'OK',
    },
    account: {
      basicInfo: 'Basic info',
      customerNo: 'Customer no.',
      name1: 'Name',
      name2: 'Branch name',
      displayName: 'Display name (current language)',
      nameEn: 'English name',
      nameCn: 'Traditional Chinese name',
      nameSc: 'Simplified Chinese name',
      deliveryAddress: 'Delivery address',
      addressEn: 'English address',
      addressCn: 'Chinese address',
      salesman: 'Sales rep',
      deliveryDays: 'Delivery days',
      holiday: 'Holiday',
      loadFailed: 'Could not load account',
      sectionDelivery: 'Delivery address',
      sectionSales: 'Sales rep',
      sectionDeliveryDays: 'Delivery days',
      weekdays: {
        Mon: 'M', Tue: 'T', Wed: 'W', Thu: 'T', Fri: 'F', Sat: 'S', Sun: 'S',
      },
    },
    legacyCart: {
      cartItems: 'Cart items ({count})',
      pendingOrders: 'Pending orders ({count})',
      pendingConfirm: 'Pending',
      subtotal: 'Subtotal',
      empty: 'Cart is empty',
      submitAll: 'Submit all orders',
      submitting: 'Submitting...',
      toastNoCustomer: 'Could not load customer, contact admin',
      toastNoLink: 'No linked customer, contact admin',
      toastCreateFail: 'Failed to create order',
      toastSuccess: 'Orders submitted!',
      toastFail: 'Submit failed, try again',
    },
  },
  
  // Menu items
  menu: {
    dashboard: 'Dashboard',
    application: 'Application',
    publishedApps: 'Published Apps',
    pendingTasks: 'Running Forms',
    adminTools: 'Admin Tools',
    contactList: 'Contact Management',
    broadcastGroups: 'Broadcast Groups',
    hashtags: 'Tag Management',
    studio: 'Studio',
    unsigned: 'Delivered Not Signed',
    customerSigned: 'Customer Signed',
    signedPending: 'Signed Pending Confirmation',
    logout: 'Logout',
    dashboardRecentActivity: 'Recent Activity',
    whatsappWorkflow: 'Workflow Design',
    companyUserAdmin: 'Company/User Management',
    eformList: 'Form Management',
    whatsappTemplates: 'Message Templates',
    dataSets: 'Data Sets',
    workflowMonitor: 'Running Apps',
    runningApps: 'Running Apps',
    chatBotInbox: 'ChatBot Inbox',
    calendar: 'Calendar',
    documentLibrary: 'Document Library',
    phoneVerificationAdmin: 'Phone Number Verification',
    permissionManagement: 'Permission Management',
    apiProviders: 'API Providers',
    commerce: 'Commerce',
    commerceCustomers: 'Customer Master',
    commercePriceCards: 'Price Cards',
    commerceSalesOrders: 'Sales Orders',
    commerceCollections: 'Collections',
    commerceProducts: 'Products',
    commerceWpaHomePromotions: 'PWA home ads',
    commerceImport: 'Data Exchange',
    commerceImportSchedule: 'Import Schedule',
    commerceCatalogAdmin: 'Catalog Admin',
    commerceWpaPermissions: 'PWA Permissions',
    commerceDeliveryRules: 'Delivery cutoff rules',
    reports: 'Reports',
    dailyReports: 'Daily Reports',
    monthlyReports: 'Monthly Reports',
    realtimeReports: 'Realtime Reports',
    appsMediaReports: 'App\'s Media Reports',
    eformInstanceReports: 'EForm Instance Reports',
    eformPivotReports: 'EForm Pivot Reports',
    commerceReports: 'Commerce Reports',
    reportsBillingSystem: 'System usage & billing',
    usageBillingSettings: 'Usage billing unit prices',
    aiEmployeeProfiles: 'AI Employee Profiles',
    buildApp: 'Build App',
    workflowPackage: 'CUI Apps Package',
    knowledgeBase: 'Knowledge base',
    reportTemplates: 'Report template library',
    templateReport: 'Template report',
  },

  buildApp: {
    welcomeTitle: 'What will you build today?',
    welcomeSubtitle: 'Describe your business scenario, channels, and goals — AI will guide you through the build',
    inputPlaceholder: 'e.g. Build a WhatsApp customer service flow that auto-routes inquiries and notifies colleagues for approval when needed…',
    inputPlaceholder2: 'Type a reply (Enter to send, Shift+Enter for new line)',
    planFirst: 'Plan First',
    planFirstHelp: 'When enabled, AI will show a plan for you to confirm before generating',
    startBtn: 'Start Building',
    suggestionLabel: 'Quick start:',
    suggestion1: 'WhatsApp customer service auto-reply flow',
    suggestion2: 'Multi-step order approval workflow',
    suggestion3: 'New employee onboarding data collection form',
    suggestion4: 'Email notification + task assignment flow',
    suggestion5: 'Meta Flow guided questionnaire',
    suggestion6: 'WhatsApp × Email combined notification',
    chatTitle: 'Build App',
    newApp: 'New App',
    appsHistory: 'Apps History',
    aiThinking: 'AI is thinking…',
    uploadImage: 'Upload reference image',
    planCardTitle: 'Build Plan',
    planChannel: 'Channel',
    planWorkflowNodes: 'Workflow nodes',
    planEformFields: 'Form fields',
    planWizardSteps: 'Wizard Steps',
    planModify: 'Modify plan',
    planConfirm: 'Confirm & Generate',
    buildingMsg: 'AI is generating your app, please wait…',
    completeMsg: 'App generated! Click below to enter the build wizard and refine each step.',
    openDesigner: 'Open Designer',
    openWorkflowDesigner: '① Open Workflow Designer',
    openFormDesigner: 'Open Form Designer',
    openMetaflowDesigner: 'Open MetaFlow Designer',
    wizardStart: 'Next: Enter Build Wizard',
    wizardTitle: 'Build Wizard',
    wizardBackToChat: 'Back to Build App',
    wizardPrev: 'Previous',
    wizardNext: 'Confirm & Next',
    wizardFinish: 'Finish',
    wizardDone: 'Build complete!',
    wizardLoading: 'Loading…',
    wizardLoadFail: 'Failed to load',
    wizardSaved: 'Saved',
    wizardPreFinalizing: 'Applying selected resources to workflow nodes…',
    wizardPreFinalizeDone: 'Selected resources applied to workflow nodes',
    wizardFinalizeFail: 'Some resources could not be auto-linked; please set them manually in the workflow designer',
    wizardPickLabel: 'Use in workflow:',
    wizardPickPlaceholder: 'Select the item to use in the workflow (create below then refresh)',
    wizardPickSelected: 'Selected',
    wizardPickRefresh: 'Refresh',
    wizardStep: {
      eform: 'Form',
      metaflow: 'Meta Flow',
      template: 'Message Template',
      dataset: 'Dataset',
      aiStaff: 'AI Staff',
      kb: 'Knowledge Base',
      workflow: 'Workflow',
    },
    wizardHint: {
      eform: 'Adjust form fields and layout here, then confirm to proceed.',
      metaflow: 'Adjust Meta Flow screens here, then confirm to proceed.',
      template: 'Create or edit WhatsApp message templates (Meta Template required for 24h+ outbound).',
      dataset: 'Configure Dataset fields and data source here.',
      aiStaff: 'Set up AI employee profiles here.',
      kb: 'Upload knowledge base documents here.',
      workflow: 'Refine workflow nodes here. eForm nodes are pre-linked.',
    },
    generateFailMsg: 'An error occurred during generation. Please describe your requirements and try again.',
    modifyPlanPrompt: 'Sure, what would you like to change?',
    suggChangeChannel: 'Change channel',
    suggAddApproval: 'Add approval step',
    suggRemoveForm: 'No form needed',
  },

  workflowPackage: {
    title: 'CUI Apps Package',
    cuiDefinition: 'CUI stands for Conversational User Interface: applications centered on natural-language dialogue with users.',
    subtitle: 'Export or import a workflow and its dependencies (forms, datasets, templates, AI staff, Studio knowledge documents, etc.).',
    tabExport: 'Export',
    tabImport: 'Import',
    stepSelectWorkflow: 'Select workflow',
    stepReviewDeps: 'Review dependencies',
    stepBuilding: 'Build ZIP',
    stepDownload: 'Download',
    stepUpload: 'Upload package',
    stepPreview: 'Preview',
    stepImporting: 'Importing',
    stepDone: 'Done',
    selectWorkflow: 'Workflow to export',
    selectWorkflowFirst: 'Please select a workflow first',
    prev: 'Back',
    dropdownColName: 'Workflow',
    dropdownColCompany: 'Company',
    dropdownColStatus: 'Status',
    dropdownColUpdated: 'Updated',
    exportAiStaff: 'Include in export',
    next: 'Next: scan dependencies',
    previewLoaded: 'Dependency list loaded',
    colKind: 'Kind',
    kindEform: 'Form',
    kindDataset: 'Dataset',
    kindTemplate: 'Template',
    kindMetaTemplate: 'Meta template',
    kindAiStaff: 'AI staff',
    kindKnowledgeDoc: 'Knowledge document',
    kindWorkflow: 'Workflow',
    colName: 'Name',
    colInclude: 'Include',
    included: 'Included',
    excluded: 'Excluded',
    startExportZip: 'Build ZIP',
    downloadZip: 'Download ZIP',
    selectZip: 'Select .zip package',
    importPreviewOk: 'Package preview ready',
    metaNotice: 'This package includes Meta-related resources. After import, complete WABA sync in WhatsApp/form settings and map Meta IDs if needed.',
    renameFrom: 'Original name',
    renameTo: 'Import as',
    confirmImport: 'Confirm import',
    importDone: 'Import completed',
    metaWarningsTitle: 'Meta Template Import Warnings',
    exportMetaWarningsTitle: 'Meta Template Export Warnings',
    exportAgain: 'Export again',
    importAgain: 'Import again',
    goImport: 'Go to Import',
    goExport: 'Go to Export',
  },

  knowledgeBase: {
    title: 'Studio knowledge base',
    subtitle: 'Upload Office/PDF files, convert to AI-friendly text and a first-page preview; version and publish.',
    viewTile: 'Tiles',
    viewList: 'List',
    filterCategory: 'Category',
    allCategories: 'All categories',
    searchPlaceholder: 'Search title or content',
    search: 'Search',
    uploadNew: 'Upload',
    uploadSelectCategory: 'Category (optional)',
    newCategory: 'New category',
    uploadOk: 'Uploaded; processing…',
    versionAdded: 'New version added',
    publishOk: 'Publish version set',
    deleteVersionOk: 'Version removed',
    deleteDocumentOk: 'Document removed from the list',
    deleteDocument: 'Delete document',
    confirmDeleteDocument: 'Delete this entire document? It will disappear from the list; version records remain for audit.',
    publish: 'Publish',
    delete: 'Delete',
    confirmDeleteVersion: 'Delete this version? If it is published, publishing will be cleared.',
    empty: 'No documents yet',
    noPreview: 'No preview',
    published: 'Published',
    draft: 'Not published',
    detailTitle: 'Document',
    addVersion: 'Upload new version',
    metaPublished: 'Published version',
    none: 'None',
    categoryCreated: 'Category created',
    categoryName: 'Name',
    parentCategory: 'Parent (optional)',
    sortOrder: 'Sort order',
    colVersion: 'Ver.',
    colFileName: 'File',
    colStatus: 'Status',
    colIndexStatus: 'Vector index',
    colChunks: 'Chunks',
    indexNone: 'Not indexed',
    reindex: 'Rebuild index',
    reindexQueued: 'Queued for vector indexing',
    ragWorkflowHint: 'Enable "Vector retrieval (RAG)" in the workflow node\'s Knowledge base settings: turn on the master switch, select this document, then toggle RAG. Use "Rebuild index" on this page to build vectors only.',
    ragXaiHint: 'xAI Collections managed RAG is enabled. Create a Collection for each category (tree on the left), then Publish a version to sync it to xAI. The chatbot will automatically search synced content.',
    xaiNotSyncedHint: 'Not yet synced to xAI Collection. Ensure the category has a Collection, then re-publish this version.',
    colCreated: 'Created',
    colActions: 'Actions',
    colDocumentActions: 'Document',
    colTitle: 'Title',
    colPublished: 'Published',
    colUpdated: 'Updated',
    yes: 'Yes',
    no: 'No',
    prev: 'Prev',
    next: 'Next',
    download: 'Download',
    downloadLatest: 'Download latest version',
    downloadAllVersionsZip: 'Download all versions (ZIP)',
    downloadNoVersions: 'No versions to download',
    colXaiSync: 'xAI Sync',
    xaiSynced: 'Synced',
    xaiNotSynced: 'Not synced',
    xaiCategoryCollections: 'xAI Collections (per category)',
    xaiCollectionStatus: 'xAI Collection Status',
    xaiCollectionReady: 'Created',
    xaiCollectionNotCreated: 'Not created',
    xaiCollectionCreate: 'Create Collection',
    xaiCollectionRemove: 'Remove Collection',
    xaiCollectionConfirmRemove: 'Remove this xAI Collection? All uploaded files on xAI will be permanently deleted.',
    xaiCollectionCreated: 'xAI Collection created successfully',
    xaiCollectionRemoved: 'xAI Collection removed',
    xaiCollectionNoMgmtKey: 'Please ask a Tenant Admin to configure the xAI Management API Key in API Providers settings',
    allCategories: 'All Documents',
    noCategoryYet: 'No categories yet',
    noCategorySet: 'No category',
    categoryLabel: 'Category',
    moveCategoryOk: 'Category updated',
    deleteCategory: 'Delete category',
    categoryDeleted: 'Category deleted',
    confirmDeleteCategory: 'Delete this category? (Must have no documents or sub-categories)',
    catDeleteBlockedXai: 'This category still has an xAI Collection linked. Remove the Collection first.',
    catDeleteBlockedDocs: 'This category still has documents. Move or delete them first.',
    catDeleteBlockedChildren: 'Please delete sub-categories first.',
  },

  reportTemplates: {
    title: 'Report template library',
    subtitle: 'Manage Word / Excel / PowerPoint templates; configure placeholders and workflow variable bindings.',
    refresh: 'Refresh',
    uploadTemplate: 'Upload template',
    categories: 'Categories',
    all: 'All',
    uncategorized: 'Uncategorized',
    searchPlaceholder: 'Search name / description / category…',
    searchResultCount: '{count} result(s)',
    selectedCount: '{count} template(s) selected',
    batchDelete: 'Delete selected',
    batchDownload: 'Download selected',
    clearSelection: 'Clear selection',
    colName: 'Name',
    colFormat: 'Format',
    colCategory: 'Category',
    colPlaceholder: 'Placeholder',
    colUploadDate: 'Uploaded',
    colActions: 'Actions',
    textCount: '{count} text',
    photoCount: '{count} photo',
    viewPlaceholder: 'View placeholders',
    download: 'Download template',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    confirmDeleteOne: 'Delete this template?',
    confirmBatchDelete: 'Delete {count} selected template(s)?',
    emptyInCategory: 'No templates in this category.',
    loadFailed: 'Failed to load templates: ',
    loadDetailFailed: 'Failed to load details: ',
    deleteSuccess: 'Template deleted',
    deleteFailed: 'Delete failed: ',
    batchDeleteSuccess: 'Deleted {count} template(s)',
    batchDeleteFailed: 'Batch delete failed: ',
    downloadFailed: 'Download failed: ',
    batchDownloadSuccess: 'Downloaded {done} template(s)',
    batchDownloadFailed: 'Batch download partially failed: {error} error(s)',
    updateSuccess: 'Updated',
    updateFailed: 'Update failed: ',
    batchCategoryLabel: 'Category (applies to all files)',
    categoryPlaceholder: 'Enter or select category (optional)',
    dragHint: 'Drag or click to select .docx / .xlsx / .pptx / .zip files',
    dragSubHint: 'Multiple files supported; ZIP files are automatically extracted; original filename used as template name',
    uploadComplete: 'Upload complete: {done} succeeded / {error} failed',
    fileCount: '{count} file(s)',
    pendingUpload: '{count} pending',
    uploading: 'Uploading…',
    completed: 'Completed',
    uploadingProgress: 'Uploading… ({done}/{total})',
    uploadAll: 'Upload all ({count})',
    photoSlotCount: '{count} photo slot(s)',
    placeholderFormatHint: 'Placeholder format:',
    placeholderFormatExamples: '{{PV:xxx}} / {{EFORM:form.field}} / {{SYS:DATE}} / {{PHOTO:slot|cols=5}}',
    detailTitle: 'Template details',
    detailTitleWithName: '{name} — Placeholders',
    editTitle: 'Edit template',
    nameRequired: 'Please enter a name',
    description: 'Description',
    bindingsSaved: 'Variable bindings saved',
    saveFailed: 'Save failed: ',
    textPlaceholders: 'Text placeholders',
    saveBindings: 'Save bindings',
    location: 'Location: {location}',
    displayLabelPlaceholder: 'Display label (optional)',
    photoSlots: 'Photo slots',
    noPlaceholdersDetected: 'No placeholders detected. Ensure the template uses {{TYPE:key}} syntax.',
  },

  usageBilling: {
    title: 'Usage billing',
    joinDate: 'Billing anchor (join date)',
    period: 'Billing period',
    workflowExecution: 'Workflow runs',
    metaOutbound: 'Meta outbound',
    aiCall: 'AI calls',
    rates: 'Unit prices',
    totalAmount: 'Subtotal',
    loadFailed: 'Failed to load usage',
    noPermission: 'No permission to view this report',
    systemReportTitle: 'System-wide usage & billing',
    settingsTitle: 'Usage billing unit prices',
    selectCompany: 'Company',
    currency: 'Currency',
    metaTemplatePrice: 'Meta outbound (per message)',
    aiCallPrice: 'AI (per call)',
    workflowExecPrice: 'Workflow execution (per run)',
    saveSuccess: 'Saved',
    saveFailed: 'Save failed',
    loadCompaniesFailed: 'Failed to load companies',
    loadSettingsFailed: 'Failed to load billing settings',
  },

  commerceDeliveryRules: {
    hint: 'Listed dates override weekly cutoff seconds. Set company timezone (IANA) on the company profile. PWA orders validate cutoffs using this page and the company timezone.',
    companyFilter: 'Company',
    tabCalendar: 'Special delivery dates / cutoffs',
    tabWeekly: 'Weekly cutoffs (seconds)',
    addWeekday: 'Add weekday',
    colDeliveryDate: 'Delivery date',
    colDeliveryWeekday: 'Weekday',
    yearFilter: 'Delivery date year',
    yearFilterAll: 'All years',
    colHoliday: 'Holiday',
    colCutoff: 'Order cutoff',
    colWeekday: 'Weekday',
    descriptionEn: 'Description (EN)',
    descriptionZh: 'Description (ZH)',
    noPermission: 'No permission',
    loadFailed: 'Load failed',
    saved: 'Saved',
    deleted: 'Deleted',
    orderCutoffDate: 'Cutoff date',
    orderCutoffTime: 'Cutoff time',
    editWeek: 'Edit weekly cutoff',
    addWeekdayTitle: 'Add weekday cutoff',
    cutoffOffsetSeconds: 'Cutoff offset (seconds)',
    weekdayField: 'Weekday (0–6)',
    weekdaySelectPlaceholder: '0=Sun … 6=Sat',
    deleteCalendarConfirm: 'Delete this special delivery date?',
  },

  aiEmployeeProfiles: {
    title: 'AI Employee Profiles',
    loadFailed: 'Failed to load',
    searchPlaceholder: 'Search name, number, department',
    viewList: 'List',
    viewTile: 'Tiles',
    create: 'Add',
    createTitle: 'New AI employee',
    editTitle: 'Edit AI employee',
    employeeNumber: 'Employee no.',
    employeeNumberAuto: 'Employee number is assigned after create',
    avatar: 'Avatar',
    gender: 'Gender',
    genderMale: 'Male',
    genderFemale: 'Female',
    genderOther: 'Other',
    displayName: 'Name',
    nameRequired: 'Name is required',
    department: 'Department',
    jobTitle: 'Job title',
    jobDescription: 'Job description',
    responsibilities: 'Responsibilities',
    responsibilitiesHint: 'Type and press Enter or comma',
    birthDate: 'Birth date',
    age: 'Age',
    birthplace: 'Birthplace',
    industry: 'Industry',
    background: 'Background',
    workExperience: 'Work experience',
    professionalSkills: 'Professional skills',
    personality: 'Personality',
    tabWork: 'Role & avatar',
    tabPersonal: 'Personal',
    tabMemory: 'My memories',
    memoryLabel: 'Memories / log (Markdown)',
    memoryHelp:
      'Rolling context for this AI employee: each successful AI call that uses this profile (wait-reply validation, eForm fill, HTML/Office generation, etc.) appends a short input/output summary, plus expand/avatar actions. It is injected into the role prompt on the next call; you can edit freely.',
    memoryPlaceholder:
      'No entries yet. Successful flow and fill-AI steps append summaries; expand/avatar also writes here—you can paste notes too.',
    memoryWizardHint: 'After creation, open the employee for edit and use the “My memories” tab to view or maintain the log.',
    loadDetailPartial: 'Could not load full detail; showing list data (memories may be out of sync).',
    createdAt: 'Created',
    actions: 'Actions',
    save: 'Save',
    saved: 'Saved',
    created: 'Created',
    deleted: 'Deleted',
    confirmDelete: 'Delete this profile?',
    randomAvatar: 'AI generate avatar',
    avatarProvider: 'Avatar AI provider',
    expandProvider: 'Expand-field provider',
    selectAiProvider: 'Select an AI provider first',
    avatarOk: 'Avatar updated',
    aiModalTitle: 'AI expand field',
    aiHintPlaceholder: 'Short instructions (optional)',
    aiApplied: 'Applied AI content',
    prev: 'Back',
    next: 'Next',
    submitCreate: 'Create',
    wizardStepOrg: 'Department & title',
    wizardStepProfile: 'Ideal colleague',
    wizardStepBio: 'Background & traits',
    wizardStepRole: 'Role details',
    wizardReviewHint: 'Review and click Create.',
    lookupLabels: {
      departments: {
        客服部: 'Customer Service',
        營運部: 'Operations',
        資訊部: 'IT',
        人資部: 'Human Resources',
        財務部: 'Finance',
        行銷部: 'Marketing',
        業務部: 'Sales',
        產品部: 'Product',
        研發部: 'R&D',
        法務部: 'Legal',
        總經理室: 'Executive Office'
      },
      jobTitles: {
        專員: 'Specialist',
        資深專員: 'Senior Specialist',
        主任: 'Supervisor',
        副理: 'Assistant Manager',
        經理: 'Manager',
        副總經理: 'Vice President',
        顧問: 'Consultant',
        實習生: 'Intern',
        助理: 'Assistant',
        組長: 'Team Lead',
        課長: 'Section Chief',
        總監: 'Director'
      },
      birthplaces: {
        香港: 'Hong Kong',
        台北: 'Taipei',
        新北: 'New Taipei',
        桃園: 'Taoyuan',
        台中: 'Taichung',
        台南: 'Tainan',
        高雄: 'Kaohsiung',
        新加坡: 'Singapore',
        上海: 'Shanghai',
        北京: 'Beijing',
        深圳: 'Shenzhen',
        廣州: 'Guangzhou',
        東京: 'Tokyo',
        首爾: 'Seoul',
        吉隆坡: 'Kuala Lumpur',
        倫敦: 'London',
        雪梨: 'Sydney'
      },
      industries: {
        金融服務: 'Financial services',
        保險: 'Insurance',
        地產與物業: 'Real estate & property',
        建築與工程: 'Construction & engineering',
        物流與運輸: 'Logistics & transportation',
        零售與批發: 'Wholesale & retail',
        餐飲與酒店: 'Food service & hospitality',
        科技與資訊: 'Technology & IT',
        電訊: 'Telecommunications',
        專業服務: 'Professional services',
        醫療與健康: 'Healthcare & wellness',
        教育與培訓: 'Education & training',
        政府與公共機構: 'Government & public sector',
        傳媒與廣告: 'Media & advertising',
        製造業: 'Manufacturing',
        能源與公用事業: 'Energy & utilities',
        非牟利與社福: 'Non-profit & social services',
        航空與旅遊: 'Aviation & tourism',
        其他: 'Other'
      }
    }
  },

  // Dashboard
  dashboard: {
    applicationTitle: 'Application',
    applicationDescription: 'Published workflow applications ready to launch',
    studioTitle: 'Studio',
    studioDescription: 'Management and design tools to build your custom workflows',
    adminToolsTitle: 'Admin Tools',
    adminToolsDescription: 'System management and user administration tools',
    contactManagement: 'Contact Management',
    contactManagementDescription: 'Manage WhatsApp contact information',
    broadcastGroups: 'Broadcast Groups',
    broadcastGroupsDescription: 'Manage broadcast groups and members',
    hashtagManagement: 'Hashtag Management',
    hashtagManagementDescription: 'Manage system tags and categories',
    companyUserManagement: 'Company/User Management',
    companyUserManagementDescription: 'Manage company accounts and user permissions',
    totalContacts: 'Total Contacts',
    totalGroups: 'Total Groups',
    totalMembers: 'Total Members',
    totalHashtags: 'Total Hashtags',
    hashtagUsage: 'Usage Count',
    totalUsers: 'Total Users',
    admins: 'Admins',
    totalCompanies: 'Total Companies',
    publishedApps: 'Published Apps',
    publishedAppsDescription: 'Available workflow applications',
    runningApps: 'Running Apps',
    runningAppsDescription: 'Currently executing workflow instances',
    pendingTasks: 'Pending Tasks',
    pendingTasksDescription: 'Approvals and responses requiring your attention',
    formManagement: 'Form Management',
    formManagementDescription: 'Electronic form design and management',
    messageTemplates: 'Message Templates',
    messageTemplatesDescription: 'WhatsApp message template management',
    workflowDesign: 'Workflow Design',
    workflowDesignDescription: 'Design and configure workflows',
    datasetManagement: 'Dataset Management',
    datasetManagementDescription: 'Data source and dataset management',
    aiEmployeeProfiles: 'AI Employee Profiles',
    aiEmployeeProfilesDescription: 'Virtual AI colleague profiles and avatars',
    userManagement: 'User Management',
    userManagementDescription: 'Company user and permission management',
    systemMonitoring: 'System Monitoring',
    systemMonitoringDescription: 'Workflow execution monitoring and analysis',
    workflowMonitor: 'Running Apps',
    workflowMonitorDescription: 'Workflow execution monitoring and analysis',
    totalCount: 'Total',
    recentlyAdded: 'Recently Added',
    loading: 'Loading...',
    loadingDashboard: 'Loading Dashboard...',
    active: 'Active',
    draft: 'Draft',
    disabled: 'Disabled',
    running: 'Running',
    completed: 'Completed',
    failed: 'Failed',
    pendingApproval: 'Pending Approval',
    processed: 'Processed',
    today: 'Today',
    enabled: 'Enabled',
    inactive: 'Inactive',
    published: 'Published',
    test: 'Test',
    totalDatasets: 'Total Datasets',
    error: 'Error',
    totalUsers: 'Total Users',
    online: 'Online',
    admin: 'Admin',
    successRate: 'Success Rate',
    averageTime: 'Average Time',
    minutes: 'min',
    // 數據分析相關
    dataAnalysis: 'Data Analysis',
    dataAnalysisDescription: 'Real-time system operation data overview',
    messageTrend: 'Message Trend',
    hotWorkflows: 'Hot Workflows',
    formStatus: 'Form Status',
    systemHealth: 'System Health',
    messageSuccessRate: 'Message Success Rate',
    workflowSuccessRate: 'Workflow Success Rate',
    avgExecutionTime: 'Avg Execution Time',
    pendingTasksCount: 'Pending Tasks',
    seconds: 'sec',
    past7Days: 'Past 7 Days',
    executionCount: 'Execution Count',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected'
  },

  // Pending Tasks Page
  pendingTasks: {
    // Expanded row sections (Form fields / Process Data)
    expandedSection: {
      formFields: 'Form Fields',
      processVariables: 'Process Data'
    },
    title: 'Pending Tasks',
    description: 'Handle form applications awaiting approval',
    totalPending: 'Total Pending',
    pendingApproval: 'Pending Approval',
    overdueItems: 'Overdue Items',
    urgentItems: 'Urgent Items',
    formName: 'Form Name',
    processInstanceId: 'Process instance ID',
    status: 'Status',
    fillType: 'Fill Type',
    priority: 'Priority',
    applicant: 'Applicant',
    applicationTime: 'Application Time',
    dueDate: 'Due Date',
    action: 'Action',
    approve: 'Approve',
    reject: 'Reject',
    approveTooltip: 'Approve',
    rejectTooltip: 'Reject',
    submitForm: 'Submit Form',
    submitFormTooltip: 'Submit Form',
    submitFormMessage: 'Form submission feature is under development...',
    formOpenedForSubmission: 'Form opened in new tab, please fill and submit',
    resubmitForm: 'Resubmit',
    searchPlaceholder: 'Search form name, applicant...',
    priorityPlaceholder: 'Priority',
    all: 'All',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
    manualFill: 'Manual Fill',
    aiFill: 'AI Fill',
    dataFill: 'Data Fill',
    aiDataFill: 'AI/Data Fill',
    inhouseForm: 'In-house Form',
    inhouseFormDescription: 'Authenticated phone numbers or login operations<br/>e.g.: Internal system operations',
    publicForm: 'Public Form',
    publicFormDescription: 'General phone numbers, no login required<br/>e.g.: Promotions, feedback collection',
    manualPendingForms: 'Pending Response Forms',
    manualRespondedForms: 'Responded Forms',
    noManualPendingForms: 'No pending manual fill forms',
    noManualRespondedForms: 'No responded manual fill forms',
    overdue: 'Overdue',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    submitted: 'Submitted',
    changeToApproved: 'Change to Approved',
    changeToRejected: 'Change to Rejected',
    statusChangeConfirmation: 'Status Change Confirmation',
    statusChangeWarning: 'Status Change Warning',
    currentStatus: 'Current Status',
    decidedBy: 'Decided By',
    decidedAt: 'Decided At',
    changeTo: 'Change To',
    confirmStatusChange: 'Confirm Change',
    confirmStatusChangeQuestion: 'Are you sure you want to change the status of this form?',
    noPendingTasks: 'No pending tasks',
    approveApplication: 'Approve Application',
    rejectApplication: 'Reject Application',
    confirmApprove: 'Confirm Approve',
    confirmReject: 'Confirm Reject',
    cancel: 'Cancel',
    confirmApproval: 'Confirm Approval',
    confirmRejection: 'Confirm Rejection',
    applicantLabel: 'Applicant:',
    applicationTimeLabel: 'Application Time:',
    approvalNote: 'Approval Note',
    approvalNotePlaceholder: 'Please enter approval note (optional)',
    rejectionReason: 'Rejection Reason',
    rejectionReasonPlaceholder: 'Please enter rejection reason (required)',
    rejectionReasonRequired: 'Please enter rejection reason',
    operationSuccess: 'Operation successful',
    operationFailed: 'Operation failed',
    approveSuccess: 'Approval successful',
    rejectSuccess: 'Rejection successful',
    approveFailed: 'Approval failed',
    rejectFailed: 'Rejection failed',
    save: 'Save',
    saveSuccess: 'Form content saved',
    saveFailed: 'Save failed',
    loadPendingTasksFailed: 'Failed to load pending tasks',
    loadStatisticsFailed: 'Failed to load statistics',
    refresh: 'Refresh',
    clearFilters: 'Clear',
    exportExcel: 'Export Excel',
    exportDisabledTip: 'Please select a form definition (process definition) in the dropdown first to export Excel',
    noDataToExport: 'No data to export',
    exportSuccess: 'Export completed',
    exportFailed: 'Export failed',
    definitionPlaceholder: 'Select definition',
    workflowInstanceId: 'Workflow instance ID',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    approvalAt: 'Approval At',
    pendingTasksList: 'Pending Forms',
    pendingForms: 'Pending Forms',
    approvedForms: 'Approved Forms',
    rejectedForms: 'Rejected Forms',
    approvedBy: 'Approved',
    rejectedBy: 'Rejected',
    noApprovedForms: 'No approved forms',
    noRejectedForms: 'No rejected forms',
    pageRange: 'Items {start}-{end} of {total}',
    itemsPerPage: '/ page',
    jumpTo: 'Go to',
    page: 'Page',
    confirm: 'OK',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    viewFormInstance: 'View Form Instance',
    loadingFormInstance: 'Loading form instance...',
    close: 'Close',
    openInNewTab: 'Open in new tab',
    noFormData: 'No form data',
    userMessage: 'User Message',
    
    // Batch processing translations
    select: 'Select',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    selectedItems: '{count} items selected',
    clearSelection: 'Clear Selection',
    batchApprove: 'Batch Approve',
    batchReject: 'Batch Reject',
    batchChangeToApproved: 'Batch Change to Approved',
    batchChangeToRejected: 'Batch Change to Rejected',
    batchOperationConfirmation: 'Batch Operation Confirmation',
    batchOperationType: 'Operation Type',
    selectedFormsCount: 'Selected Forms Count',
    formsList: 'Forms List',
    confirmBatchOperation: 'Confirm to execute this batch operation?',
    operationNote: 'Operation Note',
    operationNotePlaceholder: 'Please enter operation reason...',
    confirmExecute: 'Confirm Execute',
    batchOperationSuccess: 'Batch operation successful',
    batchOperationFailed: 'Batch operation failed',
    batchApprovalSuccess: 'Successfully approved {count} forms',
    batchRejectionSuccess: 'Successfully rejected {count} forms',
    batchStatusChangeSuccess: 'Successfully changed {count} forms status'
  },
  
  // Unsigned management
  unsigned: {
    title: 'Delivered Not Signed',
    totalRecords: 'Total Records',
    totalProcessed: 'Total Processed',
    currentPageRecords: 'Current Page Records',
    search: 'Search',
    searchPlaceholder: 'Search invoice number, customer name, phone...',
    filterAll: 'All',
    filterUnconfirmed: 'Unconfirmed',
    filterConfirmed: 'Confirmed',
    confirm: 'Confirm',
    confirmSelected: 'Confirm Selected',
    confirmSuccess: 'Confirmation successful',
    confirmFailed: 'Confirmation failed',
    downloadPdf: 'Download PDF',
    previewImage: 'Preview Image',
    customerTel: 'Customer Phone',
    invoiceNo: 'Invoice Number',
    customerName: 'Customer Name',
    orderLines: 'Order Details',
    noData: 'No data available',
    loading: 'Loading...',
    pageSize: 'Records per page',
    manualReview: 'Manual Review by Customer Service',
    customerSignedPending: 'Signed Pending Confirmation',
    customerSignedConfirmed: 'Confirmed',
    customerNo: 'Customer Number',
    receiptDate: 'Receipt Date',
    uploadDate: 'Upload Date',
    remarks: 'Remarks',
    status: 'Status',
    action: 'Action',
    confirmed: 'Confirmed',
    unconfirmed: 'Unconfirmed',
  },
  
  // Workflow
  workflow: {
    title: 'Workflow Management',
    add: 'Add Workflow',
    name: 'Workflow Name',
    createdBy: 'Created By',
    createdAt: 'Created Date',
    updatedAt: 'Last Modified',
    status: 'Status',
    action: 'Action',
    design: 'Design',
    copy: 'Copy',
    delete: 'Delete',
    confirmDeleteTitle: 'Are you sure you want to delete this workflow?',
    confirmDeleteContent: 'Workflow Name: {name}',
    confirmDeleteOk: 'Delete',
    confirmDeleteCancel: 'Cancel',
    copySuccess: 'Workflow copied',
    deleteSuccess: 'Workflow deleted',
    deleteFailed: 'Delete failed',
    copyFailed: 'Copy failed',
    save: 'Save Workflow',
    saveSuccess: 'Workflow saved!',
    saveFailed: 'Save failed',
    nameRequired: 'Please enter workflow name',
    mustHaveStartEnd: 'Workflow must contain Start and End nodes',
    mustHaveEdge: 'Please create node connections',
    description: 'Description (optional)',
    back: 'Back to List',
    new: 'New Workflow',
    edit: 'Edit Workflow',
    searchPlaceholder: 'Search workflow name, creator...',
    search: 'Search',
    nodeTypes: 'Node Types',
    to: 'Recipient',
    message: 'Message Content',
    timeout: 'Timeout',
    sql: 'SQL Query',
    apiUrl: 'API URL',
    formName: 'Form Name',
    result: 'Result',
    approved: 'Approved',
    rejected: 'Rejected',
    deleteEdge: 'Delete Connection',
    startNodeCannotEdit: 'Start node cannot be edited'
  },
  
  // Common
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    configure: 'Configure',
    configured: 'Configured',
    notConfigured: 'Not configured',
    all: 'All',
    action: 'Action',
    refresh: 'Refresh',
    clear: 'Clear',
    submit: 'Submit',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    close: 'Close',
    open: 'Open',
    on: 'On',
    off: 'Off',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    passwordPolicy: {
      generatePassword: 'Generate',
      generateSuccess: 'Password generated',
      generateFailed: 'Failed to generate password',
    },
    required: 'Required',
    minLength: 'at least {min} characters',
    pageRange: '{start}-{end} of {total} items',
    status: 'Status',
    actions: 'Actions',
    every: 'Every',
    minutes: 'Minutes',
    active: 'Active',
    inactive: 'Inactive',
    paused: 'Paused',
    activate: 'Activate',
    deactivate: 'Deactivate',
    systemDefault: 'System Default',
    editingCompany: 'Editing Company',
    export: 'Export',
    exportExcel: 'Export Excel',
    exportPdf: 'Export PDF',
    formName: 'Form Name',
    instanceName: 'Instance Name',
    fillType: 'Fill Type',
    createdAt: 'Created At',
    createdDate: 'Created Date',
    createdBy: 'Created By',
    updatedAt: 'Updated At',
    updatedDate: 'Updated Date',
    updatedBy: 'Updated By',
    recipientName: 'Recipient Name',
    recipientWhatsApp: 'Recipient WhatsApp',
    userMessage: 'User Message',
    dueDate: 'Due Date',
    startDate: 'Start Date',
    endDate: 'End Date',
    today: 'Today',
    last7Days: 'Last 7 Days',
    selectMonth: 'Select Month',
    minutes: 'minutes',
    pending: 'Pending',
    submitted: 'Submitted',
    approved: 'Approved',
    rejected: 'Rejected',
    aiFill: 'AI Fill',
    dataFill: 'Data Fill',
    manualFill: 'Manual Fill',
    unauthorized: 'Unauthorized',
    reset: 'Reset'
  },
  
  // Recipient Selector
  recipientSelector: {
    title: 'Select Recipients',
    placeholder: 'Select recipients',
    clearAll: 'Clear All',
    confirmSelection: 'Confirm Selection',
    clear: 'Clear',
    
    // Tabs
    users: 'Users',
    contacts: 'Contacts',
    processVariables: 'Process Data',
    initiators: 'Process Initiator',
    
    // Search placeholders
    searchUsers: 'Search users...',
    searchContacts: 'Search contacts...',
    
    // Selected recipients display
    selectedRecipients: 'Selected Recipients',
    usersCount: '{count} users',
    contactsCount: '{count} contacts',
    groupsCount: '{count} groups',
    hashtagsCount: '{count} tags',
    variablesCount: '{count} variables',
    processInitiator: 'Process Initiator',
    
    // Users tab
    usersTab: {
      title: 'Users',
      noUsersFound: 'No users found',
      userPhone: 'Phone: {phone}',
      userEmail: 'Email: {email}'
    },
    
    // Contacts tab
    contactsTab: {
      title: 'Contacts',
      broadcastGroups: 'Broadcast Groups',
      noGroupsData: 'No broadcast group data available',
      hashtags: 'Tags',
      noHashtagsData: 'No tags data available',
      contactList: 'Contact List',
      totalContacts: 'Total {count} contacts',
      noContactsFound: 'No contacts found',
      whatsAppNumber: 'WhatsApp: {number}',
      email: 'Email: {email}',
      pageRange: 'Page {start}-{end} of {total} items'
    },
    
    // Process Data tab
    processVariablesTab: {
      title: 'Process Data',
      description: 'Select Process Data, the system will automatically replace with actual values during execution (recommended to select variables containing phone numbers)',
      noVariablesFound: 'No Process Data found',
      value: 'Value: {value}',
      dataType: 'Type: {type}',
      instructions: {
        title: 'Instructions',
        items: [
          'Display all types of Process Data',
          'Recommend selecting variables containing phone numbers',
          'Selected variables will be saved in ${variableName} format',
          'System will automatically replace with actual values during workflow execution',
          'Suitable for integrating external systems (such as ERP)'
        ]
      }
    },
    
    // Process Initiator tab
    initiatorsTab: {
      title: 'Process Initiator',
      useInitiator: 'Use Process Initiator',
      description: 'When checked, the system will automatically use the user who initiated this workflow instance as the recipient during execution',
      instructions: {
        title: 'Instructions',
        items: [
          'This option will be automatically replaced with the actual process initiator during workflow execution',
          'Suitable for scenarios that need to send messages to or wait for replies from the workflow initiator',
          'System will automatically obtain initiator information from the InitiatedBy field in the workflow_executions table'
        ]
      }
    },
    
    // Tags and labels
    tagLabels: {
      user: 'User',
      contact: 'Contact',
      group: 'Group',
      hashtag: 'Tag',
      variable: 'Variable',
      initiator: 'Process Initiator'
    },
    
    // Fallback texts
    fallbackTexts: {
      unknownGroup: 'Unknown Group',
      unknownTag: 'Unknown Tag',
      unknownVariable: 'Unknown Variable',
      autoReplace: 'Auto-replace at runtime',
      noBroadcastGroupsData: 'No broadcast group data available',
      noTagsData: 'No tags data available',
      contactList: 'Contact List',
      broadcastGroups: 'Broadcast Groups',
      tags: 'Tags',
      processVariables: 'Process Data',
      selectProcessVariables: 'Select Process Data, the system will automatically replace with actual values during execution (recommended to select variables containing phone numbers)',
      recommendSelectPhoneVariables: 'Recommend selecting variables containing phone numbers',
      saveInFormat: 'Selected variables will be saved in ${variableName} format',
      autoReplaceAtRuntime: 'System will automatically replace with actual values during workflow execution',
      suitableForERP: 'Suitable for integrating external systems (such as ERP)',
      autoReplaceWithInitiator: 'This option will be automatically replaced with the actual process initiator during workflow execution',
      suitableForInitiator: 'Suitable for scenarios that need to send messages to or wait for replies from the workflow initiator',
      autoGetFromWorkflow: 'System will automatically obtain initiator information from the InitiatedBy field in the workflow_executions table',
      instructions: 'Instructions',
      displayAllVariables: 'Display all types of Process Data'
    }
  },

  
  // Language switching
  language: {
    zhTC: '繁體中文',
    zhSC: '简体中文', 
    en: 'English',
    language: 'Language'
  },
  
  // User Preferences
  preferences: {
    title: 'My Preferences',
    basicInfo: 'Basic Information',
    usageBillingTab: 'Usage billing',
    avatar: 'Avatar',
    uploadAvatar: 'Upload Avatar',
    account: 'Account',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    language: 'Language',
    timezone: 'Timezone',
    selectTimezone: 'Please select timezone',
    password: 'Password',
    passwordPlaceholder: 'Enter new password if you need to change',
    isActive: 'Active',
    isOwner: 'Main Account',
    save: 'Save',
    cancel: 'Cancel',
    updateSuccess: 'Profile updated successfully',
    updateFailed: 'Failed to update profile',
    avatarUploadSuccess: 'Avatar uploaded successfully',
    avatarUploadFailed: 'Avatar upload failed'
  },
  
  // Company user management
  companyUserAdmin: {
    companyName: "Company Name",
    email: "Email",
    address: "Address",
    phone: "Phone",
    website: "Website",
    createdAt: "Created Time",
    updatedAt: "Updated Time",
    action: "Action",
    edit: "Edit",
    delete: "Delete",
    name: "Name",
    account: "Account",
    isActive: "Active",
    isOwner: "Main Account",
    active: "Active",
    inactive: "Inactive",
    owner: "Main",
    addUser: "Add User",
    searchUser: "Search account, Email, name...",
    batchEnable: "Batch Enable",
    batchDisable: "Batch Disable",
    timezone: "Timezone",
    selectTimezone: "Please select timezone",
    language: "Language",
    addCompany: "Add Company",
    platformWabaBadge: "Platform WABA",
    platformWabaTooltip: "This company is the platform WABA: its WhatsApp / WABA settings are used as the copy source when provisioning new companies.",
    roles: "Roles",
    selectRoles: "Select Roles",
    roleManagement: "Role Management",
    tenantAdmin: "Tenant Admin",
    companyAdmin: "Company Admin",
    designer: "Designer",
    approver: "Approver",
    addRole: "Add Role",
    removeRole: "Remove Role",
    noRoles: "No Roles",
    currentRoles: "Current Roles",
    selectedRoles: "Selected Roles",
    userInfo: "User Information",
    avatar: "Avatar",
    status: "Status",
    isMainAccount: "Is Main Account",
    enabled: "Enabled",
    disabled: "Disabled",
    yes: "Yes",
    no: "No",
    editUser: "Edit User",
    mainAccountNote: "(In SaaS version, main account refers to payment account)",
    password: "Password",
    passwordPlaceholder: "Enter new password to change (leave empty to keep current)",
    confirmPassword: "Confirm Password",
    confirmPasswordPlaceholder: "Please enter password again",
    confirmPasswordRequired: "Please enter password again to confirm",
    passwordMismatch: "Passwords do not match",
    passwordMinLength: "Password must be at least 6 characters",
    company: "Company",
    selectCompany: "Select Company",
    companyRequired: "Please select a company",
    phoneDuplicate: "Phone number already exists, please use another number",
    emailDuplicate: "Email already exists, please use another email",
    userCreateSuccess: "User information created successfully",
    userUpdateSuccess: "User information updated successfully",
    roleUpdateSuccess: "Role updated successfully",
    roleUpdateFailed: "Role update failed",
    userCreateSuccessButRoleFailed: "User created successfully, but role setup failed. Please set it manually later"
  },
  
  // Company edit
  companyEdit: {
    uploadLogo: "Click to upload company avatar",
    basicInfo: "Company Basic Information",
    companyId: "Company ID",
    copyCompanyId: "Copy company ID",
    companyIdCopied: "Company ID copied to clipboard",
    name: "Company Name",
    nameLocalesHint: "Primary field syncs to name_locales.en; TC/SC optional.",
    nameLocaleZhTc: "Company name (Traditional Chinese)",
    nameLocaleZhSc: "Company name (Simplified Chinese)",
    email: "Email",
    address: "Address",
    phone: "Phone",
    website: "Website",
    createdAt: "Created Time",
    updatedAt: "Updated Time",
    timezone: "Timezone",
    timezonePlaceholder: "Select timezone",
    whatsappSetting: "WhatsApp Settings",
    waApiKey: "wA_API_Key",
    waPhoneNoId: "wA_PhoneNo_ID",
    waVerifyToken: "wA_VerifyToken",
    back: "Back",
    save: "Save",
    cancel: "Cancel",
    saveSuccess: "Save successful",
    saveFailed: "Save failed",
    uploadSuccess: "Upload successful",
    uploadFailed: "Upload failed",
    // WhatsApp API Settings
    waBusinessAccountId: "WhatsApp Business Account ID",
    waBusinessAccountIdTooltip: "Used for managing Meta official templates",
    waBusinessAccountIdSuffix: "Template Management",
    waMetaBusinessId: "Meta Business ID (Business Asset Management Portfolio)",
    waMetaBusinessIdPlaceholder: "e.g.: 1420491162404755",
    waMetaBusinessIdTooltip: "Used for catalog management: create catalog, list all catalogs under Business. View in Meta Business Suite > Business Settings > Business Info",
    waMetaBusinessIdSuffix: "Catalog Management",
    phoneNoIdPlaceholder: "e.g.: 690383010830837",
    businessAccountIdPlaceholder: "e.g.: 1102096678464098",
    configWarningTitle: "⚠️ Important Configuration Reminder",
    configWarningDescription: "Please ensure Phone Number ID belongs to the WABA specified by Business Account ID:",
    configWarningPhoneIdUse: "• Phone Number ID is used for sending messages (must belong to the correct WABA)",
    configWarningBusinessIdUse: "• Business Account ID is used for querying template list",
    configWarningMismatchTitle: "⚠️ If these two IDs do not match, it will lead to:",
    configWarningMismatchItem1: "Can see template list, but cannot find template when sending messages",
    configWarningMismatchItem2: "Templates belong to different WABAs and cannot be used",
    configWarningSolution: "💡 Solution: In Meta Business Suite, confirm which WABA the Phone Number ID belongs to, then update Business Account ID to that WABA's ID",
    validateTokenButton: "Validate Token Permissions",
    validateTokenHint: "Click validate after entering API Key and Business Account ID",
    validateTokenLoading: "Validating Token permissions...",
    subscribeWebhookButton: "Subscribe Webhook",
    subscribeWebhookLoading: "Subscribing webhook...",
    subscribeWebhookSuccessTitle: "Webhook Subscription",
    subscribeWebhookSuccess: "Webhook subscription successful. Meta notifications will be sent to your callback URL.",
    subscribeWebhookErrorTitle: "Webhook Subscription Failed",
    subscribeWebhookError: "Unable to subscribe webhook, please verify Access Token, Business Account ID, and permissions.",
    validateTokenError: "❌ Validation Failed",
    validateTokenFailed: "❌ Permission Check Failed",
    validateTokenErrorMsg: "Unable to validate Token permissions, please check your settings",
    validateTokenCheckResult: "🔐 Token Permission Check Result",
    tokenStatus: "Token Status:",
    tokenValid: "✅ Valid",
    tokenInvalid: "❌ Invalid",
    companyLabel: "Company:",
    capabilitiesTitle: "Capabilities:",
    sendMessageLabel: "Send Messages:",
    available: "✅ Available",
    unavailable: "❌ Unavailable",
    receiveWebhookLabel: "Receive Webhooks:",
    manageTemplatesLabel: "Manage Meta Templates:",
    createFlowLabel: "Create WhatsApp Flow:",
    permissionsTitle: "Detailed Permissions:",
    recommendationsTitle: "Recommendations:",
    permissionCheckFailed: "Unable to validate Token permissions, please check your settings",
    validateTokenPermissionError: "Error occurred while checking Token permissions, please try again later",
    validateTokenCheckError: "Error occurred while checking Token permissions, please try again later",
    apiKeyRequired: "Please enter WA API Key (Access Token) first",
    businessAccountIdRequired: "Please enter WhatsApp Business Account ID first",
    webhookToken: "Webhook Token",
    webhookTokenPlaceholder: "Auto-generated unique Token",
    regenerateToken: "Regenerate",
    tokenGenerated: "New Token generated, URL updated",
    webhookUrl: "Meta Webhook URL",
    webhookUrlPlaceholder: "e.g.: https://your-domain.com/api/MetaWebhook/your-token",
    copyWebhookUrl: "Copy",
    webhookUrlCopied: "Webhook URL copied to clipboard",
    generateTokenFirst: "Please generate Webhook Token first",
    // WhatsApp Menu Settings
    chatbotMenuConfig: "Chatbot Menu Config",
    apiSettings: "API Settings",
    menuConfigHint: "These settings are used to customize WhatsApp chatbot menu text. Leave empty to use system defaults.",
    welcomeMessage: "Welcome Message",
    welcomeMessageTooltip: "Welcome text displayed when users first interact",
    noFunctionMessage: "No Function Message",
    noFunctionMessageTooltip: "Message displayed when no workflows are available",
    menuTitle: "Menu Title",
    menuTitleTooltip: "Title of the WhatsApp list menu",
    menuButton: "View Button",
    menuButtonTooltip: "Text for the view options button",
    menuFooter: "Menu Footer",
    menuFooterTooltip: "Footer text for WhatsApp list menu",
    sectionTitle: "Section Title",
    sectionTitleTooltip: "Category title for service options",
    defaultOptionDescription: "Default Option Description",
    defaultOptionDescriptionTooltip: "Default text when workflow has no description",
    inputErrorMessage: "Input Error Message",
    inputErrorMessageTooltip: "Message when user input format is incorrect",
    fallbackMessage: "Fallback Message",
    fallbackMessageTooltip: "Fallback message when interactive messages fail",
    systemErrorMessage: "System Error Message",
    systemErrorMessageTooltip: "General system error message",
    // Placeholders
    welcomeMessagePlaceholder: "Welcome to our service!\n\nPlease select the feature you need:",
    noFunctionMessagePlaceholder: "Welcome to our service!\n\nNo features available at the moment, please contact the administrator.",
    menuTitlePlaceholder: "Service Menu",
    menuButtonPlaceholder: "View Options",
    menuFooterPlaceholder: "Please select the service you need",
    sectionTitlePlaceholder: "Service Options",
    defaultOptionDescriptionPlaceholder: "Click to select this service",
    inputErrorMessagePlaceholder: "Input is incorrect, please re-enter.",
    fallbackMessagePlaceholder: "\n\nReply with a number to select a feature, or type \"Menu\" to show the menu again.",
    systemErrorMessagePlaceholder: "System error: Unable to find QR Code node configuration.",
    delete: "Delete company",
    deleteTenantAdminOnly: "Only Tenant_Admin can delete companies",
    deleteConfirmTitle: "Confirm carefully before deleting company",
    deleteConfirmOk: "I have backed up and confirm deletion",
    deleteConfirmCancel: "Cancel",
    deleteBackupWarningTitle: "This action may permanently delete or affect related data for this company",
    deleteBackupWarningDesc: "Please complete database and file backups before deleting, and confirm that this company's workflows, forms, commerce, and WhatsApp records are no longer needed. Some tables may still block deletion due to foreign key constraints; the system will report the error.",
    deleteImpactTitle: "Potentially affected data scope:",
    deleteImpactUsers: "Company users, roles, and permission settings",
    deleteImpactWorkflows: "Workflow definitions, execution records, and step records",
    deleteImpactForms: "E-forms, form instances, approvals, reports, and document outputs",
    deleteImpactDatasets: "DataSets, records, import schedules, and processed records",
    deleteImpactContacts: "Contacts, broadcast groups, hashtags, calendar events, and related resources",
    deleteImpactWhatsapp: "WhatsApp templates, messages, webhook / Flow related settings",
    deleteImpactCommerce: "Commerce customers, products, collections, orders, price cards, and WPA permission data",
    deleteImpactAiBilling: "AI employees, API Provider settings, usage billing, and Wix provisioning records",
    deleteImpactKnowledge: "Knowledge base categories, documents, and versions",
    deleteTypeCompanyName: "Enter company name \"{name}\" to confirm deletion.",
    deleteConfirmTextMismatch: "Confirmation text is incorrect; deletion was cancelled",
    deleteFailed: "Delete failed",
    deleteSuccess: "Deleted",
    // Ice Breakers / Commands
    iceBreakersTab: 'Ice Breakers',
    commandsTab: 'Commands',
    iceBreakersDesc: 'Ice breakers are common questions users can easily ask you. They appear as tappable prompts at the start of a new conversation.',
    commandsDesc: 'Commands are special keywords that instruct the WhatsApp Bot to take an action. Each command must start with \"/\".',
    convNotSaved: 'Please save the company first before configuring conversation components',
    iceBreakersLabel: 'Ice Breaker {index}',
    iceBreakersInputPlaceholder: 'Enter ice breaker question (max 80 chars, no emojis)',
    addIceBreaker: 'Add Ice Breaker',
    saveIceBreakersSuccess: 'Ice breakers saved to WhatsApp',
    cmdNameLabel: 'Command',
    cmdNamePlaceholder: 'e.g. /imagine, /generate',
    cmdDescLabel: 'Description',
    cmdDescPlaceholder: 'Add a description for this command (e.g. Generate an image)',
    addCommand: 'Add Command',
    saveCommandsSuccess: 'Commands saved to WhatsApp',
    convLoadFailed: 'Failed to load conversation components',
    convSaveFailed: 'Save failed',
  },

  commerceCustomers: {
    title: 'Customer Master',
    addCustomer: 'Add Customer',
    editCustomer: 'Edit Customer',
    customerNo: 'Customer No.',
    branchNo: 'Branch No.',
    nameCn: 'Chinese Name',
    nameEn: 'English Name',
    nameCn1: 'Chinese Name 1',
    nameCn2: 'Chinese Name 2',
    nameCn3: 'Chinese Name 3',
    nameEn1: 'English Name 1',
    nameEn2: 'English Name 2',
    nameEn3: 'English Name 3',
    customerNameCol: 'Customer name (UI language)',
    nameLine: 'Customer Name',
    nameLocaleZhTc: 'Customer name (Traditional Chinese)',
    nameLocaleZhSc: 'Customer name (Simplified Chinese)',
    customerNameLocalesHint: 'Add Traditional / Simplified per line. English uses the fields above (maps to en in JSON).',
    contactName: 'Contact',
    tel: 'Tel',
    fax: 'Fax',
    email: 'Email',
    whatsappNo: 'WhatsApp',
    salesmanName: 'Salesman',
    salesmanCode: 'Salesman code',
    salesmanCodePlaceholder: 'For cross-check with ERP / internal id',
    salesmanWhatsapp: 'Salesman WhatsApp',
    creditLimit: 'Credit limit',
    priceType: 'Price type',
    priceTypePlaceholder: 'Free text',
    paymentTerm: 'Payment Terms',
    paymentTermPlaceholder: 'COD / Net 30 / Net 60 …',
    remark: 'Remark',
    remarkPlaceholder: 'Customer remark',
    customerStatus: 'Customer status',
    statusActive: 'Active',
    statusSuspended: 'Suspended',
    statusPending: 'Pending',
    tabBasic: 'Basic Info',
    tabAddress: 'Address',
    tabDeliverySchedule: 'Delivery Schedule',
    tabSalesman: 'Salesman',
    billingAddressCn: 'Billing Address (CN)',
    billingAddressEn: 'Billing Address (EN)',
    deliveryAddressCn: 'Delivery Address (CN)',
    deliveryAddressEn: 'Delivery Address (EN)',
    addressLine1: 'Address Line 1',
    addressLine2: 'Address Line 2',
    addressLine3: 'Address Line 3',
    deliveryMon: 'Mon',
    deliveryTue: 'Tue',
    deliveryWed: 'Wed',
    deliveryThu: 'Thu',
    deliveryFri: 'Fri',
    deliverySat: 'Sat',
    deliverySun: 'Sun',
    deliveryScheduleHolidayTag: 'PH',
    deliveryHoliday: 'Deliver on Public Holidays',
    importExcel: 'Import Excel',
    importPreview: 'Import Preview',
    confirmImport: 'Confirm Import',
    importSuccess: 'Import Successful',
    search: 'Search customers...',
    deleteConfirm: 'Are you sure to delete this customer?',
    created: 'Created',
    updated: 'Updated',
    noData: 'No customer data',
    subtitle: 'Manage customer master, addresses and delivery schedule',
    loadFailed: 'Failed to load customers',
    saved: 'Customer updated',
    saveFailed: 'Save failed',
    deleted: 'Customer deleted',
    deleteFailed: 'Delete failed',
    importParseFailed: 'Failed to parse import file',
    importFailed: 'Import failed',
    whatsapp: 'WhatsApp',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    confirmDelete: 'Are you sure to delete this customer?',
    required: 'Required',
    addressLine: 'Address Line',
    deliveryScheduleHint: 'Please select available delivery days',
    holidayDelivery: 'Deliver on Public Holidays',
    import: 'Import',
    refresh: 'Refresh',
    searchPlaceholder: 'Search customer no / name / contact',
    filterByCompany: 'Filter by company',
    company: 'Company',
    selectCompany: 'Please select company',
    cancel: 'Cancel',
    save: 'Save',
  },

  commercePriceCards: {
    title: 'Price Card Management',
    addPriceCard: 'Add Price Card',
    editPriceCard: 'Edit Price Card',
    customerNo: 'Customer No.',
    branchNo: 'Branch No.',
    itemNo: 'Item No.',
    unitPrice: 'Unit Price',
    showPrice: 'Show Price',
    validFrom: 'Valid From',
    validTo: 'Valid To',
    source: 'Source',
    priceType: 'Price type',
    priceTypePlaceholder: 'Free text',
    importCsv: 'Import CSV',
    importPreview: 'Import Preview',
    confirmImport: 'Confirm Import',
    importSuccess: 'Import Successful',
    deleteConfirm: 'Are you sure to delete this price card?',
    overlapError: 'Date range overlaps with existing price card',
    yes: 'Yes',
    no: 'No',
    noData: 'No price card data',
    description: 'Manage customer-branch-item price cards with validity periods',
    loadFailed: 'Failed to load price cards',
    created: 'Price card created',
    saved: 'Price card updated',
    saveFailed: 'Save failed',
    deleted: 'Price card deleted',
    deleteFailed: 'Delete failed',
    importEmpty: 'No data to import',
    importParseFailed: 'Failed to parse CSV',
    importFailed: 'Import failed',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    confirmDelete: 'Are you sure to delete this price card?',
    refresh: 'Refresh',
    filterCustomerNo: 'Filter customer no',
    filterCustomerName: 'Filter customer name (all locales)',
    filterBranchNo: 'Filter branch no',
    filterItemNo: 'Filter item no',
    filterByCompany: 'Filter by company',
    company: 'Company',
    required: 'Required',
    selectCompany: 'Please select company',
    selectCompanyFirst: 'Please select company first',
    customerPickerTitle: 'Select customer',
    customerPickerSearchPlaceholder: 'Search customer no., branch, name, contact, phone',
    customerPickerLoadFailed: 'Failed to load customers',
    openCustomerList: 'Browse',
    chooseCustomer: 'Select',
    productPickerTitle: 'Select product',
    productPickerSearchPlaceholder: 'Search Content ID, name, description',
    productPickerLoadFailed: 'Failed to load products',
    openProductList: 'Browse',
    chooseProduct: 'Select',
    customerName: 'Customer Name',
    productName: 'Product Name',
    productNameColUiLocale: 'Product name (UI language)',
    productNameList: 'Product name',
    productListPrice: 'List price',
    pickerNameCn: 'Company name (CN)',
    pickerContactName: 'Contact',
    pickerContactTel: 'Phone',
    customerNoPlaceholder: 'Type or pick from list',
    branchNoPlaceholder: 'Filled when you pick a customer; editable',
    importPreviewTitle: 'Price Card Import Preview',
    cancel: 'Cancel',
    save: 'Save',
  },

  commerceSalesOrders: {
    title: 'Sales Order Management',
    addOrder: 'New Order',
    editOrder: 'Edit Order',
    orderNo: 'Order No.',
    orderDate: 'Order Date',
    customerNo: 'Customer No.',
    branchNo: 'Branch No.',
    companyNameCn: 'Company Name (CN)',
    companyNameEn: 'Company Name (EN)',
    billingAddress: 'Billing Address',
    deliveryAddress: 'Delivery Address',
    deliveryDate: 'Delivery Date',
    contactName: 'Contact',
    contactTel: 'Contact Tel',
    salesmanName: 'Salesman',
    purchaseOrderNo: 'PO No.',
    paymentTerm: 'Payment Terms',
    paymentTermPlaceholder: 'COD / Net 30 / Net 60 …',
    remark: 'Remark',
    currency: 'Currency',
    totalAmount: 'Total Amount',
    status: 'Status',
    thirdPartyReadStatus: '3rd-party read',
    thirdPartyReadPending: 'Pending',
    thirdPartyReadDone: 'Imported',
    source: 'Source',
    statusPending: 'Pending',
    statusConfirmed: 'Confirmed',
    statusProcessing: 'Processing',
    statusCompleted: 'Completed',
    statusCancelled: 'Cancelled',
    sourceManual: 'Manual',
    sourceWhatsapp: 'WhatsApp',
    confirm: 'Confirm',
    complete: 'Complete',
    cancel: 'Cancel',
    customerInfo: 'Customer Info',
    anonymousOrder: 'Anonymous WhatsApp Order',
    waId: 'WhatsApp ID',
    remark: 'Remark',
    deliverySchedule: 'Delivery Schedule',
    orderDetails: 'Order Details',
    seq: 'Seq',
    itemNo: 'Item No.',
    productName: 'Product Name',
    unitPrice: 'Unit Price',
    quantity: 'Qty',
    unit: 'Unit',
    amount: 'Amount',
    addLine: 'Add Line',
    selectCustomer: 'Select Customer',
    search: 'Search orders...',
    deleteConfirm: 'Are you sure to delete this order?',
    noData: 'No order data',
    allStatus: 'All Status',
    deliveryMon: 'Mon',
    deliveryTue: 'Tue',
    deliveryWed: 'Wed',
    deliveryThu: 'Thu',
    deliveryFri: 'Fri',
    deliverySat: 'Sat',
    deliverySun: 'Sun',
    deliveryHoliday: 'Public Holiday',
    subtitle: 'Manage sales order header and details',
    loadFailed: 'Failed to load orders',
    loadDetailFailed: 'Failed to load order details',
    customerRequired: 'Please select a customer first',
    created: 'Order created',
    saved: 'Order updated',
    saveFailed: 'Save failed',
    statusUpdated: 'Status updated',
    statusUpdateFailed: 'Failed to update status',
    deleted: 'Order deleted',
    deleteFailed: 'Delete failed',
    confirmCancel: 'Are you sure to cancel this order?',
    lineRemark: 'Line Remark',
    confirmDeleteLine: 'Are you sure to delete this line?',
    customer: 'Customer',
    companyName: 'Company Name',
    detail: 'Detail',
    actions: 'Actions',
    delete: 'Delete',
    confirmDelete: 'Are you sure to delete this order?',
    refresh: 'Refresh',
    searchPlaceholder: 'Search order no / customer / company',
    filterByStatus: 'Filter by status',
    filterByCompany: 'Filter by company',
    deliveryDateFrom: 'Delivery From',
    deliveryDateTo: 'Delivery To',
    close: 'Close',
    create: 'Create',
    save: 'Save',
    orderDetail: 'Order Detail',
    newOrder: 'New Order',
    selectCustomerPlaceholder: 'Please select customer',
    customerPickerTitle: 'Select customer',
    customerPickerSearchPlaceholder: 'Search by customer no., branch, name, contact, phone',
    customerPickerLoadFailed: 'Failed to load customers',
    openCustomerList: 'Browse',
    clearCustomer: 'Clear',
    chooseCustomer: 'Select',
    selectCompanyFirst: 'Please select company first (tenant admin).',
    searchProductPlaceholder: 'Search or pick product (Content ID)',
    searchMoreProducts: 'Search more…',
    productPickerTitle: 'Search products',
    productPickerSearchPlaceholder: 'Search Content ID, name, description',
    productPickerLoadFailed: 'Failed to load products',
    chooseProduct: 'Select',
    productListPrice: 'List price',
    holidayFlag: 'Public Holiday Delivery',
    purchaseOrderNoPlaceholder: 'Enter PO number',
    remarkPlaceholder: 'Enter remark',
    creditLimit: 'Credit limit',
    customerStatusLabel: 'Customer status',
    customerStatusActive: 'Active',
    customerStatusSuspended: 'Suspended',
    customerStatusPending: 'Pending',
  },

  commerceCatalogAdmin: {
    title: "Meta Catalog Admin (Catalog CRUD)",
    alertInfo: "This page is for users with catalog admin permission (e.g. Tenant_Admin). You can create catalogs, list all catalogs under a Business and link them to the current company WABA; linked catalogs are shown below. To delete or unlink, use Meta Commerce Manager (API does not provide unlink/delete).",
    alertMetaPermission: "Meta Catalog API permissions",
    alertMetaPermissionDesc: "Creating and listing Business catalogs requires the Meta Access Token to have business_management and catalog_management. If you see \"Missing Permission\" or \"Requires business_management permission\", add these permissions in the Meta App Dashboard and refresh the company WA API Key (Access Token).",
    cardCreate: "1. Create new catalog",
    metaBusinessId: "Meta Business ID",
    catalogName: "Catalog name",
    catalogNamePlaceholder: "e.g. My product catalog",
    required: "Required",
    createCatalog: "Create catalog",
    metaBusinessIdHint: "Meta Business ID: Business Manager > Business Settings > Accounts.",
    cardOwned: "2. All catalogs under Business (optional link to WABA)",
    inputMetaBusinessId: "Enter Meta Business ID",
    loadCatalogs: "Load catalogs",
    catalogId: "Catalog ID",
    name: "Name",
    action: "Action",
    linkToWaba: "Link to WABA",
    emptyOwned: "Enter Business ID and click \"Load catalogs\", or create a catalog above first.",
    cardLinked: "3. Catalogs linked to current company WABA",
    reload: "Reload",
    emptyLinked: "No linked catalogs. For test WABAs, Meta may not expose catalog API; create and link catalogs in Meta Business first.",
    noPermission: "No catalog admin permission",
    loadCatalogsFailed: "Failed to load catalogs",
    catalogCreated: "Catalog created",
    createFailed: "Create failed",
    catalogIdEmpty: "Catalog ID is empty",
    linkSuccess: "Catalog linked to WABA",
    linkFailed: "Link failed",
    wabaMaxOneCatalog: "This WABA already has a catalog linked. Meta allows only one product catalog per WhatsApp Business Account. To link a different catalog, unlink the current one in Meta Commerce Manager first.",
    unlinkHint: "To unlink a catalog, use Meta Commerce Manager (public API does not support unlink).",
    openMetaCommerceManager: "Open Meta Commerce Manager",
    unlinkAction: "Go to Meta to unlink",
    pleaseEnterMetaBusinessId: "Please enter Meta Business ID first",
    loadedCount: "Loaded {count} catalog(s)"
  },
  commerceCollections: {
    title: "Commerce / Collections",
    description: "Manage product collections and associate products with collections.",
    refresh: "Refresh",
    addCollection: "Add collection",
    name: "Name",
    nameColUiLocale: "Collection name (UI language)",
    company: "Company",
    phoneNumberId: "Phone number ID",
    filterByCompany: "Filter by company",
    selectCompany: "Select company",
    externalKey: "External Key",
    metaProductSet: "Meta Product Set",
    itemCount: "Items",
    actions: "Actions",
    edit: "Edit",
    linkProducts: "Link products",
    sync: "Upload to Meta",
    delete: "Delete",
    confirmDelete: "Delete this collection?",
    editCollection: "Edit collection",
    addCollectionModal: "Add collection",
    collectionName: "Collection name (English / primary)",
    nameLocaleZhTc: "Collection name (Traditional Chinese)",
    nameLocaleZhSc: "Collection name (Simplified Chinese)",
    nameLocalesHint: "Primary field syncs to name_locales.en; TC/SC optional.",
    description: "Description",
    externalCollectionKey: "External Collection Key",
    metaProductSetId: "Meta Product Set ID",
    metaCatalogId: "Meta Catalog ID",
    selectCatalog: "Select catalog (from Meta API)",
    noCatalog: "No catalogs; ensure company has WABA and API Key",
    linkedCatalogDefault: "Linked catalog (default; WABA can have only one)",
    noCatalogLinkedHint: "No catalog linked to company WABA yet. Link one in Catalog Admin.",
    loading: "Loading...",
    linkProductsTitle: "Link products: {name}",
    linkProductsHint: "Linked products are listed above (remove as needed). Search and tick products below to add links—already linked items are not shown. Only products under the same phone number (WABA) as this collection are listed.",
    linkProductsLinkedSection: "Linked products",
    linkProductsAvailableSection: "Add links",
    linkProductsLinkedEmpty: "No linked products yet",
    linkProductsRemove: "Remove",
    linkProductsSearchPlaceholder: "Search name, Content ID, description, brand, category…",
    linkProductsSelectedCount: "{n} product(s) selected",
    selectProducts: "Select products for this collection",
    loadFailed: "Failed to load collections",
    saved: "Collection updated",
    created: "Collection created",
    saveFailed: "Save failed",
    deleted: "Collection deleted",
    deleteFailed: "Delete failed",
    syncSuccess: "Added to upload queue (scheduler_executions)",
    syncFailed: "Upload to Meta failed",
    syncEmptyHint: "This collection has no linked products. Add at least one via \"Link products\" before uploading to Meta.",
    selectAtLeastOne: "Please select at least one collection",
    batchUploadToMeta: "Batch upload to Meta",
    batchUploadQueued: "{count}/{total} collection(s) added to upload queue",
    batchUploadQueuedSkipped: "{count}/{total} added to upload queue ({skipped} skipped, no products)",
    loadLinkFailed: "Failed to load linked products",
    linkSaved: "Product links updated",
    linkSaveFailed: "Failed to save links"
  },
  commerceImport: {
    title: "Commerce Data Exchange",
    description: "Import via Excel / Google Sheets / SQL; export sales orders.",
    uploadText: "Click or drag file here",
    uploadHint: "First row should include column headers; select target company above (Tenant_Admin).",
    clear: "Clear",
    startImport: "Start Import",
    loadedRows: "Loaded {count} row(s), missing required: {missing}",
    parseSuccess: "Loaded {count} row(s)",
    parseFailed: "Load failed",
    pleaseUpload: "Please upload a file first",
    companyRequired: "Please select target company for import (required for Tenant_Admin).",
    rowMissing: "Row {row}: missing required field",
    rowMissingName: "Row {row}: missing name",
    rowFailed: "Row {row} failed",
    importDone: "Import complete, {count} row(s)",
    importDoneTitle: "Import Complete",
    importFailed: "Import failed",
    importResult: "Import complete: {success} success, {failed} failed",
    importResultDetail: "Result: {success} success, {failed} failed",
    allSuccess: "All succeeded",
    importTarget: "Import Target",
    company: "Company",
    selectCompany: "Select Company",
    minutes: "min",
    total: "Total",
    created: "Created",
    updated: "Updated",
    added: "Added",
    linked: "Linked",
    skipped: "Skipped",
    errorsCount: "Errors",
    errorDetails: "Error Details",
    exportDone: "Export complete",
    exportFailed: "Export failed",
    exportResult: "Export Result",
    tabImport: "Data Import",
    tabExport: "Sales Order Export",
    domainCommerce: "Commerce Master Data",
    domainWpa: "PWA Permissions",
    targetCustomers: "Customer Master",
    targetPriceCards: "Price List",
    targetProducts: "Product List",
    targetCollections: "Collections",
    targetCollectionLinks: "Collection Links",
    targetWpaGroupMembers: "PWA Group Members",
    targetWpaGroupCustomers: "PWA Group Customers",
    targetWpaContactOverrides: "PWA Contact Overrides",
    targetWpaIdentities: "PWA Login Accounts",
    stepSource: "Select Source",
    stepSourceDesc: "Configure data source",
    stepMapping: "Field Mapping",
    stepMappingDesc: "Preview & map fields",
    stepResult: "Results",
    stepResultDesc: "Import complete",
    sourceExcel: "Excel File",
    sourceGoogle: "Google Sheets",
    sourceSql: "SQL Database",
    exportTitle: "Sales Order Export",
    exportModeSplit: "Header + Detail (split)",
    exportModeFlat: "Flat (combined)",
    exportQuery: "Query & Export",
    exportDownloadCsv: "Download CSV",
    exportAllStatus: "All",
    exportDateRange: "Date Range",
    exportMode: "Mapping Mode",
    scheduleTitle: "Commerce Import Schedule Management",
    scheduleName: "Schedule Name",
    scheduleTarget: "Import Target",
    scheduleFrequency: "Frequency",
    scheduleLastRun: "Last Run",
    scheduleNextRun: "Next Run",
    scheduleEdit: "Edit",
    scheduleEditTitle: "Edit Commerce Import Schedule",
    schedulePause: "Pause",
    scheduleResume: "Resume",
    scheduleActive: "Active",
    schedulePaused: "Paused",
    scheduleResumed: "Resumed",
    scheduleDeleted: "Schedule deleted",
    scheduleDeleteFailed: "Delete failed",
    scheduleDeleteConfirm: "Are you sure you want to delete this schedule?",
    scheduleDelete: "Delete",
    scheduleUpdated: "Schedule updated",
    scheduleUpdateFailed: "Update failed",
    scheduleSaved: "Schedule saved!",
    scheduleSavedDesc: "Your import has been saved as a scheduled task.",
    scheduleSaveFailed: "Failed to save schedule",
    scheduleGotoManage: "Go to Schedule Management",
    scheduleLoadFailed: "Failed to load schedule list",
    schedulePreviewFailed: "Unable to load preview",
    schedulePreviewFailedManual: "Preview load failed; you can edit mapping manually",
    scheduleToggleFailed: "Operation failed",
    scheduleBasicSettings: "Basic Settings",
    scheduleIntervalLabel: "Interval (minutes)",
    scheduleEnable: "Enabled",
    scheduleSourceConfig: "Source Config",
    scheduleFile: "File",
    scheduleSheet: "Sheet",
    scheduleStatus: "Status",
    scheduleActions: "Actions",
    scheduleCompany: "Company",
    scheduleExecuteNow: "Run now",
    scheduleExecuteSuccess: "Import run completed",
    importProgress: "Import progress",
    importRunningBackground: "Import started in the background; watch the progress column",
    importAlreadyRunning: "An import is already running for this schedule",
    scheduleExecuteFailed: "Run failed",
    scheduleTotalCount: "Total {count} schedule(s)",
    reloadPreview: "Reload preview",
    sqlPreviewTotalRows: "Matching rows (count): {count}",
    sqlPreviewTopNote: "Preview uses TOP {n} for speed; the actual import loads all matching rows.",
    sqlPreviewWithCteNote: "This query uses WITH/CTE; TOP was not auto-added. Preview may be slower.",
    sqlLoadingFullForImport: "Loading full SQL result for import…",
    sqlConfigIncomplete: "Please fill server, database, and either table name or custom query",
    googleSpreadsheetId: "Spreadsheet ID",
    googleSpreadsheetIdPlaceholder: "Optional; can be used together with URL after verification",
    noPreviewData: "No preview data",
    freqEveryNMin: "Every {n} min",
    wpaAllowPasswordUpdate: "Allow updating existing account passwords",
    fieldCustomerNo: "Customer No.",
    fieldBranchNo: "Branch No.",
    fieldCustomerName1: "Customer name line 1 (English / default en)",
    fieldCustomerName2: "Customer name line 2 (English / default en)",
    fieldCustomerName3: "Customer name line 3 (English / default en)",
    fieldCustomerNameLine1ZhTc: "Customer name line 1 Traditional (zh-TC)",
    fieldCustomerNameLine1ZhSc: "Customer name line 1 Simplified (zh-SC)",
    fieldCustomerNameLine2ZhTc: "Customer name line 2 Traditional",
    fieldCustomerNameLine2ZhSc: "Customer name line 2 Simplified",
    fieldCustomerNameLine3ZhTc: "Customer name line 3 Traditional",
    fieldCustomerNameLine3ZhSc: "Customer name line 3 Simplified",
    fieldContactName: "Contact Name",
    fieldTel: "Phone",
    fieldEmail: "Email",
    fieldWhatsappNo: "WhatsApp",
    fieldSalesmanName: "Salesman",
    fieldSalesmanCode: "Salesman code (for cross-check)",
    fieldSalesmanWhatsapp: "Salesman phone / WhatsApp",
    fieldCreditLimit: "Credit Limit",
    fieldPriceType: "Price type (price_type)",
    fieldBillingAddressEn1: "Billing address (English) line 1",
    fieldBillingAddressEn2: "Billing address (English) line 2",
    fieldBillingAddressEn3: "Billing address (English) line 3",
    fieldBillingAddressCn1: "Billing address (Chinese) line 1",
    fieldBillingAddressCn2: "Billing address (Chinese) line 2",
    fieldBillingAddressCn3: "Billing address (Chinese) line 3",
    fieldDeliveryAddressEn1: "Shipping address (English) line 1",
    fieldDeliveryAddressEn2: "Shipping address (English) line 2",
    fieldDeliveryAddressEn3: "Shipping address (English) line 3",
    fieldDeliveryAddressCn1: "Shipping address (Chinese) line 1",
    fieldDeliveryAddressCn2: "Shipping address (Chinese) line 2",
    fieldDeliveryAddressCn3: "Shipping address (Chinese) line 3",
    fieldDeliveryDayMon: "Delivery schedule: Monday",
    fieldDeliveryDayTue: "Delivery schedule: Tuesday",
    fieldDeliveryDayWed: "Delivery schedule: Wednesday",
    fieldDeliveryDayThu: "Delivery schedule: Thursday",
    fieldDeliveryDayFri: "Delivery schedule: Friday",
    fieldDeliveryDaySat: "Delivery schedule: Saturday",
    fieldDeliveryDaySun: "Delivery schedule: Sunday",
    fieldDeliveryDayHoliday: "Delivery schedule: Public holiday",
    fieldItemNo: "Item No.",
    fieldUnitPrice: "Unit Price",
    fieldShowPrice: "Show Price",
    fieldValidFrom: "Valid From",
    fieldValidTo: "Valid To",
    fieldSource: "Source",
    fieldName: "Name",
    fieldNameLocaleEn: "Name (JSON en override, optional)",
    fieldNameLocaleZhTc: "Name (Traditional Chinese)",
    fieldNameLocaleZhSc: "Name (Simplified Chinese)",
    fieldRetailerId: "Content ID (Product ID)",
    fieldDescription: "Description",
    fieldLinkUrl: "Link URL",
    fieldImageUrl: "Image URL",
    fieldBrand: "Brand",
    fieldPrice: "Price",
    fieldProductPrice1: "Tier 1 price (price_1)",
    fieldProductValidFrom1: "Tier 1 valid from (valid_from_1)",
    fieldProductValidTo1: "Tier 1 valid to (valid_to_1)",
    fieldProductPrice2: "Tier 2 price (price_2)",
    fieldProductValidFrom2: "Tier 2 valid from (valid_from_2)",
    fieldProductValidTo2: "Tier 2 valid to (valid_to_2)",
    fieldCurrency: "Currency",
    fieldStatus: "Status",
    fieldAvailability: "Availability",
    fieldUnitOfMeasure: "Quantity unit",
    fieldUnitOfMeasureLocaleEn: "Quantity unit (JSON en override, optional)",
    fieldUnitOfMeasureLocaleZhTc: "Quantity unit (Traditional Chinese)",
    fieldUnitOfMeasureLocaleZhSc: "Quantity unit (Simplified Chinese)",
    fieldUnitOfBrokenPackLocaleEn: "Broken-pack unit (JSON en override, optional)",
    fieldUnitOfBrokenPackLocaleZhTc: "Broken-pack unit (Traditional Chinese)",
    fieldUnitOfBrokenPackLocaleZhSc: "Broken-pack unit (Simplified Chinese)",
    fieldQtyPerUnit: "Qty per unit",
    fieldMinOrderQuantity: "MOQ (minimum order quantity)",
    fieldOqm: "Original Quality Manufacturer (OQM)",
    fieldCondition: "Condition",
    fieldColor: "Color",
    fieldSize: "Size",
    fieldGender: "Gender",
    fieldMaterial: "Material",
    fieldPattern: "Pattern",
    fieldCustomLabel0: "Content ID",
    fieldProductionCategory: "Production Category",
    fieldMetaCatalogId: "Meta Catalog ID",
    fieldExternalKey: "External Key",
    fieldCollectionKey: "Collection Key",
    fieldGroupName: "Group Name",
    fieldWhatsappNumber: "WhatsApp Number",
    fieldRoleKey: "Role Key",
    fieldDefaultCustomerNo: "Default Customer No.",
    fieldDefaultBranchNo: "Default Branch No.",
    fieldCustomerNos: "Allowed Customers (comma-separated)",
    fieldPhoneNo: "Phone No.",
    fieldDisplayName: "Display Name",
    fieldPassword: "Password",
    hintCustomers: "Required: customerNo. branchNo defaults to 0000. Matches by customerNo+branchNo; updates if exists. Use name1–name3 for English (en); use nameLocaleLine1ZhTc / nameLocaleLine1ZhSc etc. for Traditional/Simplified. Optional salesmanName / salesmanCode (ERP cross-check). Optional priceType / price_type. Optional billing/shipping addresses: billingAddressEn1…deliveryAddressCn3 (or billing_address_en_1 snake_case). Optional delivery days (Mon–Sun, holiday): Y/N, 1/0, TRUE/FALSE; on update, unmapped columns keep existing values.",
    hintPriceCards: "Required: customerNo, itemNo, unitPrice. Overlapping date ranges will be skipped. Optional: priceType / price_type.",
    hintProducts: "Red labels are required: name, Content ID (Product ID) (field productRetailerId). Required for new rows; updates if ID already exists. Optional tier prices: price1, validFrom1, validTo1, price2… or snake_case price_1, valid_from_1, etc.; works alongside main price. Optional MOQ: minOrderQuantity (aliases e.g. moq, min_order_quantity).",
    fieldMappingColumnRequired: "Please map a source column",
    noColumnMapping: "(No source column)",
    fieldMappingFormIncomplete: "Please complete all required (red) field mappings before importing",
    mappingExport: "Export field mapping",
    mappingImport: "Import field mapping",
    mappingImportSuccess: "Field mapping imported successfully",
    mappingImportFailed: "Import failed. Please verify the JSON format.",
    hintCollections: "Required: name. If externalCollectionKey exists, updates existing record.",
    hintCollectionLinks: "Required: collectionKey, Content ID (Product ID) (productRetailerId). Matching collection and product must already exist.",
    fieldLoginId: "PWA login ID (loginId)",
    downloadImportTemplate: "Download import template",
    downloadAllImportTemplatesZh: "Download all templates (Chinese)",
    downloadAllImportTemplatesEn: "Download all templates (English)",
    templateDownloaded: "Import template for current master downloaded",
    templateAllDownloaded: "All master import templates downloaded (includes guide sheet)",
    selectImportSheet: "Select worksheet ({count} sheets)",
    multiSheetPickHint: "This workbook has {count} sheets. A data sheet was pre-selected — confirm below.",
    sqlTenantAdminOnly: "SQL database import is restricted to Tenant_Admin",
    templateGoogleSheetsHint: "Download the Excel template and copy the column layout to Google Sheets, or upload the template and open it with Google Sheets.",
    hintWpaGroupMembers: "Required: groupName, loginId (PWA account). Group and account must already exist.",
    hintWpaGroupCustomers: "Required: groupName, customerNo. branchNo defaults to 0000.",
    hintWpaContactOverrides: "Required: loginId, roleKey. customerNos: comma-separated (format: no/branch).",
    hintWpaIdentities: "Required: loginId (PWA account; email column accepted). password required when creating; enable allow-password-update to change existing passwords.",
  },
  commerceProducts: {
    title: "Commerce / Products",
    description: "Manage products, link to collections, sync to Meta.",
    refresh: "Refresh",
    addProduct: "Add product",
    image: "Image",
    titleLabel: "Title",
    nameColUiLocale: "Product name (UI language)",
    productName: "Product name (English / primary)",
    nameLocaleZhTc: "Product name (Traditional Chinese)",
    nameLocaleZhSc: "Product name (Simplified Chinese)",
    nameLocalesHint: "Primary field syncs to name_locales.en; TC/SC optional.",
    description: "Description",
    descriptionPrimary: "Description (English / primary)",
    descriptionLocalesHint: "Primary field syncs to description_locales.en; TC/SC optional.",
    descriptionLocaleZhTc: "Description (Traditional Chinese)",
    descriptionLocaleZhSc: "Description (Simplified Chinese)",
    link: "Link",
    company: "Company",
    filterByCompany: "Filter by company",
    filterByCollectionsPlaceholder: "Filter by collections (multi-select)",
    phoneNumberId: "Phone number ID",
    contentId: "Content ID (Product ID)",
    searchKeywordPlaceholder: "Search name, description, Content ID (Product ID)",
    fbCategory: "Facebook product category",
    brand: "Brand",
    contentNumber: "Content number",
    color: "Color",
    size: "Size",
    gender: "Gender",
    price: "Price",
    tabBasic: "Basic",
    tabSellingPrice: "Selling price",
    sellingPriceTabHint: "Set at least one of Price 1 or Price 2 (with valid-from/to, UTC), or legacy list price only. PWA/cart uses price cards first; otherwise these tiers apply.",
    legacyPrice: "List price (optional, legacy)",
    price1: "Price 1",
    validFrom1: "Valid from (1)",
    validTo1: "Valid to (1)",
    price2: "Price 2",
    validFrom2: "Valid from (2)",
    validTo2: "Valid to (2)",
    effectivePriceCol: "Effective price (now)",
    previewEffectiveAtServer: "Preview (server UTC)",
    status: "Status",
    availability: "Availability",
    unitOfMeasure: "Quantity unit",
    unitOfMeasureLocaleZhTc: "Quantity unit (Traditional Chinese)",
    unitOfMeasureLocaleZhSc: "Quantity unit (Simplified Chinese)",
    unitOfBrokenPack: "Broken-pack unit",
    unitOfBrokenPackLocaleZhTc: "Broken-pack unit (Traditional Chinese)",
    unitOfBrokenPackLocaleZhSc: "Broken-pack unit (Simplified Chinese)",
    unitOfBrokenPackPlaceholder: "e.g. piece, pack, bag",
    unitOfBrokenPackHint: "Unit used when selling below a full pack/case (loose / broken pack)",
    qtyPerUnit: "Qty per unit",
    qtyPerUnitHint: "How many items in one unit. e.g. 1 case = 12 pieces → 12",
    moq: "MOQ (min. order qty)",
    oqm: "Original Quality Manufacturer (OQM)",
    oqmHint: "Optional text",
    oqmPlaceholder: "e.g. manufacturer or quality source",
    unitOfMeasurePlaceholder: "e.g. piece, case, kg",
    condition: "Condition",
    currency: "Currency",
    material: "Material",
    pattern: "Pattern",
    actions: "Actions",
    edit: "Edit",
    sync: "Sync",
    delete: "Delete",
    confirmDelete: "Delete this product?",
    addProductModal: "Add product",
    editProductModal: "Edit product",
    loadFailed: "Failed to load products",
    loadCollectionsFailed: "Failed to load collections list",
    addToCollection: "Add to collection",
    addToCollectionHint: "{count} product(s) selected. Add to an existing collection or create a new one.",
    addToExistingCollection: "Add to existing collection",
    createNewCollection: "Create new collection",
    selectCollection: "Select collection",
    selectCollectionPlaceholder: "Select a collection",
    selectCollectionFirst: "Please select a collection first",
    selectCollectionsFirst: "Please select at least one collection",
    addToCollectionSearchPlaceholder: "Search by name, description, external key, company",
    addToCollectionsSelectedCount: "{n} collection(s) selected",
    addToCollectionMixedWaba: "Selected products use different WhatsApp numbers (WABA). Choose products that share the same phone number ID.",
    addToCollectionNoCompatibleCollections: "No collections match the selected products' WhatsApp number. Create a new collection or link the same WABA on collections.",
    formBasicSection: "Basic",
    selectAtLeastOne: "Please select at least one product",
    newCollectionNameRequired: "Please enter the new collection name",
    newCollectionNamePlaceholder: "New collection name",
    newCollectionDescriptionPlaceholder: "Description (optional)",
    confirmAddToCollection: "OK",
    cancel: "Cancel",
    drawerClose: "Close",
    addToCollectionSuccess: "Added to collection",
    addToCollectionFailed: "Failed to add to collection",
    saveFailed: "Save failed",
    saved: "Product updated",
    created: "Product created",
    deleted: "Product deleted",
    deleteFailed: "Delete failed",
    syncSuccess: "Sync record written (scheduler_executions)",
    syncFailed: "Sync failed",
    uploadToMeta: "Upload to Meta",
    uploadQueued: "Added to upload queue (upload only; does not download from Meta)",
    uploadFailed: "Failed to add to upload queue",
    batchUploadToMeta: "Batch upload to Meta",
    batchUploadQueued: "{count}/{total} product(s) added to upload queue",
    batchUploadFailed: "Batch upload failed",
    copy: "Copy",
    batchCopy: "Batch copy",
    copySuccess: "Copied as new product (name auto (1), (2)...)",
    copyFailed: "Copy failed",
    batchCopySuccess: "Copied {count}/{total} as new products",
    batchCopyFailed: "Batch copy failed",
    nameRequired: "Name is required",
    inlineSaveFailed: "Inline save failed",
    saveMediaFirst: "Save the product first, then upload images/videos",
    imageVideoOnly: "Only image or video files are supported",
    imageSizeLimit: "Image must not exceed 8MB",
    videoSizeLimit: "Video must not exceed 100MB",
    mediaUploadSuccess: "Media uploaded",
    uploadFailed: "Upload failed",
    setPrimary: "Set as primary image",
    setPrimaryFailed: "Failed to set primary",
    altUpdated: "alt_text updated",
    altUpdateFailed: "Failed to update alt_text",
    mediaDeleted: "Media deleted",
    reorderFailed: "Reorder failed",
    loadMediaFailed: "Failed to load media",
    loadCatalogFailed: "Failed to load Meta catalog list",
    selectCategory: "Select category",
    noCategory: "No categories; sync first",
    save: "Save",
    inlineEdit: "Inline edit",
    detail: "Detail",
    media: "Image/Video",
    metaProductId: "Meta Product ID",
    customLabel0Label: "Content number (custom_label_0)",
    linkUrlPlaceholder: "https://...",
    mediaFormHint: "Use media management UI (primary image will sync to list).",
    openMediaManager: "Open image / video management",
    productImage: "Product image",
    productImageUploadHint: "Click to upload or manage",
    creatingProductForMedia: "Creating product...",
    mediaModalTitle: "Image / video management",
    mediaModalHint: "Image max 8MB; video max 100MB. You can set primary image and reorder.",
    mediaUploadDragText: "Drag and drop or click to upload",
    mediaUploadHint: "Supports image/video, replicating Meta product media flow.",
    mediaTypeImage: "Image",
    mediaTypeVideo: "Video",
    mediaTagPrimary: "Primary",
    batchUploadProgress: "Batch upload progress",
    retry: "Retry",
    copyImageUrl: "Copy full URL",
    copyImageUrlSuccess: "Full URL copied (base + path)",
    metaAttributes: "Meta attributes",
    productType: "product_type",
    loadingMedia: "Loading media...",
    noMediaUploaded: "No media uploaded yet",
    altTextPlaceholder: "alt_text",
    saveAlt: "Save alt",
    primaryImage: "Primary image",
    confirmDeleteMedia: "Delete this media?",
    linkedCatalogDefault: "Linked catalog (default; WABA can have only one)",
    noCatalogLinkedHint: "No catalog linked to company WABA yet. Link one in Catalog Admin.",
    linkRequired: "Required (Meta/WhatsApp needs product link to display)",
    priceRequired: "Required (Meta/WhatsApp needs price to display)",
    metaRequiredHint: "Meta/WhatsApp requires \"Link\" and \"Price\" to display products; missing values cause \"Missing product link\" / \"Missing price\" errors.",
    collectionsSection: "Collections",
    productCollectionsLabel: "Collections (one-to-many)",
    productCollectionsTooltip: "Select the collections this product belongs to; changes will sync when you save.",
    productCollectionsPlaceholder: "Select collections...",
    noCollectionFound: "No collections",
    syncFacebookTaxonomy: "Sync Facebook categories",
    taxonomySyncSuccess: "{provider} taxonomy synced: {count} item(s)",
    taxonomySyncFailed: "Sync {provider} taxonomy failed"
  },

  commerceWpaHomePromotions: {
    title: 'PWA home promotions',
    selectCompany: 'Company',
    refresh: 'Refresh',
    add: 'Add',
    loadFailed: 'Load failed',
    saveOk: 'Saved',
    saveFailed: 'Save failed',
    deleteConfirm: 'Delete this promotion?',
    deleteOk: 'Deleted',
    deleteFailed: 'Delete failed',
    colSort: 'Order',
    colBanner: 'Banner',
    colFullscreen: 'Fullscreen',
    colProduct: 'Product',
    colActive: 'Active',
    colSchedule: 'Schedule',
    colActions: 'Actions',
    yes: 'Yes',
    no: 'No',
    create: 'New promotion',
    edit: 'Edit promotion',
    sortOrder: 'Sort order (lower first)',
    active: 'Active',
    validFrom: 'Valid from (optional)',
    validTo: 'Valid to (optional)',
    bannerPath: 'Banner image path',
    fullscreenPath: 'Fullscreen image path',
    uploadBanner: 'Recommended 16:10 (e.g. 1920×1200), full width on PWA',
    uploadFullscreen: 'Recommended 9:16 (e.g. 1080×1920); keep safe margins',
    uploadBannerBtn: 'Upload banner',
    uploadFullscreenBtn: 'Upload fullscreen',
    uploadOk: 'Upload OK',
    linkedProduct: 'Linked product (optional)',
    searchProduct: 'Search products',
    noLinkedProduct: 'No product selected',
    pickProductBtn: 'Choose product',
    pickProductTitle: 'Choose linked product',
    clearLinkedProduct: 'Clear',
    productSearchPlaceholder: 'Search name, SKU or description',
    filterBrand: 'Brand (contains)',
    pickerOk: 'OK',
    pickerCancel: 'Cancel',
    pickerNeedSelect: 'Please select a product',
    sizeHintTitle: 'Image specs',
    sizeHintBody: 'Banner: 16:10 (e.g. 1920×1200). Fullscreen: 9:16 (e.g. 1080×1920); keep important content away from edges and reserve bottom for buttons.',
  },
  
  // EForm related
  eform: {
    title: "Electronic Form Management",
    name: "Name",
    description: "Description",
    formType: "Form Type",
    status: "Status",
    createdAt: "Created Time",
    updatedAt: "Updated Time",
    action: "Action",
    edit: "Edit",
    delete: "Delete",
    add: "Add Form",
    search: "Search",
    searchPlaceholder: "Search form name, description...",
    enabled: "Enabled",
    disabled: "Disabled",
    deleted: "Deleted",
    confirmDeleteTitle: "Are you sure you want to delete this form?",
    confirmDeleteContent: "This action cannot be undone",
    confirmDeleteOk: "Confirm",
    confirmDeleteCancel: "Cancel",
    deleteSuccess: "Delete successful",
    deleteFailed: "Delete failed",
    saveSuccess: "Save successful",
    saveFailed: "Save failed",
    batchDeleteTitle: "Batch Delete",
    batchDeleteContent: "Are you sure you want to delete the selected {count} forms?",
    batchDeleteSuccess: "Batch delete successful",
    batchDeleteFailed: "Batch delete failed",
    batchEnableTitle: "Batch Enable",
    batchEnableContent: "Are you sure you want to enable the selected {count} forms?",
    batchEnableSuccess: "Batch enable successful",
    batchDisableTitle: "Batch Disable",
    batchDisableContent: "Are you sure you want to disable the selected {count} forms?",
    batchDisableSuccess: "Batch disable successful",
    noData: "No data available",
    loading: "Loading...",
    totalRecords: "Total Records",
    currentPageRecords: "Current Page Records",
    pleaseSelectForms: "Please select forms to operate on",
    cannotGetCompanyInfo: "Cannot get user company information",
    updateFailed: "Update failed",
    createFailed: "Create failed",
    eformUpdateSuccess: "Form update successful",
    eformCreateSuccess: "Form create successful",
    batchEnable: "Batch Enable",
    batchDisable: "Batch Disable",
    batchDelete: "Batch Delete",
    refresh: "Refresh",
    eformManagement: "Form Management",
    searchNameDescription: "Search name, description...",
    clearFilter: "Clear Filter",
    pageRange: "Page ",
    total: " items, total ",
    batchDeleteForms: "Batch Delete Forms",
    cancel: "Cancel",
    confirmDelete: "Confirm Delete",
    forms: " forms",
    batchDeleteWarning: "Batch Delete Warning",
    batchDeleteWarningContent: "You are about to delete ",
    cannotBeUndone: " forms. This action cannot be undone. Please confirm the forms to delete.",
    pleaseConfirm: "Please confirm the forms to delete",
    batchEnableForms: "Batch Enable Forms",
    batchDisableForms: "Batch Disable Forms",
    confirm: "Confirm",
    enable: "Enable",
    disable: "Disable",
    confirmStatusChangeTitle: "Confirm Status Change",
    confirmStatusChangeContent: "Are you sure you want to change the status of form \"{name}\" to \"{action}\"?",
    statusChangeSuccess: "Status changed successfully",
    statusChangeFailed: "Status change failed",
    batchStatusContent: "You are about to",
    enableAfter: " forms. After enabling, forms will be available for normal use.",
    disableAfter: " forms. After disabling, forms will be unavailable but can be re-enabled.",
    unknownError: "Unknown error",
    batchStatusSuccess: "Successful",
    batchStatusFailed: "Batch operation failed",
    copy: "Copy",
    copyForm: "Copy Form",
    copyFormInfo: "Copy Form Information",
    copyFormContent: "You are about to copy form",
    copyFormContent2: ". After copying, a new form copy will be created.",
    newFormName: "New Form Name",
    newFormDescription: "New Form Description",
    pleaseEnterFormName: "Please enter form name",
    formNameTooLong: "Form name cannot exceed 100 characters",
    enterNewFormName: "Please enter new form name",
    enterNewFormDescription: "Please enter new form description (optional)",
    copySuccess: "Copy successful",
    copyFailed: "Copy failed"
  },
  
  // EForm Designer
  eformDesigner: {
    title: 'Form Designer',
    formInfo: 'Form Information',
    formName: 'Form Name',
    formDescription: 'Form Description',
    formNamePlaceholder: 'Please enter form name',
    formDescriptionPlaceholder: 'Please enter form description',
    uploadFile: 'File Upload',
    createFromWordFile: 'Create from Word File',
    createFromExcelFile: 'Create from Excel File',
    createFromPdfFile: 'Create from PDF File',
    uploadImage: 'Upload Image',
    aiGenerate: 'AI Generate',
    aiGenerateForm: 'AI Generate Form',
    tabBasicInfo: 'Basic Info',
    tabFileUpload: 'File Upload',
    tabAIAssistant: 'AI Assistant',
    aiProvider: 'AI Provider',
    aiProviderPlaceholder: 'Select the AI provider to use',
    aiProviderRequired: 'Please select an AI provider',
    loadAiProvidersFailed: 'Failed to load AI providers. Please try again later.',
    sendDefaultSystemPrompt: 'Send default system prompt',
    modifySystemPrompt: 'Modify default system prompt',
    loadDefaultPromptFailed: 'Failed to load default system prompt',
    loadingDefaultPrompt: 'Loading default...',
    systemPromptPlaceholder: 'Default system prompt (editable)',
    aiFormAssistant: 'AI Form Assistant',
    chatEmptyHint: 'Enter requirements or upload image/document; AI will help generate or modify the form.',
    chatSaveFailed: 'Failed to save chat history',
    chatSaveHintNewForm: 'Chat history will be saved after you save the form.',
    restoreToThisVersion: 'Restore to this version',
    restoredToThisVersion: 'Restored to this version.',
    uploadedImage: 'Image uploaded',
    uploadImage: 'Image',
    uploadDoc: 'Word/PDF',
    aiFormUpdatedSuccess: 'Form updated according to your request.',
    advancedOptions: 'Advanced options',
    formStyle: 'Form style',
    formStyleUi: 'Interactive UI',
    formStylePrint: 'Printable document',
    formStylePrintHint: 'Best for image/PDF/Word uploads to reproduce the original layout as closely as possible',
    pleaseUploadImage: 'Please upload an image file',
    imageSizeLimit: 'Image size must not exceed 10MB',
    
    // Upload modal translations
    createFormFromWordFile: 'Create Form from Word File',
    createFormFromExcelFile: 'Create Form from Excel File',
    createFormFromPdfFile: 'Create Form from PDF File',
    imageUpload: 'Image Upload',
    wordFileConversion: 'Word File Conversion',
    excelFileConversion: 'Excel File Conversion',
    pdfFileConversion: 'PDF File Conversion',
    uploadWordFileDescription: 'Upload Word file (.doc, .docx), the system will automatically convert to HTML format and load into the editor. Supports text, tables, images and other content.',
    uploadExcelFileDescription: 'Upload Excel file (.xls, .xlsx), the system will automatically convert to HTML format and load into the editor. Supports tables, charts and other content.',
    uploadPdfFileDescription: 'Upload PDF file (.pdf), the system will automatically convert to HTML format and load into the editor. Supports text, images and other content.',
    uploadImageDescription: 'Upload image file, the system will automatically insert the image into the editor. Supports JPG, PNG, GIF and other formats.',
    converting: 'Converting...',
    uploading: 'Uploading...',
    clickOrDragWordFileHere: 'Click or drag Word file here',
    clickOrDragExcelFileHere: 'Click or drag Excel file here',
    clickOrDragPdfFileHere: 'Click or drag PDF file here',
    clickOrDragImageHere: 'Click or drag image here',
    supportsDocAndDocxFormats: 'Supports .doc and .docx formats, file size not exceeding 50MB',
    supportsXlsAndXlsxFormats: 'Supports .xls and .xlsx formats, file size not exceeding 50MB',
    supportsPdfFormat: 'Supports .pdf format, file size not exceeding 50MB',
    supportsJpgPngGifBmpWebpFormats: 'Supports JPG, PNG, GIF, BMP, WebP formats, file size not exceeding 10MB',
    processingWordFile: 'Processing Word file, please wait...',
    processingExcelFile: 'Processing Excel file, please wait...',
    processingPdfFile: 'Processing PDF file, please wait...',
    uploadingImage: 'Uploading image, please wait...',
    
    // AI modal translations
    aiSmartGeneration: 'AI Smart Generation',
    describeTheFormTypeAndRequirements: 'Describe the form type and requirements you need, AI will generate the corresponding HTML form for you. Suitable for approval processes, application forms, etc.',
    requirementsDescription: 'Requirements Description:',
    uploadFormImage: 'Upload form image (optional)',
    uploadFormDocumentOptional: 'Upload Word/Excel/PDF (optional)',
    clickOrDragDocHere: 'Click or drag Word/Excel/PDF here',
    documentConvertedToHtmlForAi: 'Per app settings, LibreOffice exports HTML or FODG (Flat ODF XML) for AI field recognition; using image and document together yields more accurate forms.',
    uploadWordExcelPdfOnly: 'Only Word (.doc/.docx), Excel (.xls/.xlsx), and PDF (.pdf) are supported',
    documentSizeLimit: 'File size must not exceed 50MB',
    remove: 'Remove',
    placeholderExample: 'For example: I need a leave application form, including employee information, leave type, start date, end date, leave reason and other fields...',
    includeCurrentHtml: 'Include current HTML',
    willModifyBasedOnCurrentContent: 'Will modify based on current content',
    willGenerateNewForm: 'Will generate new form',
    aiWillModifyAndOptimizeBasedOnYourCurrentFormContent: 'AI will modify and optimize based on your current form content. Current content length: {length} characters',
    
    // Editor component translations
    editTextInput: 'Edit Text Input',
    editTextArea: 'Edit Text Area',
    editButton: 'Edit Button',
    editRadioButton: 'Edit Radio Button',
    editCheckbox: 'Edit Checkbox',
    editLabel: 'Edit Label',
    
    // Common field labels
    placeholderText: 'Placeholder Text',
    fieldName: 'Field Name',
    defaultValue: 'Default Value',
    inputType: 'Input Type',
    dateFormat: 'Date Format',
    rows: 'Rows',
    columns: 'Columns',
    buttonText: 'Button Text',
    buttonType: 'Button Type',
    buttonStyle: 'Button Style',
    buttonSize: 'Button Size',
    labelText: 'Label Text',
    associatedField: 'Associated Field',
    labelStyle: 'Label Style',
    fontSize: 'Font Size',
    requiredField: 'Required Field',
    disabled: 'Disabled',
    requiredLabel: 'Required Label',
    
    // Placeholder texts
    pleaseEnterPlaceholderText: 'Please enter placeholder text',
    pleaseEnterFieldName: 'Please enter field name',
    pleaseEnterDefaultValue: 'Please enter default value',
    pleaseEnterDefaultDate: 'Please enter default date',
    pleaseEnterButtonText: 'Please enter button text',
    pleaseEnterLabelText: 'Please enter label text',
    pleaseEnterAssociatedFieldId: 'Please enter associated field ID',
    
    // Input type options
    text: 'Text',
    email: 'Email',
    password: 'Password',
    number: 'Number',
    currency: 'Currency',
    phone: 'Phone',
    url: 'URL',
    date: 'Date',
    time: 'Time',
    file: 'File',
    
    // Button type options
    normalButton: 'Normal Button',
    submitButton: 'Submit Button',
    resetButton: 'Reset Button',
    
    // Button style options
    primaryButton: 'Primary Button',
    secondaryButton: 'Secondary Button',
    successButton: 'Success Button',
    dangerButton: 'Danger Button',
    warningButton: 'Warning Button',
    infoButton: 'Info Button',
    lightButton: 'Light Button',
    darkButton: 'Dark Button',
    
    // Button size options
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    
    // Label style options
    normal: 'Normal',
    bold: 'Bold',
    italic: 'Italic',
    underline: 'Underline',
    
    // Font size options
    small12px: 'Small (12px)',
    medium14px: 'Medium (14px)',
    large16px: 'Large (16px)',
    extraLarge18px: 'Extra Large (18px)',
    
    // Date format options and descriptions
    dateFormatDescription: 'Choose the date format displayed in the form, this will affect the date style users see',
    selectedFormat: 'Selected format: {format}',
    formatPreview: 'Format preview: {preview}',
    tip: 'Tip: Format settings will affect the display effect in WYSIWYG editor',
    pleaseEnterDefaultValueAccordingToDateFormat: 'Please enter default value according to the selected date format, for example: {example}',
    
    // GrapesJS component default content
    pleaseEnterYourMessage: 'Please enter your message',
    pleaseSelect: 'Please select...',
    option1: 'Option 1',
    option2: 'Option 2',
    option3: 'Option 3',
    pleaseEnterEmail: 'Please enter email',
    pleaseEnterPassword: 'Please enter password',
    pleaseEnterNumber: 'Please enter number',
    pleaseEnterCurrencyAmount: 'Please enter amount',
    pleaseEnterUrl: 'Please enter URL',
    pleaseEnterPhoneNumber: 'Please enter phone number',
    
    // Table Cell Editor translations
    editTableCell: 'Edit Table Cell',
    editTableHeader: 'Edit Table Header',
    cellContent: 'Cell Content',
    pleaseEnterCellContent: 'Please enter cell content...',

    // Text Block Editor
    editTextBlock: 'Edit Text',
    textContent: 'Text Content',
    pleaseEnterTextContent: 'Please enter text content',
    textAlign: 'Alignment',
    textAlignLeft: 'Left',
    textAlignCenter: 'Center',
    textAlignRight: 'Right',
    textAlignJustify: 'Justify',
    fontFamily: 'Font',
    fontStyle: 'Font Style',
    boldItalic: 'Bold + Italic',
    fontSize20px: '20px',
    fontSize24px: '24px',
    
    // Image Editor translations
    editImage: 'Edit Image',
    imageUrl: 'Image URL',
    pleaseEnterImageUrl: 'Please enter image URL',
    imageUploadHint: 'Click the upload button to select an image file, or directly enter an image URL in the URL field',
    altText: 'Alt Text',
    pleaseEnterAltText: 'Please enter alt text',
    imageWidth: 'Image Width',
    pleaseEnterWidth: 'Please enter width (e.g., 100px or 50%)',
    imageWidthHint: 'You can enter pixel values (e.g., 100px) or percentages (e.g., 50%)',
    imageHeight: 'Image Height',
    pleaseEnterHeight: 'Please enter height (e.g., 100px or 50%)',
    imageHeightHint: 'You can enter pixel values (e.g., 100px) or percentages (e.g., 50%)',
    imagePreview: 'Image Preview',
    uploadImage: 'Upload Image',
    labelText: 'Label Text',
    groupTitle: 'Group Title',
    groupInputField: 'Group input field',
    unknown: 'Unknown',
    aiWillGenerateANewFormBasedOnYourDescription: 'AI will generate a new form based on your description, without using the current content in the editor',
    aiGeneratingForm: 'AI is generating form, please wait...',
    generating: 'Generating...',
    generateForm: 'Generate Form',
    pleaseEnterYourRequirements: 'Please enter your requirements description',
    welcomeMessage: 'Welcome to Form Designer',
    
    // Component Editor translations
    editComponent: 'Edit Component',
    componentId: 'Component ID',
    editDropdownMenu: 'Edit Dropdown Menu',
    editTextInput: 'Edit Text Input',
    editTextArea: 'Edit Text Area',
    editButton: 'Edit Button',
    editRadioButton: 'Edit Radio Button',
    editCheckbox: 'Edit Checkbox',
    editLabel: 'Edit Label',
    fieldName: 'Field Name',
    fieldNamePlaceholder: 'Please enter field name',
    placeholderText: 'Placeholder Text',
    placeholderTextPlaceholder: 'Please enter placeholder text',
    optionList: 'Option List',
    optionValue: 'Option Value',
    optionText: 'Option Text',
    delete: 'Delete',
    addOption: '+ Add Option',
    requiredField: 'Required Field',
    disabled: 'Disabled',
    readonly: 'Read Only',
    buttonText: 'Button Text',
    buttonTextPlaceholder: 'Please enter button text',
    buttonType: 'Button Type',
    buttonStyle: 'Button Style',
    buttonSize: 'Button Size',
    generalButton: 'General Button',
    submitButton: 'Submit Button',
    resetButton: 'Reset Button',
    primaryButton: 'Primary Button',
    secondaryButton: 'Secondary Button',
    successButton: 'Success Button',
    dangerButton: 'Danger Button',
    warningButton: 'Warning Button',
    infoButton: 'Info Button',
    lightButton: 'Light Button',
    darkButton: 'Dark Button',
    smallSize: 'Small Size',
    mediumSize: 'Medium Size',
    largeSize: 'Large Size',
    labelText: 'Label Text',
    labelTextPlaceholder: 'Please enter label text',
    defaultValue: 'Default Value',
    defaultValuePlaceholder: 'Please enter default value',
    rows: 'Rows',
    cols: 'Columns',
    maxLength: 'Max Length',
    minLength: 'Min Length',
    inputType: 'Input Type',
    text: 'Text',
    email: 'Email',
    password: 'Password',
    number: 'Number',
    tel: 'Phone',
    url: 'URL',
    date: 'Date',
    time: 'Time',
    datetime: 'Date Time',
    dateFormat: 'Date Format',
    dateFormatPlaceholder: 'Select date format',
    checkboxText: 'Checkbox Text',
    checkboxTextPlaceholder: 'Please enter checkbox text',
    welcomeDescription: 'Please drag components from the left panel here to start designing your form.',
    pleaseDragComponents: 'Please drag components here to start designing your form',
    exampleInput: 'Example Input Field',
    exampleInputLabel: 'Example Input Field',
    exampleInputPlaceholder: 'Please enter...',
    pleaseEnter: 'Please enter content',
    newForm: 'New Form',
    saveForm: 'Save Form',
    formSaved: 'Form saved',
    saveFailed: 'Save failed',
    grapesJsInitializationFailed: 'GrapesJS initialization failed',
    uploadWord: 'Upload Word File',
    uploadExcel: 'Upload Excel File',
    uploadPdf: 'Upload PDF File',
    uploadImage: 'Upload Image',
    aiGenerate: 'AI Generate Form',
    aiPrompt: 'Please describe the form you want',
    generating: 'Generating...',
    generationFailed: 'Generation failed',
    aiFormGeneratedSuccess: 'AI form generation successful',
    wordUploadSuccess: 'Word file conversion successful',
    excelUploadSuccess: 'Excel file conversion successful',
    pdfUploadSuccess: 'PDF file conversion successful',
    imageUploadSuccess: 'Image upload successful',
    uploadFailed: 'Upload failed',
    formCreatedFromWord: 'Form created from Word',
    formCreatedFromExcel: 'Form created from Excel',
    formCreatedFromPdf: 'Form created from PDF',
    unknownError: 'Unknown error',
    fileTooLarge: 'File too large',
    unsupportedFormat: 'Unsupported format',
    includeCurrentHtml: 'Include current HTML content',
    toolbarCollapse: 'Collapse Toolbar',
    toolbarExpand: 'Expand Toolbar',
    viewCode: 'View Code',
    viewPreview: 'Preview',
    backToList: 'Back to List',
    wordFileConvertedSuccess: 'Word file conversion successful',
    excelFileConvertedSuccess: 'Excel file conversion successful',
    pdfFileConvertedSuccess: 'PDF file conversion successful',
    conversionFailed: 'Conversion failed',
    requestTimeoutWordFileConversion: 'Word file conversion request timeout',
    requestTimeoutExcelFileConversion: 'Excel file conversion request timeout',
    requestTimeoutPdfFileConversion: 'PDF file conversion request timeout',
    requestTimeoutImageUpload: 'Image upload request timeout',
    requestTimeoutAiGeneration: 'AI generation request timeout',
    requestTimeoutPleaseTryAgain: 'Request timeout, please try again',
    pleaseTryAgainLaterOrCheckNetworkConnection: ', please try again later or check network connection',
    pleaseEnterYourRequirements: 'Please enter your requirements',
    aiFormGeneratedSuccess: 'AI form generation successful',
    aiGeneratedForm: 'AI Generated Form',
    pleaseWriteFormContent: 'Please write form content',
    pleaseEnterFormName: 'Please enter form name',
    formSavedSuccessfully: 'Form saved successfully',
    formSavedToLocalStorage: 'Form saved to local storage',
    saveFailed: 'Save failed',
    expandToolbar: 'Expand Toolbar',
    back: 'Back',
    saving: 'Saving...',
    saveDesign: 'Save Design',
    aiGenerateForm: 'AI Generate Form',
    createFromWordFile: 'Create from Word File',
    createFromExcelFile: 'Create from Excel File',
    createFromPdfFile: 'Create from PDF File',
    createFromImageFile: 'Create from Image',
    viewDesign: 'View Design',
    viewCode: 'View Code',
    formName: 'Form Name',
    formDescription: 'Form Description',
    formNamePlaceholder: 'Please enter form name',
    formDescriptionPlaceholder: 'Please enter form description (optional)',
    uploadFile: 'Upload File',
    exportImport: 'Export / Import',
    exportHtml: 'Export HTML',
    importHtml: 'Import HTML',
    exportSuccess: 'HTML file exported',
    importSuccess: 'HTML imported successfully',
    importFailed: 'Import failed',
    dragAndDropOrClick: 'Drag and drop files here or click to upload',
    selectFile: 'Select File',
    upload: 'Upload',
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    generate: 'Generate',
    promptPlaceholder: 'Please describe the form you want, for example: a contact form containing name, phone, address',
    includeCurrentContent: 'Include current content',
    yes: 'Yes',
    no: 'No',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',
    
    // Upload related translations
    upload: {
      authTokenNotFound: 'Authentication token not found, please login again'
    },
    
    // Field display setting related translations
    fieldDisplaySetting: {
      modalTitle: 'Form Field Display Settings',
      tableColumns: {
        fieldType: 'Field Type',
        originalLabel: 'Original Label',
        displayLabel: 'Display Label',
        showInList: 'Show in List',
        fieldId: 'Field ID',
        actions: 'Actions'
      },
      placeholders: {
        displayLabel: 'Enter display label',
        jsonKey: 'Enter JSON Key'
      },
      actions: {
        moveUp: 'Move Up',
        moveDown: 'Move Down',
        addJsonRow: 'Add JSON Sub-Row',
        convertToJson: 'Convert to JSON Mode',
        removeJsonRow: 'Remove JSON Sub-Row'
      },
      buttons: {
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      helperText: 'All input fields have been auto-scanned. You can rename labels, adjust ordering, toggle visibility, and add multiple JSON Key sub-rows for JSON-typed fields.',
      helperTextNoJson: 'All input fields have been auto-scanned. You can rename labels, adjust ordering, and toggle visibility in the list.',
      messages: {
        saveSuccess: 'Field display settings saved',
        saveFailed: 'Save failed: ',
        unnamedField: 'Unnamed Field',
        noFieldsFound: 'No form fields found'
      }
    }
  },
  
  // EForm Instance
  eformInstance: {
    title: "Form Instance",
    status: "Status",
    submittedAt: "Submitted Time",
    approvedAt: "Approved Time",
    rejectedAt: "Rejected Time",
    approvedBy: "Approved By",
    rejectedBy: "Rejected By",
    approvalNote: "Approval Note",
    rejectNote: "Rejection Note",
    approve: "Approve",
    reject: "Reject",
    back: "Back",
    loading: "Loading...",
    error: "Error",
    noData: "No data available",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    confirmApprove: "Are you sure you want to approve this form?",
    confirmReject: "Are you sure you want to reject this form?",
    approveSuccess: "Approval successful",
    rejectSuccess: "Rejection successful",
    approveFailed: "Approval failed",
    rejectFailed: "Rejection failed",
    noteRequired: "Please enter note",
    loginRequired: "Please login first",
    loginExpired: "Login expired, please login again",
    fetchFailed: "Failed to get form instance",
    formApproved: "Form approved",
    formRejected: "Form rejected",
    pendingApproval: "Pending Approval",
    formInstanceNotFound: "Form instance not found",
    formInfo: "Form Information",
    instanceName: "Instance Name",
    createdAt: "Created Time",
    userInput: "User Input",
    approver: "Approver",
    approvalTime: "Approval Time",
    formContent: "Form Content",
    approveForm: "Approve Form",
    cancel: "Cancel",
    confirmApprove: "Confirm Approve",
    confirmApproveForm: "Are you sure you want to approve this form?",
    approvalNotePlaceholder: "Approval note (optional)",
    rejectForm: "Reject Form",
    confirmReject: "Confirm Reject",
    confirmRejectForm: "Are you sure you want to reject this form?",
    rejectReasonPlaceholder: "Rejection reason (optional)",
    rejectionReasonRequired: "Please enter rejection reason",
    receivedMedia: "Received Media"
  },

  eformValidation: {
    pleaseFillRequiredFields: "Please fill in all required fields",
    pleaseFillField: "Please fill in \"{field}\"",
    pleaseUploadField: "Please upload \"{field}\"",
    pleaseCheckField: "Please check \"{field}\"",
    pleaseSelectField: "Please select \"{field}\""
  },
  
  // WhatsApp Template
  whatsappTemplate: {
    title: "Message Template Management",
    name: "Name",
    description: "Description",
    category: "Category",
    status: "Status",
    type: "Type",
    createdAt: "Created Time",
    updatedAt: "Updated Time",
    action: "Action",
    add: "Add Template",
    edit: "Edit",
    delete: "Delete",
    copy: "Copy",
    preview: "Preview",
    import: "Import",
    search: "Search",
    searchPlaceholder: "Search template name, description...",
    enabled: "Enabled",
    disabled: "Disabled",
    draft: "Draft",
    text: "Text",
    image: "Image",
    video: "Video",
    audio: "Audio",
    document: "Document",
    location: "Location",
    contact: "Contact",
    interactive: "Interactive",
    button: "Button",
    list: "List",
    confirmDeleteTitle: "Are you sure you want to delete this template?",
    confirmDeleteContent: "This action cannot be undone",
    confirmDeleteOk: "Confirm",
    confirmDeleteCancel: "Cancel",
    deleteSuccess: "Delete successful",
    deleteFailed: "Delete failed",
    copySuccess: "Copy successful",
    copyFailed: "Copy failed",
    saveSuccess: "Save successful",
    saveFailed: "Save failed",
    importSuccess: "Import successful",
    importFailed: "Import failed",
    batchDeleteTitle: "Batch Delete",
    batchDeleteContent: "Are you sure you want to delete the selected {count} templates?",
    batchDeleteSuccess: "Batch delete successful",
    batchDeleteFailed: "Batch delete failed",
    noData: "No data available",
    loading: "Loading...",
    totalRecords: "Total Records",
    currentPageRecords: "Current Page Records",
    messageContent: "Message Content",
    mediaUrl: "Media URL",
    caption: "Caption",
    latitude: "Latitude",
    longitude: "Longitude",
    address: "Address",
    phoneNumber: "Phone Number",
    displayName: "Display Name",
    buttonText: "Button Text",
    buttonType: "Button Type",
    listTitle: "List Title",
    listDescription: "List Description",
    listItems: "List Items",
    variables: "Variables",
    addVariable: "Add Variable",
    variableName: "Variable Name",
    variableValue: "Variable Value",
    removeVariable: "Remove Variable",
    metaTemplates: "Meta Templates",
    importFromMeta: "Import from Meta",
    createMetaTemplate: "Create Meta Template",
    deleteMetaTemplate: "Delete Meta Template",
    metaTemplateName: "Meta Template Name",
    metaTemplateCategory: "Meta Template Category",
    customName: "Custom Name",
    filterAll: "All",
    filterEnabled: "Enabled",
    filterDisabled: "Disabled",
    templateName: "Template Name",
    templateDescription: "Template Description",
    templateType: "Template Type",
    templateStatus: "Template Status",
    templateLanguage: "Template Language",
    templateVersion: "Template Version",
    templateUpdateTime: "Template Update Time",
    templateOperation: "Template Operation",
    templatePreview: "Template Preview",
    templateEdit: "Template Edit",
    templateCopy: "Template Copy",
    templateDelete: "Template Delete",
    templateDeleteMeta: "Delete Meta Template",
    templateDeleteConfirm: "Are you sure you want to delete this template from Meta?",
    templateDeleteConfirmLocal: "Are you sure you want to delete this template?",
    templateConfirm: "Confirm",
    templateCancel: "Cancel",
    templateBatchDelete: "Batch Delete",
    templateBatchDeleteConfirm: "Are you sure you want to delete the selected {count} templates? This action cannot be undone.",
    templateBatchDeleteConfirmCount: "Are you sure you want to delete the selected",
    templateBatchDeleteConfirmSuffix: " templates? This action cannot be undone.",
    templateBatchDeleteOk: "Confirm Delete",
    templateBatchDeleteCancel: "Cancel",
    templateAdd: "Add Template",
    templateEditTitle: "Edit Template",
    templateAddTitle: "Add Template",
    templateSave: "Save",
    templateCancel: "Cancel",
    templateNameRequired: "Please enter template name",
    templateNamePlaceholder: "Please enter template name",
    templateDescriptionPlaceholder: "Please enter template description (optional)",
    templateCategoryRequired: "Please select category",
    templateCategoryPlaceholder: "Please select category",
    templateTypeRequired: "Please select template type",
    templateTypePlaceholder: "Please select template type",
    templateStatusRequired: "Please select status",
    templateStatusPlaceholder: "Please select status",
    templateLanguageRequired: "Please select language",
    templateLanguagePlaceholder: "Please select language",
    templateMessageContent: "Message Content",
    templateMessageContentRequired: "Please enter message content",
    templateMessageContentPlaceholder: "Please enter message content, you can use {{variable_name}} format to insert variables",
    templateMediaType: "Media Type",
    templateMediaTypeRequired: "Please select media type",
    templateMediaUrl: "Media File URL",
    templateMediaUrlRequired: "Please enter media file URL",
    templateMediaUrlPlaceholder: "Please enter media file URL",
    templateMediaCaption: "Media Caption",
    templateMediaCaptionPlaceholder: "Please enter media caption (optional)",
    templateInteractiveType: "Interactive Type",
    templateInteractiveTypeRequired: "Please select interactive type",
    templateHeader: "Header",
    templateHeaderPlaceholder: "Please enter header (optional)",
    templateBody: "Main Content",
    templateBodyRequired: "Please enter main content",
    templateBodyPlaceholder: "Please enter main content",
    templateFooter: "Footer Text",
    templateFooterPlaceholder: "Please enter footer text (optional)",
    templateLatitude: "Latitude",
    templateLatitudeRequired: "Please enter latitude",
    templateLatitudePlaceholder: "Please enter latitude",
    templateLongitude: "Longitude",
    templateLongitudeRequired: "Please enter longitude",
    templateLongitudePlaceholder: "Please enter longitude",
    templateLocationName: "Location Name",
    templateLocationNameRequired: "Please enter location name",
    templateLocationNamePlaceholder: "Please enter location name",
    templateLocationAddress: "Address",
    templateLocationAddressRequired: "Please enter address",
    templateLocationAddressPlaceholder: "Please enter complete address",
    templateContactName: "Contact Name",
    templateContactNameRequired: "Please enter contact name",
    templateContactNamePlaceholder: "Please enter contact name",
    templateContactPhone: "Contact Phone",
    templateContactPhoneRequired: "Please enter contact phone",
    templateContactPhonePlaceholder: "Please enter contact phone",
    templateContactEmail: "Contact Email",
    templateContactEmailPlaceholder: "Please enter contact email (optional)",
    templateVariables: "Variable Settings",
    templateVariableName: "Variable Name",
    templateVariableNamePlaceholder: "Variable name",
    templateVariableType: "Type",
    templateVariableTypePlaceholder: "Type",
    templateVariableDescription: "Description",
    templateVariableDescriptionPlaceholder: "Description",
    templateVariableRequired: "Required",
    templateAddVariable: "Add Variable",
    templateFromMetaImport: "Import from Meta",
    templateBatchDelete: "Batch Delete",
    templateWhatsAppMessageTemplateManagement: "WhatsApp Message Template Management",
    templateCopySuccess: "Template copy successful",
    templateCopyFailed: "Template copy failed",
    templateCopying: "Copying template...",
    templateSearchPlaceholder: "Search template name, description or category",
    templateCategorySelect: "Select Category",
    templateStatusSelect: "Select Status",
    templateClearFilter: "Clear Filter",
    templatePageRange: "Page",
    templatePageTotal: " items, total ",
    templatePageItems: " items",
    templateBasicInfo: "Basic Information",
    templateContent: "Template Content",
    templateVariableDefinition: "Variable Definition",
    templateWelcome: "Welcome",
    templateOrder: "Order",
    templateMarketing: "Marketing",
    templateSupport: "Support",
    templateGeneral: "General",
    templateMedia: "Media",
    templateInteractive: "Interactive",
    templateLocation: "Location",
    templateContact: "Contact",
    templateActive: "Active",
    templateInactive: "Inactive",
    templateDraft: "Draft",
    templateTraditionalChinese: "Traditional Chinese",
    templateSimplifiedChinese: "Simplified Chinese",
    templateEnglish: "English",
    templateString: "Text",
    templateNumber: "Number",
    templateDate: "Date",
    templateID: "ID",
    templateRefreshMetaTemplates: "Refresh Meta Templates",
    templateImportFromMeta: "Import Templates from Meta",
    templateImport: "Import",
    templateGetMetaTemplatesFailed: "Failed to get Meta templates",
    templateImportSuccess: "Template import successful",
    templateImportFailed: "Import failed",
    templateCreateMetaTemplateSuccess: "Meta template creation successful",
    templateCreateFailed: "Creation failed",
    templateDeleteMetaTemplateSuccess: "Meta template deletion successful",
    templateDeleteFailed: "Deletion failed",
    templateGetTemplateListFailed: "Failed to get template list",
    templatePleaseSelectTemplates: "Please select templates to delete",
    templateSuccessDelete: "Successfully deleted",
    templateTemplates: " templates",
    templateDeleteSuccess: "Template deletion successful",
    templateUpdateSuccess: "Template update successful",
    templateUpdateFailed: "Update failed",
    templateCreateSuccess: "Creation successful",
    templateCreateFailed: "Creation failed",
    templateSaveFailed: "Save failed",
    templateParseContentFailed: "Parse content failed",
    templateDeleteConfirmLocal: "Are you sure you want to delete this template?",
    preview: "Preview",
    edit: "Edit",
    copy: "Copy",
    delete: "Delete",
    category: "Category",
    type: "Type",
    status: "Status",
    updatedAt: "Updated Time",
    action: "Action",
    add: "Add",
    title: "Message Template Management",
    templateLanguage: "Template Language",
    templateVersion: "Template Version",
    
    // Meta Template related translations
    metaTemplate: {
      // Buttons and actions
      createMetaTemplate: "Create Meta Template",
      preview: "Preview",
      edit: "Edit",
      delete: "Delete",
      editTitle: "Edit Meta Template",
      update: "Update",
      updating: "Updating...",
      updateSuccess: "Meta template updated and resubmitted for review",
      updateFailed: "Update failed",
      confirm: "Confirm",
      cancel: "Cancel",
      insert: "Insert",
      search: "Search",
      refresh: "Refresh",
      clearFilter: "Clear Filter",
      submit: "Submit to Meta Review",
      
      // Format button tooltips
      boldTooltip: "Bold (*text*)",
      italicTooltip: "Italic (_text_)",
      strikethroughTooltip: "Strikethrough (~text~)",
      codeTooltip: "Code (```text```)",
      insertVariableTooltip: "Insert Variable",
      
      // Form labels
      templateName: "Template Name",
      category: "Category",
      language: "Language",
      headerOptional: "Media Example · Optional",
      headerNone: "None",
      headerText: "Text",
      headerImage: "Image",
      headerVideo: "Video",
      headerDocument: "Document",
      headerLocation: "Location (GPS)",
      locationHeaderHelp: "UTILITY / MARKETING only. You may create the template without coordinates; if you add a review sample, provide both latitude and longitude. Name and address are optional.",
      locationLatitude: "Latitude",
      locationLongitude: "Longitude",
      locationName: "Location name",
      locationAddress: "Address",
      locationLatitudePlaceholder: "e.g. 37.44216",
      locationLongitudePlaceholder: "e.g. -122.16153",
      locationNamePlaceholder: "e.g. Philz Coffee",
      locationAddressPlaceholder: "Optional full address",
      locationCoordsIncomplete: "If you enter a sample location, provide both latitude and longitude, or leave all fields empty.",
      locationLatitudeInvalid: "Latitude must be a number between -90 and 90.",
      locationLongitudeInvalid: "Longitude must be a number between -180 and 180.",
      locationOpenMap: "Open in map",
      locationPreviewHint: "If you saved sample coordinates when creating the template, they appear here in preview.",
      locationSearchPlaceholder: "Search place or address…",
      locationSearch: "Search",
      locationMapHint: "Map tiles: OpenStreetMap (free). Click the map to set a pin, or drag the pin to adjust. Search may fill name and address (Photon geocoder).",
      bodyContent: "Body Content",
      footerOptional: "Footer (Optional)",
      
      // Form hints and help
      templateNameHelp: "Only lowercase letters, numbers and underscores. On create, the system appends \"_\" plus a 12-character hex company id (total max 200 characters), so keep the base name at most 187 characters.",
      templateNameMaxBase: "Base name at most 187 characters (a suffix is added on create)",
      templateNamePlaceholder: "e.g.: welcome_message",
      categoryPlaceholder: "Select template category",
      languagePlaceholder: "Select language",
      headerPlaceholder: "e.g.: Important Notice",
      dragOrClickToUpload: "Drag and drop files to upload, or choose files from your device",
      imageUploadHint: "Supports JPG, PNG, GIF, BMP, WEBP formats",
      videoUploadHint: "Supports MP4, AVI, MOV, WMV formats",
      documentUploadHint: "Supports PDF, DOC, DOCX, TXT formats",
      orEnterUrl: "Or enter file URL",
      urlHelp: "If the file is already uploaded elsewhere, you can directly enter the URL",
      enterFileUrl: "Please enter file URL (e.g.: https://example.com/image.jpg)",
      fileUploadInDevelopment: "File upload feature is under development, please use URL method for now",
      pleaseUploadFileOrUrl: "Please upload a file or provide a file URL",
      dataUrlNotSupported: "Meta API does not accept data URL (base64) format, please use actual HTTP/HTTPS URL",
      urlMustBeHttp: "URL must be HTTP or HTTPS protocol",
      invalidUrlFormat: "Invalid URL format",
      uploadingFile: "Uploading file...",
      fileUploadFailed: "File upload failed",
      localhostNotAccessible: "Warning: Meta API cannot access localhost or local IP addresses. Please use a publicly accessible URL or upload the file to a public server.",
      bodyPlaceholder: "e.g.: Your order {{1}} has been confirmed\nAmount: *${{2}}*\nEstimated delivery: _{{3}}_",
      bodyHelp: "Supported formats: *bold* _italic_ ~strikethrough~ ```code```",
      footerPlaceholder: "e.g.: Thank you for using",
      
      // Status options
      approved: "Approved",
      pending: "Pending",
      rejected: "Rejected",
      paused: "Paused",
      
      // Category options
      marketing: "Marketing",
      utility: "Utility",
      authentication: "Authentication",
      marketingFull: "Marketing (MARKETING)",
      utilityFull: "Utility (UTILITY)",
      authenticationFull: "Authentication (AUTHENTICATION)",
      
      // Language options
      traditionalChinese: "Traditional Chinese",
      simplifiedChinese: "Simplified Chinese",
      english: "English",
      
      // Action confirmations
      deleteConfirmTitle: "Are you sure you want to delete this Meta template?",
      deleteConfirmDescription: "This action will permanently delete the template from Meta platform",
      
      // Button types
      quickReply: "Quick Reply",
      url: "URL",
      phoneNumber: "Phone",
      
      // Variable related
      addVariable: "Add Variable",
      insertVariable: "Insert Variable",
      variableType: "Variable Type",
      numberVariable: "Number Variable",
      nameVariable: "Named Variable",
      recommended: "Recommended",
      variableName: "Variable Name",
      variableNamePlaceholder: "e.g.: customer_name, order_id, amount",
      variableNameHelp: "Use lowercase letters and underscores, e.g.: customer_name",
      autoNumberHelp: "System will automatically find the next available number and insert it",
      
      // Titles and descriptions
      createTitle: "Create Meta Template",
      previewTitle: "Template Preview",
      insertVariableTitle: "Insert Variable",
      basicInfo: "Basic Information",
      contentComponents: "Content Components",
      buttonsOptional: "Buttons (Optional)",
      
      // Category descriptions
      categoryDescription: "Category Description (Meta will automatically adjust based on content):",
      marketingDescription: "Promotions, offers, new product recommendations, welcome messages",
      utilityDescription: "Order confirmations, shipping notifications, account updates, appointment reminders",
      authenticationDescription: "Only for OTP verification codes",
      utilityWarning: "Content must be transactional notifications, cannot contain promotional language, otherwise it will be changed to MARKETING",
      
      // Format help
      formatHelp: "WhatsApp formatting syntax:",
      formatExamples: "• *text* = bold • _text_ = italic • ~text~ = strikethrough • ```text``` = monospace font",
      variableHelp: "Use Add Variable button to insert {{1}} {{2}} etc. variables",
      
      // Button configuration
      buttonText: "Button Text",
      buttonTextPlaceholder: "Button Text",
      buttonType: "Button Type",
      urlPlaceholder: "https://example.com",
      phonePlaceholder: "+852 1234 5678",
      addButton: "Add Button",
      buttonCount: "Add Button ({count}/3)",
      
      // Variable examples
      variableExamples: "Variable Examples:",
      variableExampleLabel: "Example value for variable {{index}}",
      variableExamplePlaceholder: "e.g.: John, 12345, etc.",
      
      // Search and filter
      searchPlaceholder: "Search template name",
      selectStatus: "Select Status",
      selectCategory: "Select Category",
      selectLanguage: "Select Language",
      query: "Query",
      
      // Tip cards
      metaOfficialTemplates: "Meta Official Templates:",
      metaDescription: "Need to be submitted to Meta for review, can only be used after approval.",
      applicableScenarios: "Applicable Scenarios:",
      applicableScenariosDesc: "Proactively send marketing campaigns, order notifications, customer service messages",
      sessionWindow: "24-hour Conversation Window Limit:",
      withinWindowLabel: "Within Window",
      withinWindow: " (within 24 hours of customer's last message): Can send any message (template or free format)",
      outsideWindowLabel: "Outside Window",
      outsideWindow: " (over 24 hours): Can only send approved template messages",
      tip: "Tip:",
      tipDescription: "It is recommended to pre-create and review templates for common scenarios, so you can proactively contact customers at any time",
      
      // Status labels
      statusApproved: "Approved",
      statusPending: "Pending",
      statusRejected: "Rejected",
      statusPaused: "Paused",
      
      // Language labels
      langTraditionalChinese: "Traditional Chinese",
      langSimplifiedChinese: "Simplified Chinese",
      langEnglish: "English",
      
      // Category labels
      categoryMarketing: "Marketing",
      categoryUtility: "Utility",
      categoryAuthentication: "Authentication",
      
      // Basic info
      basicInfoTitle: "Basic Information",
      templateContent: "Template Content",
      
      // Operation results
      submitSuccess: "Meta template submitted for review!",
      submitFailed: "Submit failed",
      deleteSuccess: "Meta template deleted",
      deleteFailed: "Delete failed",
      loading: "Submitting to Meta review...",
      deleting: "Deleting...",
      
      // Form validation
      nameRequired: "Please enter template name",
      namePattern: "Only lowercase letters, numbers and underscores allowed",
      categoryRequired: "Please select category",
      languageRequired: "Please select language",
      bodyRequired: "Please enter body content",
      
      // Table column titles
      templateName: "Template Name",
      category: "Category",
      language: "Language",
      reviewStatus: "Review Status",
      metaId: "Meta ID",
      updatedTime: "Updated",
      action: "Action",
      
      // Status text
      approved: "Approved",
      pending: "Pending",
      rejected: "Rejected",
      paused: "Paused",
      
      // Category text
      marketing: "Marketing",
      utility: "Utility",
      authentication: "Authentication",
      
      // Language text
      traditionalChinese: "Traditional Chinese",
      simplifiedChinese: "Simplified Chinese",
      english: "English",
      
      // Error and warning messages
      cannotGetInputElement: "Cannot get input element, please try again",
      pleaseSelectTextToFormat: "Please select text to format first",
      cannotInsertVariable: "Cannot insert variable, please try again",
      pleaseEnterVariableName: "Please enter variable name",
      maxButtonsWarning: "Maximum 3 buttons allowed",
      variableInserted: "Variable inserted",
      
      // Character count
      characters: "characters",
      
      // Category descriptions
      categoryDescriptionTitle: "Category Description (Meta will automatically adjust based on content):",
      marketingDescription: "Promotions, offers, new product recommendations, welcome messages",
      utilityDescription: "Order confirmations, shipping notifications, account updates, appointment reminders",
      authenticationDescription: "Only for OTP verification codes",
      utilityWarning: "Content must be transactional notifications, cannot contain promotional language, otherwise it will be changed to MARKETING",
      
      // Variable examples
      variableExamples: "Variable Examples:",
      variableExampleLabel: "Example value for variable {{index}}",
      variableExamplePlaceholder: "e.g.: John, 12345, etc.",
      
      // Preview template
      name: "Name:",
      category: "Category:",
      language: "Language:",
      status: "Status:",
      
      // Variable type descriptions
      autoNumberDescription: "Auto numbering:",
      customNameDescription: "Custom name:",
      metaStandardFormat: "Suitable for Meta official templates, complies with WhatsApp standard format",
      moreReadable: "More readable, but requires correct variable name mapping when sending",
      
      // Total display
      totalTemplates: "Total {count} templates",
      pageRange: "Page ",
      total: " templates",
      
      // Error messages
      validationFailed: "Validation failed",
      createFailed: "Create failed",
      
      // Example value
      exampleValue: "Example value {index}",
      
      // Rejection reason related
      rejectionReason: "Rejection Reason:",
      apiNoRejectionReason: "API did not provide rejection reason",
      apiLimitationNote: "Due to Meta API limitations, detailed rejection reasons cannot be retrieved.",
      suggestion: "Suggestion:",
      suggestionText: "Please modify template content based on common rejection reasons and resubmit. You can delete this template and create a new version.",
      commonRejectionReasons: "Common Rejection Reasons:",
      floatingParameters: "Floating Parameters:",
      floatingParametersDesc: "Parameters lack sufficient contextual description",
      marketingContent: "Marketing Content:",
      marketingContentDesc: "Content is too commercial or exaggerated",
      policyViolation: "Policy Violation:",
      policyViolationDesc: "Content violates WhatsApp policies",
      wrongCategory: "Wrong Category:",
      wrongCategoryDesc: "Selected incorrect template category",

      // Official Template Library
      fromLibrary: "Create from Official Library",
      libraryTitle: "Meta Official Template Library",
      libraryHint: "Select a template from Meta's official library. Once created, it becomes your custom template and will be submitted for review.",
      librarySearchPlaceholder: "Search template name…",
      libraryTopic: "Topic",
      libraryUsecase: "Use Case",
      libraryIndustry: "Industry",
      libraryLanguage: "Language",
      libraryApplyFilters: "Filter",
      libraryEmpty: "No templates match the criteria",
      libraryUse: "Create",
      libraryLoadFailed: "Failed to load template library",
      libraryCreateSuccess: "Template created from library",
      noData: "No templates"
    },
    
    // WhatsApp template list page
    templateList: {
      internalTemplates: "Internal Templates",
      metaOfficialTemplates: "Meta Official Templates",
      description: "Manage WhatsApp message templates: Internal templates are used for rapid iteration, Meta official templates are used for formal marketing activities"
    },
    
    // Missing translation keys
    categorySelect: "Select Category",
    statusSelect: "Select Status",
    confirmDelete: "Confirm Delete",
    templateConfirmDeleteSelected: "Are you sure you want to delete the selected",
    templateConfirmDeleteSelectedSuffix: " templates? This action cannot be undone.",
    addTitle: "Add Template",
    nameRequired: "Please enter template name",
    namePlaceholder: "Please enter template name",
    descriptionPlaceholder: "Please enter template description (optional)",
    categoryRequired: "Please select category",
    categoryPlaceholder: "Please select category",
    welcome: "Welcome",
    order: "Order",
    marketing: "Marketing",
    support: "Support",
    general: "General",
    typeRequired: "Please select template type",
    typePlaceholder: "Please select template type",
    media: "Media",
    pleaseEnterMessageContent: "Please enter message content",
    pleaseEnterMessageContentWithVariables: "Please enter message content, you can use {{variable_name}} format to insert variables",
    statusRequired: "Please select status",
    statusPlaceholder: "Please select status",
    language: "Language",
    languageRequired: "Please select language",
    languagePlaceholder: "Please select language",
    traditionalChinese: "Traditional Chinese",
    simplifiedChinese: "Simplified Chinese",
    english: "English",
    searchAddress: "Search Address",
    enterAddressToSearch: "Enter address or place name to search",
    selectThisLocation: "Select This Location",
    confirm: "Confirm",
    cancel: "Cancel",
    save: "Save",
    
    // Map related translations
    searchMapContainerInUse: "Search map container is in use, cleaning up...",
    searchMapContainerCleanupWarning: "Warning while cleaning up search map container:",
    searchMap: "Search Map",
    mainMap: "Main Map",
    mapContainerInUse: "Map container is in use, cleaning up...",
    mapContainerCleanupWarning: "Warning while cleaning up map container:",
    mapInitializing: "Map is initializing, skipping duplicate initialization",
    cannotGetCurrentLocation: "Cannot get current location, please select manually",
    browserNotSupportGeolocation: "Your browser does not support geolocation",
    unknownLocation: "Unknown location",
    reverseGeocodeFailed: "Reverse geocoding failed:",
    addressSearchSuccess: "Address search successful",
    noAddressFound: "No address found",
    searchFailed: "Search failed, please try again later",
    addressSearchFailed: "Address search failed:",
    getLocationFailed: "Failed to get location:",
    saveTemplateError: "Save template error:",
    
    // Button configuration related translations
    buttonConfiguration: "Button Configuration",
    maxButtonsLimit: "Maximum 3 buttons allowed",
    addButton: "Add Button",
    maxThreeButtons: "Maximum 3 buttons",
    buttonText: "Button Text {index}",
    pleaseEnterButtonText: "Please enter button text",
    buttonType: "Button Type",
    pleaseSelectButtonType: "Please select button type",
    quickReply: "Quick Reply",
    replyId: "Reply ID",
    pleaseEnterReplyId: "Please enter reply ID",
    replyIdPlaceholder: "Reply ID (used to identify user selection)",
    
    // List configuration related translations
    listOptionsConfiguration: "List Options Configuration",
    listTitle: "List Title",
    pleaseEnterListTitle: "Please enter list title",
    maxOptionsLimit: "Maximum 10 options allowed",
    addOption: "Add Option",
    maxTenOptions: "Maximum 10 options",
    optionId: "Option {index} ID",
    pleaseEnterOptionId: "Please enter option ID",
    optionTitle: "Option Title",
    pleaseEnterOptionTitle: "Please enter option title",
    optionDescription: "Option Description",
    optionDescriptionOptional: "Option Description (optional)",
    
    // Product configuration related translations
    productConfiguration: "Product Configuration",
    productId: "Product ID",
    pleaseEnterProductId: "Please enter product ID",
    productCatalogId: "Product Catalog ID",
    pleaseEnterProductCatalogId: "Please enter product catalog ID",
    pleaseEnterFacebookProductCatalogId: "Please enter Facebook product catalog ID",
    productImageUrl: "Product Image URL",
    pleaseEnterProductImageUrl: "Please enter product image URL",
    
    // Copy related translations
    copy: "Copy",
    
    // Additional missing translation keys
    mediaType: "Media Type",
    interactiveType: "Interactive Type",
    header: "Header",
    body: "Main Content",
    footer: "Footer Text",
    mapSelection: "Map Selection",
    getCurrentLocation: "Get Current Location",
    advancedSearch: "Advanced Search",
    contactName: "Contact Name",
    contactPhone: "Contact Phone",
    contactEmail: "Contact Email",
    pleaseSelectMediaType: "Please select media type",
    pleaseSelectInteractiveType: "Please select interactive type",
    pleaseEnterHeader: "Please enter header (optional)",
    pleaseEnterMainContent: "Please enter main content",
    pleaseEnterFooter: "Please enter footer text (optional)",
    pleaseEnterContactName: "Please enter contact name",
    pleaseEnterContactPhone: "Please enter contact phone",
    pleaseEnterContactEmail: "Please enter contact email (optional)",
    searchAddressOrDragMarker: "Search address or drag marker to suitable position",
    mediaFileUrl: "Media File URL",
    pleaseEnterMediaFileUrl: "Please enter media file URL",
    mediaCaption: "Media Caption",
    pleaseEnterMediaCaption: "Please enter media caption (optional)",
    mainContent: "Main Content",
    product: "Product",
    pleaseEnterLatitude: "Please enter latitude",
    pleaseEnterLongitude: "Please enter longitude",
    pleaseEnterLocationName: "Please enter location name",
    pleaseEnterCompleteAddress: "Please enter complete address",
    locationName: "Location Name",
    
    // Template Variable Configuration
    templateVariables: 'Template Variables',
    metaTemplateVariableHint: 'Meta Template Variable Configuration',
    metaTemplateVariableDescription: 'Meta official templates use numeric parameters (1, 2, 3...) or named parameters. Please configure the corresponding variable source according to the template definition.',
    addTemplateVariable: 'Add Template Variable',
    parameterName: 'Parameter Name',
    metaParameterHint: 'Meta template parameters: Use numbers (1, 2, 3...) or variable names (customer_name, order_id)',
    processVariable: 'Process Data',
    selectVariable: 'Select Variable',
    selectedVariable: 'Selected: {variableName}'
  },
  
      // WhatsApp Workflow Designer
  workflowDesigner: {
    title: 'Workflow Designer',
    workflowInfo: 'Workflow Information',
    workflowName: 'Workflow Name',
    workflowDescription: 'Workflow Description',
    workflowNamePlaceholder: 'Please enter workflow name',
    workflowDescriptionPlaceholder: 'Please enter workflow description',
    nodeTypes: 'Node Types',
    loadingNodeTypes: 'Loading node types...',
    nodeConfiguration: 'Node Configuration',
    connection: 'Connection',
    node: 'Node',
    flow: 'Flow',
    startNode: 'Start Node',
    endNode: 'End Node',
    waitReplyNode: 'Wait Reply Node',
    waitForQRCodeNode: 'Wait for QR Code Node',
    waitForLocationNode: 'Request Geolocation',
    waitForEmailReplyNode: 'Wait for Email Reply Node',
    waitForEmailReplyAutoCompleteTitle: 'Timeout Auto Complete (Wait for Email Reply only)',
    waitForEmailReplyAutoCompleteEnable: 'Enable timeout auto complete',
    waitForEmailReplyAutoCompleteTimeout: 'Auto complete timeout',
    switchNode: 'Switch Node',
    sendMessageNode: 'Send Message Node',
    sendWhatsAppNode: 'Send Message Node',
    sendTemplateNode: 'Send Template Node',
    shoppingCartNode: 'WhatsApp Shopping Cart',
    sendInstitutionOrderingCartNode: 'Institution Ordering Cart',
    institutionOrderingCartNode: 'Institution Ordering Cart',
    chatOrderingCartNode: 'Chat Shopping Cart',
    chatBotNode: 'Chat Bot',
    chatBotInitialGreeting: 'Initial Greeting',
    chatBotInitialGreetingPlaceholder: 'e.g. Hi! How can I help you today?',
    chatBotGreetingEnabled: 'Send Initial Greeting',
    chatBotGreetingEnabledHelp: 'When off, no greeting message will be sent when entering the waiting state. Useful for flows where users typically send a photo or message right away.',
    chatBotEndKeywords: 'End chat (similar phrases)',
    chatBotEndKeywordsPlaceholder: 'Press Enter to add reference phrases. AI matches by meaning; examples: bye, thanks, stop, cancel',
    chatBotEndMessageEnabled: 'Send End Message',
    chatBotEndMessageEnabledHelp: 'When off, no end message will be sent when the chat ends (including system defaults and timeout messages).',
    chatBotEndMessage: 'End Message',
    chatBotEndMessageHelp: 'Sent to the user when the chat ends via keyword or timeout. Leave blank to use the system default.',
    chatBotEndMessagePlaceholder: 'e.g. Thank you for reaching out. Feel free to contact us again anytime.',
    chatBotRagAdditionalQuery: 'RAG Additional Query',
    chatBotRagAdditionalQueryHelp: 'Appended to the user message when querying the knowledge base. Helps surface specific KB chunks (e.g. identity lookup tables). Leave blank to use the user message only.',
    chatBotRagAdditionalQueryPlaceholder: 'e.g. identity user profile tenant',
    chatBotAdditionalPrompt: 'Additional Prompt',
    chatBotAdditionalPromptHelp: 'Appended to the default Chat Bot system prompt. It does not replace the appsettings system prompt.',
    chatBotAdditionalPromptPlaceholder: 'Extra behavior or answer style instructions, e.g. always answer with concise bullet points.',
    chatBotSystemPromptOverride: 'System Prompt Override',
    chatBotSystemPromptOverridePlaceholder: 'Leave blank to use defaults from appsettings',
    chatOrderingCartTargetCompany: 'Target Company',
    chatOrderingCartProductLanguage: 'Product Language',
    chatOrderingCartProductNlFilterFields: 'Natural Language Product Filter Fields',
    chatOrderingCartProductNlFilterFieldsHelp: 'Select one or more product fields. Each turn, the system matches existing values of these fields against the user\'s message and sends only matching products to the AI, saving tokens. Falls back to full catalog if nothing matches. Leave empty to disable filtering.',
    chatOrderingCartProductNlFilterName: 'Product Name (Name)',
    chatOrderingCartProductNlFilterProductType: 'Product Type (ProductType)',
    chatOrderingCartProductNlFilterBrand: 'Brand',
    chatOrderingCartProductNlFilterGoogleCategory: 'Google Product Category',
    chatOrderingCartProductNlFilterFbCategory: 'Facebook Product Category',
    chatOrderingCartProductNlFilterCustomLabel0: 'Custom Label (CustomLabel0)',
    chatOrderingCartInitialGreeting: 'Initial Greeting',
    chatOrderingCartInitialGreetingPlaceholder: 'e.g. Hi! Tell me what you want to order.',
    chatOrderingCartReconfirmQuestion: 'Reconfirm Question',
    chatOrderingCartReconfirmQuestionPlaceholder: 'e.g. Anything else?',
    chatOrderingCartMissingInfoExtra: 'Missing Info Prompt Extra',
    chatOrderingCartAdditionalPrompt: 'Additional Prompt',
    chatOrderingCartAdditionalPromptHelp: 'Appended to the default Chat Shopping Cart system prompt. It does not replace the appsettings system prompt.',
    chatOrderingCartAdditionalPromptPlaceholder: 'Extra ordering rules or answer style instructions, e.g. copy addresses, phone numbers, and amounts exactly.',
    chatOrderingCartEndKeywords: 'End chat (similar phrases)',
    chatOrderingCartEndKeywordsPlaceholder: 'Press Enter to add reference phrases (Chinese/English). AI matches by meaning; examples: cancel, stop ordering, 取消, 不訂了',
    chatOrderingCartBtnConfirmLabel: 'Confirm Button Label',
    chatOrderingCartBtnModifyLabel: 'Modify Button Label',
    chatOrderingCartBtnCancelLabel: 'Cancel Button Label',
    chatOrderingCartSystemPromptOverride: 'System Prompt Override',
    chatOrderingCartSystemPromptOverridePlaceholder: 'Leave blank to use defaults from appsettings',
    chatOrderingCartContactAndAnonymous: 'Contact & Anonymous',
    chatOrderingCartAllowAnonymousOrder: 'Allow anonymous order',
    chatOrderingCartAllowAnonymousOrderHelp: 'When on, orders are accepted even if the WhatsApp number is not linked to a contact (CustomerId left empty, flagged as anonymous). When off, the WhatsApp number must be authorized for at least one customer via PWA contact settings.',
    conditionNode: 'Condition Node',
    formNode: 'Form Node',
    generateHtmlReportNode: 'Generate HTML Report',
    generateDocumentNode: 'Generate Document',
    calendarNode: 'Calendar',
    defaultCalendarNode: 'Calendar Schedule',
    calendar: {
      generationMode: 'Data Source / Integration Mode',
      additionalPrompt: 'Additional Prompt (how AI should plan the schedule)',
      additionalPromptPlaceholder: 'e.g. Every 2nd Wednesday at 09:00 schedule routine inspection work',
      fillCalendarAdditionalPrompt: 'Fill Calendar Additional Prompt',
      fillCalendarAdditionalPromptPlaceholder: 'e.g. Expand the contract period into specific events month by month',
      calendarCommandVariable: 'Save command JSON to Process Data',
      defaultWorkflowDefinitionLinkage: 'Default-link events to the current workflow definition',
      dryRun: 'Validate only, do not write (Dry Run)',
      failOnValidationError: 'Fail node when any command fails validation',
      manualStartInputMode: 'Manual-start data source',
      manualStartInputModeBody: 'Use InputJson body',
      manualStartInputModeAttachment: 'Use attachments',
      manualStartInputModeBoth: 'Both',
      // Two-stage AI: analysis window + current snapshot
      snapshotSection: 'Analysis window & current snapshot',
      snapshotHelp: 'Two-stage AI: stage 1 derives the analysis window (from/to/timezone); the backend then loads existing events for that window in the same workflow definition; stage 2 generates commands while avoiding conflicts.',
      disableTwoStage: 'Disable two-stage AI (use default window)',
      windowDefaults: 'Default analysis window (fallback when AI does not provide one)',
      windowMaxes: 'Max allowed analysis window',
      analysisLookBackDaysDefault: 'Default look-back days (from = now - N)',
      analysisLookAheadDaysDefault: 'Default look-ahead days (to = now + N)',
      analysisLookBackDaysMax: 'Max look-back days',
      analysisLookAheadDaysMax: 'Max look-ahead days',
      snapshotLimits: 'Snapshot size limits',
      snapshotMaxEvents: 'Snapshot max events',
      snapshotMaxEventsHelp: 'When exceeded, only perDayCount stats are sent (events array dropped) to avoid token blowup.',
      snapshotIncludeEvents: 'Include event details (events array)',
      snapshotIncludeEventsHelp: 'When off, only per-day counts (perDayCount) are sent — most token-efficient.',
      resourceContactRefs: 'Resource Contact Identifiers',
      resourceContactRefsHelp: 'One identifier per line (or comma-separated). The system tries to match a Contact:\n• Phone number (e.g. 85296366318)\n• Email (e.g. user@example.com)\n• {{initiator}} — automatically use the flow initiator\n\nMatched → added to event Resources; not found → a note is appended to Description, event is still created.',
      resourceContactRefsPlaceholder: 'One per line, e.g.:\n85296366318\nuser@example.com\n{{initiator}}',
      defaultEventTypeRef: 'Default Event Type Name',
      defaultEventTypeRefsHelp: 'Enter the exact name of an existing calendar event type.\n• If the AI command does not specify eventTypeId, the backend resolves and injects this type automatically.\n• If the AI explicitly picks a type in the additional prompt, the AI\'s choice takes priority.\n• Not found → no error, eventTypeId is left blank or decided by AI.\n• All available type names are injected into the AI context so you can reference them by name in the additional prompt.',
      defaultEventTypeRefPlaceholder: 'e.g. Leave Application',
    },
    odooNode: 'Odoo',
    defaultOdooNode: 'Odoo ERP',
    odoo: {
      tabData: 'Operation',
      tabMode: 'Generation Mode',
      tabMapping: 'Field Mapping',
      tabResult: 'Result & Behavior',
      intro: 'Odoo 19 ERP integration. First add the odoo provider under API Provider Management → ERP Systems and activate it.',
      apiProviderKey: 'Odoo Provider',
      apiProviderKeyTip: 'Maps to API Provider Management → ERP Systems → odoo. For multi-Odoo setups, change to a different provider key.',
      operationType: 'Operation Type',
      generationMode: 'Generation Mode',
      modeFormBased: 'Form mode (manual field mapping)',
      defaultCompanyId: 'Default Company ID',
      defaultCompanyIdTip: 'For multi-company environments, forces Odoo context.allowed_company_ids; leave empty for single-company.',
      autoConfirm: 'Auto button_confirm after create',
      autoPost: 'Auto action_post after create',
      autoValidate: 'Auto button_validate after create',
      autoValidateTip: 'Requires inventory availability; otherwise keep off and let humans confirm in Odoo.',
      mappingHelp: 'Form mode: map Process Data / static values / expressions to OdooOperation fields (e.g. partner.name, lines[0].product.code, lines[0].qty).',
      mappingHelpForm: 'Form mode: map upstream sendEForm fields / Process Data / static values to Odoo fields (partner.id, partner.name, lines[0].product.code, lines[0].qty…). Empty mappedFields falls back to AI.',
      mappingHelpDataSet: 'DataSet mode: scope=master uses the first row, scope=line repeats each row into lines[]. Empty mappedFields falls back to AI.',
      mappingEmptyHint: 'No mapping yet — AI will parse the whole batch. Prefer explicit mappings when fields are known.',
      mappingOdooField: 'Odoo Field Path',
      mappingSourceType: 'Source',
      mappingSourceValue: 'Value',
      mappingAdd: 'Add field mapping',
      scope: 'Scope',
      scopeMaster: 'master',
      scopeLine: 'line',
      sourceEFormField: 'eForm field',
      sourceDatasetColumn: 'DataSet column',
      sourceVariable: 'Process Data',
      sourceStatic: 'Static',
      sourceExpressionLegacy: 'Expression (deprecated)',
      sourceEFormFieldPlaceholder: 'Pick eForm field…',
      sourceDatasetColumnPlaceholder: 'Pick DataSet column…',
      sourceVariablePlaceholder: 'Pick Process Data…',
      sourceStaticPlaceholder: 'Static value',
      expressionDeprecatedTag: 'deprecated',
      selectUpstreamEForm: 'Upstream sendEForm node',
      selectUpstreamEFormTip: 'Points to the filled eForm instance; its fields are used as mapping value source.',
      selectUpstreamEFormPlaceholder: 'Pick upstream sendEForm…',
      noUpstreamEForm: 'No sendEForm node on canvas. Add one with a formId first.',
      schemaPanelMissing: 'No cheat-sheet for this operation',
      schemaPath: 'Path / Label',
      schemaTip: 'Notes',
      schemaMaster: 'Master fields',
      schemaLines: 'Line fields (repeated per row)',
      schemaFk: 'FK references',
      schemaExample: 'Example JSON',
      schemaTips: 'Tips',
      requiredTag: 'required',
      fkTag: 'FK',
      promptFieldPickerButton: 'Insert Odoo field',
      promptFieldPickerInsert: 'Insert at cursor',
      promptFieldPickerInsertBtn: 'add',
      promptFieldPickerSearch: 'Search path / label…',
      promptFieldPickerMaster: 'Master',
      promptFieldPickerLines: 'Lines',
      promptFieldPickerFk: 'FK refs',
      promptFieldPickerSchema: 'Full schema',
      promptFieldPickerEmpty: 'No fields',
      promptFieldPickerNoProvider: 'Set the Odoo provider key to load the full schema',
      promptFieldPickerSchemaEmpty: 'fields_get is empty',
      commandVariable: 'Save command JSON to Process Data',
      commandVariableTip: 'Optional. Stores the final commands JSON sent to Odoo.',
      resultVariable: 'Save Odoo execution report to Process Data',
      resultVariableTip: 'Stores the OdooCommandExecutionReport (with each doc id / state).',
      fillOdooAdditionalPrompt: 'Fill Odoo additional prompt',
      fillOdooAdditionalPromptPlaceholder: 'e.g. Parse the supplier name, SKU and 5 line items from the PDF',
      op: {
        createPO: 'Create Purchase Order',
        createQuotation: 'Create Quotation (draft SO)',
        createSO: 'Create & confirm Sales Order',
        confirmSO: 'Confirm Sales Order',
        createInvoice: 'Create Invoice',
        postInvoice: 'Post Invoice',
        createDeliveryNote: 'Create Delivery Note',
        createGoodsReceive: 'Create Goods Receipt',
        createReturn: 'Create Return',
        createCreditNote: 'Create Credit Note',
        registerPayment: 'Register Payment',
        lookupPartner: 'Lookup Partner',
        lookupProduct: 'Lookup Product',
        lookupStock: 'Lookup Stock'
      }
    },
    webhookNode: 'Webhook Node',
    callApiNode: 'Trigger External API Node',
    dataSetQueryNode: 'DataSet Query Node',
    sendEFormNode: 'Send eForm',
    sendEmail: 'Send Email',

    copyNodes: 'Copy nodes',
    pasteNodes: 'Paste nodes',
    editConditionGroup: 'Edit condition group',
    groupRelation: 'Group relation',
    groupRelationRequired: 'Please select group relation',
    outputPathRequired: 'Please select output path',
    noConditions: 'No conditions',

    tabDesign: 'Flow Design',
    exportFlowJson: 'Export flow JSON',
    importFlowJson: 'Import flow JSON',
    exportFlowJsonSuccess: 'JSON file exported',
    exportFlowJsonFailed: 'Export failed',
    importFlowJsonSuccess: 'Flow imported',
    importFlowJsonFailed: 'Import failed',
    importFlowJsonInvalidFile: 'Please select a .json file',
    importFlowJsonConfirmTitle: 'Replace current flow?',
    importFlowJsonConfirmContent: 'You have unsaved changes. Importing will replace the canvas. Continue?',
    importFlowJsonConfirmOk: 'Import',
    importFlowJsonConfirmCancel: 'Cancel',
    tabAIAssistant: 'AI Flow Assistant',
    aiChat: {
      placeholder: 'e.g. Start by sending WhatsApp, then wait for reply, then end',
      includeCurrentFlow: 'Include current flow',
      pleaseEnterPrompt: 'Please enter a flow description',
      generationFailed: 'Generation failed',
      schemaValidationFailed: 'Flow format validation failed: ',
      logicValidationFailed: 'Flow logic validation failed: ',
      applied: 'Flow applied',
      updated: 'Flow updated according to your request',
      restored: 'Restored to this version',
      restoreFailed: 'Restore failed',
      restoreToThisVersion: 'Restore to this version',
      emptyHint: 'Enter a flow description and AI will help generate or modify the flow',
      saveHint: 'After saving the flow, chat history will be stored',
      chatSaveFailed: 'Failed to save chat history',
      timeout: 'AI generation timed out. Please retry or shorten the description.',
      generatingHint: 'This may take 15–60 seconds, please wait'
    },
    
    // DataSet node related translations
    dataSet: {
      selectDataSet: 'Select DataSet',
      selectDataSetPlaceholder: 'Select DataSet to operate',
      operationType: 'Operation Type',
      operationTypePlaceholder: 'Please select operation type',
      select: 'SELECT',
      insert: 'INSERT',
      update: 'UPDATE',
      delete: 'DELETE',
      queryConditions: 'Query Conditions',
      addQueryConditionGroup: 'Add Query Condition Group',
      editQueryConditionGroup: 'Edit Query Condition Group',
      queryConditionGroup: 'Query Condition Group',
      conditionRelation: 'Condition Relation',
      conditionRelationPlaceholder: 'Please select condition relation',
      and: 'AND',
      or: 'OR',
      andDescription: 'All conditions must be satisfied',
      orDescription: 'Any condition can be satisfied',
      cancel: 'Cancel',
      add: 'Add',
      update: 'Update',
      selectDataSetField: 'Select DataSet Field',
      selectDataSetFieldPlaceholder: 'Please select DataSet field',
      operator: 'Operator',
      operatorPlaceholder: 'Please select operator',
      conditionValue: 'Condition Value',
      conditionValueSource: 'Condition Value Source',
      fixedValue: 'Fixed Value',
      selectVariable: 'Select Variable',
      userNaturalLanguage: 'Search by Natural Language',
      conditionValuePlaceholder: 'Please enter condition value',
      nlModeDescription: 'The system extracts keywords from [User] messages in the conversation and matches them against existing values of this field, then auto-applies the matched values as a filter. E.g. if the user says "Completed Lang Ching Kui today", the system finds "Lang Ching Kui" and returns only matching records.',
      nlFallback: 'When No Match Found',
      nlFallbackKeepAll: 'Skip this condition (keep all records)',
      nlFallbackReturnEmpty: 'Force return empty result',
      nlMinFieldLength: 'Min. field value length',
      nlMinFieldLengthHint: 'Field values shorter than this are excluded from matching to avoid false positives from single-character fields. Default: 2.',
      conditionValueInputPlaceholder: 'Enter condition value, Process Data ${variableName} can be used',
      conditionLabel: 'Condition Label',
      conditionLabelPlaceholder: 'Optional condition description label',
      availableProcessVariables: 'Available Process Data',
      clickVariableToInsert: 'Click variable name to insert into condition value',
      editQueryCondition: 'Edit Query Condition',
      noDataSetFields: 'No DataSet fields',
      conditionCount: 'Condition Count',
      qrCodeSuccessMessage: 'QR Code scanned successfully! Process will continue.',
      qrCodeErrorMessage: 'Unable to process your uploaded image, please upload again.',
      template: 'Template',
      close: 'Close',
      testQuery: 'Test Query',
      queryResultDescription: 'Query results based on input simulation data (first 10 records):',
      noQueryResultData: 'No query result data',
      totalRecords: 'Total {count} records',
      pvSimulationDataHelp: 'Enter test values and click "Test Query" to view results',
      addCondition: 'Add Condition',
      operationData: 'Operation Data',
      setOperationData: 'Set Operation Data',
      fieldMapping: 'Field Mapping',
      setFieldMapping: 'Set Field Mapping',
      selectDataSetField: 'Select DataSet Field',
      selectProcessVariable: 'Select Process Data',
      selectValueSource: 'Select Process Data or eForm field',
      processVariables: 'Process Data',
      eFormFields: 'eForm Fields',
      noProcessVariables: 'No Process Data',
      addFieldMapping: 'Add Field Mapping',
      noFieldMapping: 'No field mapping',
      noOperationData: 'No operation data settings',
      fieldMappingSaved: 'Field mapping saved successfully',
      fieldMappingSaveFailed: 'Failed to save field mapping',
      operationDataSaved: 'Operation data settings saved successfully',
      operationDataSaveFailed: 'Failed to save operation data settings',
      queryConditionGroupSaved: 'Query condition group saved successfully',
      queryConditionGroupSaveFailed: 'Failed to save query condition group',
      queryConditionSaved: 'Query condition saved successfully',
      queryConditionSaveFailed: 'Failed to save query condition',
      loadDataSetListFailed: 'Failed to load DataSet list',
      loadDataSetColumnsFailed: 'Failed to load DataSet columns',
      loadProcessVariablesFailed: 'Failed to load Process Data',
      testOperation: 'Test Operation',
      testQuery: 'Test Query',
      testOperationFailed: 'Test operation failed',
      testConfigSuccess: 'Test configuration successful! Please enter simulation data in the popup to test query.',
      pleaseSelectDataSet: 'Please select DataSet first',
      pleaseSelectDataSetAndOperation: 'Please select DataSet and operation type first',
      queryResultPreview: 'DataSet Query Result Preview',
      pvSimulationData: 'PV Simulation Data',
      pvSimulationDataDescription: 'Enter test values for Process Data in query conditions:',
      pvSimulationDataHelp: 'Click "Test Query" after entering test values to view results',
      queryResultDescription: 'Query results based on input simulation data (first 10 records):',
      noQueryConditions: 'No query conditions',
      fieldMappingDescription: 'Select DataSet fields and corresponding variables from existing Process Data, query results will be automatically mapped to Process Data',
      operationDataDescription: 'Select DataSet fields and corresponding values from Process Data or eForm fields, INSERT/UPDATE operations will write the selected values to DataSet fields',
      jsonPvMapping: 'JSON Process Data Mapping',
      jsonKeyPlaceholder: 'Enter JSON key name (e.g., amount, status, date)',
      jsonKeyDescription: 'When the Process Data is JSON type, enter the JSON key name to extract. The system will extract the value of that key from the JSON object and write it to the DataSet field.',
      fixedColumn: 'Fixed Column',
      dynamicColumnName: 'Dynamic Column Name',
      selectDynamicColumnSource: 'Select PV or eForm field (value must be a valid column name)',
      dynamicColumnJsonKey: 'Dynamic Column Name JSON Key',
      dynamicColumnJsonKeyPlaceholder: 'Enter JSON key (resolved value must be a DataSet column name)',
      dynamicColumnJsonKeyDescription: 'When the source is a JSON type Process Data, enter the key to extract. The result must be a valid DataSet column name.',
      fieldMappingSummary: 'Set {count} field mappings',
      operationDataSummary: 'Set {count} field mappings',
      clickToSetFieldMapping: 'Click the button above to set DataSet field to Process Data mapping relationship',
      generatedWhereClause: 'Generated WHERE Clause',
      operationPreview: 'Operation Preview',
      pleaseSelectDataSetAndOperationType: 'Please select DataSet and operation type first',
      pleaseSelectOperationType: 'Please select operation type first',
      pleaseSelectDataSet: 'Please select DataSet first',
      operationData: 'Operation Data',
      fieldMapping: 'Field Mapping',
      noOperationData: 'No operation data',
      noFieldMapping: 'No field mapping',
      queryTopRows: 'Row Limit (TOP)',
      queryTopRowsPlaceholder: 'e.g. 1, 10, 100',
      queryTopRowsHelp: 'Leave blank for no limit',
      orderByFields: 'Sort Fields (ORDER BY)',
      noOrderByFields: 'No sort fields configured',
      addOrderByField: 'Add Sort Field',
      selectOrderByField: 'Select sort field',
      orderAsc: 'Ascending ASC',
      orderDesc: 'Descending DESC'
    },
    
    eFormResultNode: 'eForm Result Node',
    defaultStartNode: 'Start',
    statusEnabled: 'Enabled',
    taskName: 'Task Name',
    taskNameLabel: 'Task Name',
    taskNamePlaceholder: 'Please enter task name',
    phoneNumberPlaceholder: 'Please enter phone number',
    recipient: 'Recipient',
    messageTemplate: 'Message template',
    clear: 'Clear',
    sectionBasic: 'Basic',
    sectionTrigger: 'Trigger',
    sectionRecipient: 'Recipients',
    sectionMessage: 'Message',
    sectionRecipientAndMessage: 'Recipients & Message',
    sectionTemplate: 'Template & Media',
    sectionAi: 'AI',
    sectionValidation: 'Validation',
    sectionKnowledgeBase: 'Knowledge Base',
    sectionData: 'Data',
    sectionForm: 'Form & Document',
    sectionCommerce: 'Cart',
    sectionApproval: 'Approval',
    sectionBranch: 'Branch',
    sectionOverdue: 'Overdue & Escalation',
    sectionDescription: 'Description',
    sectionLocation: 'Location',
    sectionEmailFilter: 'Email Filter',
    loading: 'Loading...',
    noCollections: 'No collections',
    selectUser: 'Select User',
    selectRecipients: 'Select Recipients',
    shoppingCartSelectCollection: 'Select product collection',
    shoppingCartSelectCollectionPlaceholder: 'Select collection to display',
    shoppingCartBody: 'Message body (required)',
    shoppingCartBodyPlaceholder: 'Description text above the product list',
    shoppingCartHeader: 'Header (optional)',
    shoppingCartHeaderPlaceholder: 'Optional',
    shoppingCartFooter: 'Footer (optional)',
    shoppingCartFooterPlaceholder: 'Optional',
    shoppingCart24hHint: 'This message must be sent within 24 hours of the user\'s last reply; outside 24h requires MPM template (future).',
    institutionOrderingCartFlowMessageTitle: 'Flow message (by language)',
    institutionOrderingCartFlowMessageHeader: 'Header',
    institutionOrderingCartFlowMessageHeaderPlaceholder: 'Leave empty to use workflow name',
    institutionOrderingCartFlowMessageBody: 'Body',
    institutionOrderingCartFlowMessageBodyDefault: 'Tap the button below to start entering your order',
    institutionOrderingCartFlowMessageBodyDefaultZhCN: '请按下面按钮开始输入订单',
    institutionOrderingCartFlowMessageBodyDefaultEn: 'Tap the button below to start ordering',
    institutionOrderingCartFlowMessageButton: 'Button (Footer)',
    institutionOrderingCartFlowMessageButtonDefault: 'Start creating order',
    institutionOrderingCartFlowMessageButtonDefaultZhCN: '开始创建订单',
    institutionOrderingCartFlowMessageButtonDefaultEn: 'Start creating order',
    institutionOrderingCartFlowTemplate: 'Flow template name',
    institutionOrderingCartHint: 'Create and publish a Flow in Meta Flows with the above template name. The Data Exchange endpoint will recognize flow_token prefix cart_ and return collections, products, and cart.',
    institutionOrderingCart24hTemplateNote: 'Flows are always sent via a Flow template (same template in and outside 24h). Unlike the regular Shopping Cart (product_list), there is no template-free option within 24h.',
    institutionOrderingCartSettingsSummary: 'Node settings: recipients, Flow template name. Flow: select collection → product list (with images) → product detail (±qty, ±10) → cart → submit.',
    institutionOrderingCartFlowLanguage: 'Flow language',
    institutionOrderingCartLangZhTW: 'Traditional Chinese',
    institutionOrderingCartLangZhCN: 'Simplified Chinese',
    institutionOrderingCartLangEn: 'English',
    institutionOrderingCartCompanyForTemplate: 'Company (for creating Template)',
    institutionOrderingCartSelectCompany: 'Select company',
    institutionOrderingCartSelectCompanyFirst: 'Please select a company first',
    institutionOrderingCartCreateTemplateButton: 'Create to Meta Template & link',
    institutionOrderingCartCreateSuccess: 'Flow Template created. View in Meta Template panel.',
    institutionOrderingCartCreateFailed: 'Failed to create Flow Template',
    institutionOrderingCartPreviewTitle: 'Flow Template preview',
    institutionOrderingCartOpenMetaPanel: 'Open Meta Template panel',
    institutionOrderingCartTemplateInfo: 'Template info',
    institutionOrderingCartStatus: 'Status',
    institutionOrderingCartCategory: 'Category',
    institutionOrderingCartLanguage: 'Language',
    institutionOrderingCartMessagePreview: 'Message preview',
    institutionOrderingCartFlowButton: 'Open ordering cart',
    close: 'Close',
    shoppingCartMode: 'Mode',
    shoppingCartModeSelectCollection: 'Select a collection to display',
    shoppingCartModeSendCollectionOptions: 'Send collection options (list first, then product_list after user selects)',
    messageWithVariablesPlaceholder: 'Please enter message content, you can use variables like {variableName}; for JSON Process Datas, use ${JsonName.JsonFieldName}',
    availableVariables: 'Available Variables',
    variableSyntaxHelp: 'Use {variableName} syntax to insert variables; for JSON Process Datas use ${JsonName.JsonFieldName}',
    description: 'Description',
    descriptionPlaceholder: 'Please enter description (optional)',
    assignTo: 'Assign To',
    assignToPlaceholder: 'Please select assigned person',
    messageContent: 'Message Content',
    messageContentPlaceholder: 'Please enter message content',
    condition: 'Condition',
    conditionPlaceholder: 'Please enter condition',
    formSelection: 'Form Selection',
    formSelectionPlaceholder: 'Please select form',
    webhookUrl: 'Webhook URL',
    webhookUrlPlaceholder: 'Please enter Webhook URL',
    save: 'Save',
    saveSuccess: 'Workflow saved!',
    saveFailed: 'Save failed',
    validationErrors: 'Validation Errors',
    validationWarnings: 'Validation Warnings',
    mustHaveStartEnd: 'Workflow must contain start and end nodes',
    mustHaveConnection: 'Please create node connections',
    hasCycle: 'Circular connection detected',
    isolatedNode: 'Isolated node detected',
    startNodeNoOutput: 'Start node has no output connection',
    endNodeNoInput: 'End node has no input connection',
    cannotConnectToSelf: 'Cannot connect node to itself',
    connectionAlreadyExists: 'Connection already exists between nodes',
    workflowValidationFailed: 'Workflow validation failed',
    workflowValidationWarning: 'Workflow warning',
    continueSave: 'Continue saving?',
    back: 'Back',
    design: 'Design',
    copy: 'Copy',
    delete: 'Delete',
    confirmDelete: 'Are you sure you want to delete this workflow?',
    copySuccess: 'Workflow copied',
    deleteSuccess: 'Workflow deleted',
    deleteFailed: 'Delete failed',
    copyFailed: 'Copy failed',
    nameRequired: 'Please enter workflow name',
    descriptionRequired: 'Please enter workflow description',
    
    // Buttons and actions
    delete: 'Delete',
    clear: 'Clear',
    selectUser: 'Select User',
    selectPerson: 'Select Person',
    selectForm: 'Select Form',
    selectTemplate: 'Select Template',
    
    // Form labels and hints
    taskNameLabel: 'Task Name',
    taskNamePlaceholder: 'Enter task name',
    phoneNumberPlaceholder: 'Enter phone number (e.g.: 85296366318) or click to select user',
    selectSpecifiedPerson: 'Select specified person',
    waitReplyMessagePlaceholder: 'Enter prompt message when waiting for user reply',
    selectEFormPlaceholder: 'Select e-Form to send',
    
    // Node configuration
    replyType: 'Reply Type',
    initiator: 'Workflow Initiator',
    specifiedPerson: 'Specified Person',
    promptMessage: 'Prompt Message',
    promptMessageHelp: 'Before user input, the system will send the following message to remind the user they need to input',
    validationConfig: 'Validation Settings',
    validationSettings: 'Validation Settings',
    validatorActiveLabel: 'Validator Status',
    active: 'Active',
    inactive: 'Inactive',
    enableValidation: 'Enable Validation',
    yes: 'Yes',
    no: 'No',
    validatorType: 'Validator Type',
    defaultValidator: 'Default Validator',
    customValidator: 'Custom Validator',
    aiValidator: 'AI Validator',
    timeValidatorLabel: 'Time Validator (No Response Reminder)',
    timeoutCompleteValidatorLabel: 'Auto Complete Validator',
    promptText: 'Prompt Text',
    promptTextPlaceholder: 'Describe the rules for a valid reply, e.g. "User must provide a 6 digit code".',
    retryMessage: 'Reminder Message',
    retryMessagePlaceholder: 'Enter the message to send when the reply does not meet the requirement.',
    maxRetries: 'Max Reminders',
    minutes: 'Minutes',
    days: 'Days',
    hours: 'Hours',
    validationAiProvider: 'AI Provider',
    validationAiProviderPlaceholder: 'Select the AI provider used to validate user replies',
    validationAiProviderRequired: 'Please select an AI provider for validation',
    voiceProviderKey: 'Speech-to-Text Provider',
    voiceProviderKeyPlaceholder: 'Leave blank to use company default Voice AI',
    aiStaffLabel: 'AI Staff',
    aiStaffPlaceholder: 'Select AI Staff (optional)',
    aiStaffHelp: 'When selected, AI calls will use this staff member\'s role, skills and personality',
    aiStaffUseMemory: 'Use AI Staff Global Memory',
    aiStaffUseMemoryHelp: 'When ON, the staff\'s accumulated work memory (MemoryMd) is injected into the system prompt. When OFF, only the role profile is used without past memory.',
    validationAiResultVariable: 'AI Result Process Data',
    validationAiResultVariablePlaceholder: 'Select the Process Data to store the AI result',
    validationAiResultVariableHelp: 'After the AI parses the message, the structured result will be stored in this Process Data for later steps.',
    validationAiSuggestionVariable: 'AI Suggestion Process Data',
    validationAiSuggestionVariablePlaceholder: 'Select the Process Data for AI suggestion text',
    validationAiSuggestionVariableHelp: 'When validation succeeds and the AI returns a suggestion, it is written to this variable. Only text or string variables (not json).',
    validationAiFailReasonVariable: 'AI Fail Reason Process Data',
    validationAiFailReasonVariablePlaceholder: 'Select the Process Data for AI failure reason',
    validationAiFailReasonVariableHelp: 'When validation fails, the parsed reason from the AI response (or the error message) is written to this variable. Only text or string variables (not json).',
    aiProviderInactive: 'Inactive',
    aiProviderNotConfigured: 'No AI providers configured. Please add one in API Management.',
    aiProviderLoadFailed: 'Unable to load AI providers',
    
    // Time Validator translations
    timeValidator: {
      retryInterval: 'Reminder Interval',
      retryIntervalHelp: 'If user does not respond within this time, system will automatically resend the reminder message',
      retryLimit: 'Reminder Limit',
      retryMessage: 'Reminder Message Settings',
      escalation: 'Escalation Settings',
      configureRetryMessage: 'Configure Reminder Message',
      configureEscalation: 'Configure Escalation',
      directMessage: 'Direct Message',
      useTemplate: 'Use Template',
      retryMessageDescription: 'Set the reminder message content to be resent when the user does not respond within the specified time:',
      retryMessagePlaceholder: 'Enter reminder message content to remind users to reply as soon as possible...',
      retryMessageTip: 'Tip: This message will be sent to the user on each reminder',
      retryMessageRecipients: 'Reminder Message Recipients',
      retryMessageRecipientsDescription: 'Select personnel who need to receive reminder messages (you can choose users, contacts, Process Data, or process initiator):',
      templateDescription: 'Select an existing template as the reminder message:',
      noTemplateSelected: 'No template selected',
      escalationMessageDescription: 'Set the notification message to be sent to escalation recipients when the reminder limit is reached:',
      escalationMessagePlaceholder: 'Enter escalation notification message content to inform managers that action is needed...',
      escalationMessageTip: 'Tip: This message will only be sent once when the reminder limit is reached',
      escalationRecipients: 'Escalation Recipients',
      escalationRecipientsDescription: 'Select the personnel who need to receive escalation notifications when the reminder limit is reached:',
      escalationMessage: 'Escalation Message',
      retryMessageSaved: 'Reminder message configuration saved',
      escalationSaved: 'Escalation configuration saved',
      retryMessageCleared: 'Reminder message configuration cleared',
      escalationCleared: 'Escalation configuration cleared',
      overdueEscalationCleared: 'Overdue escalation configuration cleared',
      retryMessageConfig: 'Reminder Message Settings',
      escalationConfig: 'Escalation Settings',
      overdueEscalation: 'Overdue Escalation',
      configureOverdueEscalation: 'Configure Overdue Escalation',
      overdueEscalationRecipients: 'Overdue Escalation Recipients',
      overdueEscalationRecipientsDescription: 'Select personnel who need to receive overdue escalation notifications:',
      overdueEscalationMessage: 'Overdue Escalation Message',
      overdueEscalationMessageDescription: 'Set the notification message to be sent to escalation recipients when the workflow is overdue:',
      overdueEscalationMessagePlaceholder: 'Enter overdue escalation notification message content...',
      overdueEscalationMessageTip: 'Tip: This message will be sent when the workflow exceeds the overdue duration',
    },

    // Auto Complete Validator translations
    timeoutComplete: {
      timeoutInterval: 'Timeout Interval',
      description: 'Set the timeout interval for auto-completing this node. If the user is inactive for this duration, the system will automatically complete the node and proceed to the next one.',
      hint: 'Note: Set all fields to 0 or leave blank to disable auto-complete.',
    },
    autoComplete: {
      aiBatchCount: {
        enable: 'Auto-complete after image/video AI batch count',
        count: 'AI batch analysis completion count',
        description: 'Only counts AI batch analyses triggered by images or videos (plain text messages are not counted). Set how many batches before the Chatbot ends automatically; leave disabled for no batch limit.',
        hint: 'Tip: Ideal for "user finishes one photo batch then ends" scenarios. If the user sends a 2nd batch while the 1st AI analysis is still running, the 2nd batch is queued; once the configured count is reached, remaining queued images are discarded and not sent to AI.',
      },
    },
    chatBot: {
      jsonExtraction: {
        sectionTitle: 'JSON Extraction (runs after every AI reply)',
        additionalPrompt: 'Additional Prompt (JSON Generation)',
        additionalPromptHelp: 'Instructs the AI to extract data from the conversation history and generate JSON. Only runs when filled in. Result is written to the process variable below.',
        additionalPromptPlaceholder: 'e.g. Extract the order details from the conversation and return JSON:\n{\n  "customerName": "...",\n  "product": "...",\n  "quantity": 1,\n  "deliveryAddress": "..."\n}',
        jsonResultVariable: 'JSON Result Process Variable',
        jsonResultVariableHelp: 'Select a JSON-type process variable to store the AI-extracted JSON from each turn',
        jsonResultVariablePlaceholder: 'Select a JSON-type process variable',
      },
      batchRequireText: {
        enable: 'Require text description with image batch',
        waitSeconds: 'Wait for text (seconds)',
        seconds: 's',
        prompt: 'Prompt when no text received',
        promptPlaceholder: 'Please include a text description (e.g. block/address/job description). Thank you!',
      },
    },
    
    // Drawer fullscreen related
    enterFullscreen: 'Fullscreen',
    exitFullscreen: 'Exit Fullscreen',
    
    // Overdue Settings (workflow overdue settings - Start node)
    overdueConfig: 'Workflow Overdue Settings',
    overdueSettings: 'Overdue Monitoring Settings',
    overdue: {
      enabled: 'Enable Overdue Monitoring',
      duration: 'Overdue Threshold',
      escalation: 'Overdue Notification Settings',
      configureEscalation: 'Configure Overdue Notification',
      durationHelp: 'If workflow is still running after this time from start, an overdue notification will be sent',
      escalationRecipients: 'Overdue Notification Recipients',
      escalationRecipientsDescription: 'Select personnel who need to receive notifications when workflow is overdue:',
      escalationMessage: 'Overdue Notification Message',
      escalationMessageDescription: 'Set the notification message to be sent to managers when workflow is overdue:',
      escalationMessagePlaceholder: 'Enter overdue notification message content to inform managers that workflow is overdue and needs attention...',
      escalationMessageTip: 'Tip: This message will be sent once when workflow becomes overdue',
      escalationSaved: 'Overdue notification configuration saved',
      howItWorks: 'How It Works',
      description1: 'System periodically checks all running workflows and calculates time elapsed since start',
      description2: 'When time exceeds the threshold (days + hours) and workflow is still running (not Complete or Failed), overdue notification is sent',
      description3: 'Overdue notification is sent only once to avoid repeated interruptions',
    },
    
    // Function descriptions
    waitReplyDescription1: '1. When workflow execution reaches this node, it will pause and wait for user reply',
    waitReplyDescription2: '2. Only specified user replies will continue workflow execution',
    waitReplyDescription3: '3. If validation is enabled, it will check if user input meets requirements',
    waitReplyDescription4: '4. When validation fails, user will be asked to re-enter',
    waitReplyKnowledgeBaseEnabled: 'Dataset as knowledge base',
    waitReplyKnowledgeBaseEnabledHelp: 'When AI Validator is on, the workflow loads the selected Dataset (with query conditions) before validation and sends rows as JSON with the prompt so the model can map user input to master data. AI Result PV behavior is unchanged.',
    waitReplyKnowledgeBaseHint: 'Query results are passed to the AI as JSON (same controls as the DataSet Query node). Use conditions to limit rows if the dataset is large.',
    waitReplyKnowledgeBaseDataSet: 'Knowledge base Dataset',
    waitReplyKnowledgeBaseQueryConditions: 'Query conditions',
    knowledgeSourcesHint: 'Use either or both: "Dataset as knowledge base" sends matching rows as JSON to the AI; "Use knowledge base" lets you pick multiple Studio knowledge documents (published extract text). Only one Dataset; multiple documents allowed.',
    knowledgeSourceDataset: 'Dataset as knowledge base',
    knowledgeSourceDatasetHelp: 'When on, pick one Dataset and query conditions; results are merged into the AI prompt as JSON (same editor as the DataSet Query node).',
    knowledgeSourceStudio: 'Use knowledge base',
    knowledgeSourceStudioHelp: 'Multi-select documents from Studio Knowledge Base; at runtime only published versions are included. Unpublished items may be selected for design but are skipped at execution.',
    knowledgeSourceStudioPlaceholder: 'Select knowledge documents (multiple)',
    knowledgeSourceStudioDraft: 'Not published',
    knowledgeBaseSettingsDrawerLabel: 'Use knowledge base',
    knowledgeBaseSettingsDrawerHelp: 'Click Configure to set Dataset (one) and Studio knowledge documents (multiple) in a dialog; OK saves to the node.',
    knowledgeBaseSettingsModalTitle: 'Knowledge base settings',
    knowledgeBaseSettingsConfigure: 'Configure',
    knowledgeBaseSettingsOk: 'OK',
    knowledgeBaseSettingsCancel: 'Cancel',
    knowledgeBaseSettingsSectionDataset: 'Knowledge base Dataset',
    knowledgeBaseSettingsSectionStudio: 'Knowledge documents (multi-select)',
    knowledgeStudioRagEnabled: 'Vector retrieval (RAG)',
    knowledgeStudioRagHint: 'When enabled, only top-k FAQ chunks matching the user message are sent to the AI (requires completed vector indexing). Off by default for full-text mode.',
    knowledgeStudioTopK: 'Top-K chunks',
    knowledgeStudioMaxContextChars: 'Max context characters',
    knowledgeStudioEmbeddingProvider: 'Embedding provider',
    knowledgeStudioEmbeddingProviderPlaceholder: 'Leave blank to use company default Embedding provider',
    knowledgeStudioRagProvider: 'RAG engine',
    knowledgeStudioRagProviderLocal: 'Self-hosted pipeline (local embedding)',
    knowledgeStudioRagProviderXai: 'xAI Collections (managed)',
    knowledgeStudioRagXaiHint: 'xAI Collections is managed in the xAI cloud. The system automatically searches all categories that have a Collection created. No manual Collection IDs needed. Make sure: ① create a Collection for each category in the Knowledge Base page; ② assign documents to categories and publish them to sync to xAI.',
    knowledgeStudioRagXaiAutoSelected: 'xAI is detected as the default AI provider. xAI Collections (Managed) mode is automatically selected.',
    knowledgeStudioCollectionIds: 'xAI Collection IDs',
    knowledgeStudioCollectionIdsHelp: 'Enter one or more Collection IDs (e.g. collection_xxxxxxxx), separated by comma, space, or newline.',
    knowledgeStudioCollectionIdsPlaceholder: 'Type a Collection ID and press Enter (multiple allowed)',
    knowledgeBaseSettingsSummaryEmpty: 'Not configured',
    knowledgeBaseSettingsSummaryDataset: 'Dataset: {name}',
    knowledgeBaseSettingsSummaryAndStudio: '; {count} document(s)',
    knowledgeBaseSettingsSummaryStudioOnly: '{count} document(s)',
    knowledgeBaseSettingsSummaryMasterOn: 'On (no documents or Dataset selected yet)',
    knowledgeBaseSettingsMasterSwitch: 'Use knowledge base',
    knowledgeBaseSettingsMasterHelp: 'When off, no knowledge content is sent to the AI. When on, configure documents and Dataset below.',
    knowledgeBaseSettingsQueryDivider: 'Query conditions',
    knowledgeBaseSettingsSectionCalendar: 'Calendar Events',
    knowledgeBaseCalendarEnabledSwitch: 'Use calendar events as knowledge base',
    knowledgeBaseCalendarEnabledHelp: 'When on, calendar events are queried at runtime and sent as JSON to the AI, enabling chatbots to answer schedule-related questions.',
    knowledgeBaseCalendarFilterModeLabel: 'People filter mode',
    knowledgeBaseCalendarFilterModeSelf: 'Query self (filter by the WhatsApp user who triggered the flow)',
    knowledgeBaseCalendarFilterModeGroupTag: 'By group / tag (build different flows for different permission levels)',
    knowledgeBaseCalendarGroupIds: 'Broadcast Group',
    knowledgeBaseCalendarGroupIdsPlaceholder: 'Select broadcast groups (multi-select)',
    knowledgeBaseCalendarHashtags: 'Hashtag',
    knowledgeBaseCalendarHashtagsPlaceholder: 'Type a tag and press Enter, multiple allowed',
    knowledgeBaseCalendarRelativeDays: 'Query upcoming days',
    knowledgeBaseCalendarRelativeDaysPlaceholder: 'Leave blank = no date limit',
    knowledgeBaseSettingsSummaryCalendarSelf: 'Calendar: self',
    knowledgeBaseSettingsSummaryCalendarGroup: 'Calendar: {n} group(s){tags}',
    eFormDescription1: '1. Select e-Form to send',
    eFormDescription2: '2. Select user to receive form (phone number)',
    eFormDescription3: '3. System will send form link to specified user',
    eFormDescription4: '4. User can click link to fill form',
    eFormDescription5: '5. After form submission, subsequent workflow will be triggered',
    eFormDescription6: '6. Can set approval result variable to record approval status (approve/reject/pending)',
    eFormDescription7: '7. Approval result can be used in subsequent Switch nodes for workflow branching',
    
    // Approval result collection
    approvalResultVariable: 'Approval Result Process Data',
    selectApprovalResultVariable: 'Select Process Data to record approval result',
    approvalResultInfo: 'Approval Result Information',
    approvalResultDescription1: '1. When form approval is completed, system will automatically write approval result to selected Process Data',
    approvalResultDescription2: '2. Approval result values: approve (approved), reject (rejected), pending (pending approval)',
    approvalResultDescription3: '3. This variable can be used in subsequent Switch nodes for workflow branching',
    
    // sendEForm node related translations
    sendEForm: {
      promptMessagePlaceholder: 'Enter prompt message to remind user of information needed before filling in the form',
      
      // MetaFlows specific configuration
      flowHeader: 'Header',
      flowHeaderPlaceholder: 'Enter the Flow message header (e.g., Please fill in the form)',
      flowBody: 'Body',
      flowBodyPlaceholder: 'Enter the Flow message body content (e.g., Please click the button below to start filling in the form)',
      flowCta: 'Call to Action',
      flowCtaPlaceholder: 'Enter the button text (e.g., Fill in form)',
      flowTemplateModeTitle: 'Meta Flow Template Variable Mapping',
      flowTemplateModeHint: 'The Template header, body, and call-to-action are baked in at creation time and cannot be overridden here. Map Process Data to the {{1}} {{2}} ... placeholders below; to change the text content, rebuild the Flow Template from the MetaFlows form page.',
      flowTemplateNotBuiltHint: 'This form has no Flow Template yet (or creation failed). Trigger Flow Template creation from the MetaFlows form page, then come back to map variables here. The mappings below will take effect once the Template is ready.',
      flowTemplateLegacyHint: 'This form\'s Flow Template is in legacy format (no {{N}} placeholders); the variable mappings below will not take effect. Rebuild the Flow Template from the MetaFlows form page and add {{1}} {{2}} ... to the BODY to enable process-variable injection.',
      metaFlowsManualFillOnly: 'Meta Flows forms only support manual fill mode',
      fillMode: 'Form Filling Mode',
      integrateWaitReply: 'Integrate Wait Reply Node (AI Fill)',
      integrateDataSetQuery: 'Integrate DataSet Query Node (Data Fill)',
      integrateEmailStart: 'Integrate Email Monitor (AI Fill)',
      integrateManualStart: 'Integrate Published-App Manual Trigger (AI Fill)',
      integrateEForm: 'Integrate Upstream eForm Node (use filled form data)',
      integrateEFormDesc: 'Use form instances produced by the chosen upstream sendEForm node. When that node runs in multiFormMode=multi, all instances are aggregated and sent to AI.',
      selectUpstreamEFormNode: 'Upstream sendEForm Node',
      selectUpstreamEFormNodePlaceholder: 'Select the sendEForm node to integrate…',
      selectUpstreamEFormNodeHelp: 'Pick a sendEForm node already completed in this workflow. The fields parsed from each EFormInstance.FilledHtmlCode are sent as the AI input data. With multi-form mode, all instances are aggregated.',
      noUpstreamEFormNode: 'No sendEForm node found on the canvas. Add a sendEForm node first.',
      integrateChatBot: 'Integrate Chatbot Node (AI Fill)',
      integrateChatOrderingCart: 'Integrate Chatbot Shopping Cart Node (AI Fill)',
      selectUpstreamWaitReplyNode: 'Specify Upstream waitReply Node',
      selectUpstreamWaitReplyNodePlaceholder: 'Select waitReply node (blank = last reply)…',
      selectUpstreamWaitReplyNodeHelp: 'Pick a specific waitReply node whose valid reply (including images/files) will be used as AI input. Leave blank to automatically use the last valid reply in the current execution.',
      noUpstreamWaitReplyNode: 'No waitReply node found on the canvas',
      selectUpstreamChatBotNode: 'Specify Upstream Chatbot Node',
      selectUpstreamChatBotNodePlaceholder: 'Select Chatbot node (blank = latest session)…',
      selectUpstreamChatBotNodeHelp: 'Pick a specific Chatbot node whose conversation history will be used as AI input. Leave blank to automatically use the most recently updated Chatbot session.',
      noUpstreamChatBotNode: 'No Chatbot node found on the canvas',
      selectUpstreamChatOrderingCartNode: 'Specify Upstream Chatbot Shopping Cart Node',
      selectUpstreamChatOrderingCartNodePlaceholder: 'Select Chatbot Shopping Cart node (blank = latest session)…',
      selectUpstreamChatOrderingCartNodeHelp: 'Pick a specific Chatbot Shopping Cart node whose ordering conversation history will be used as AI input. Leave blank to automatically use the most recently updated cart session.',
      noUpstreamChatOrderingCartNode: 'No Chatbot Shopping Cart node found on the canvas',
      integrateEmailStartSendToAi: 'Send to AI',
      integrateEmailStartSendToAiHelp: 'Choose what to send to AI for form filling: attachment only, email body only, or both.',
      integrateEmailStartSendToAiAttachment: 'Attachment only',
      integrateEmailStartSendToAiBody: 'Email body only',
      integrateEmailStartSendToAiBoth: 'Both',
      integrateManualStartSendToAiHelp: 'Choose what to send to AI: attachments only, the message entered at manual trigger only, or both.',
      integrateManualStartSendToAiBody: 'User startup message only',
      manualFill: 'Manual Fill (Independent)',
      exclusiveModeLabel: 'Exclusive mode',
      aiSourceLabel: 'AI data sources (multi-select)',
      emailAndManualBothWarning: 'Email monitor and manual trigger are both start triggers; a workflow only has one. Select only one if possible.',
      multiSourceDesc: 'Multiple AI sources are merged and sent to AI together; each source is labeled in a separate block.',

      // eForm result mode
      resultMode: 'eForm Result Mode',
      singleResult: 'Single eForm Result',
      multiResult: 'Allow Multiple eForm Results (Two-Pass Analysis)',
      singleResultDesc: 'Single result: AI fills one form directly.',
      multiResultDesc: 'Multiple results: AI first plans multiple forms, then fills them one by one.',
      multiResultNotice: 'This mode increases AI calls. Consider cost and time.',
      
      // Mode descriptions
      modeDescription: 'Mode Description',
      integrateChatBotDesc: 'Use the conversation history (including images/attachments) from an upstream Chatbot node as AI input for filling the form',
      integrateChatOrderingCartDesc: 'Use the ordering conversation history (including images/attachments) from an upstream Chatbot Shopping Cart node as AI input for filling the form',
      integrateWaitReplyDesc: 'Inherit natural language reply from previous waitReply node, use AI to intelligently fill the form',
      integrateDataSetQueryDesc: 'Use query result data from specified DataSet Query node, directly map to form fields',
      integrateEmailStartDesc: 'Use email body and attachments received at start node (Email Monitor trigger) to fill the form with AI; no waitReply node needed.',
      integrateManualStartDesc: 'Use message text and files from Published Apps manual trigger (same payload shape as Email monitor). Pair with manual-start workflows.',
      manualFillDesc: 'Send blank form to user to fill manually, no dependency on other nodes. System will automatically copy form field values (field names must match Process Data names) to Process Data',
      
      // DataSet Query selection
      selectDataSetQueryNode: 'Select DataSet Query Node',
      selectDataSetQueryNodePlaceholder: 'Select DataSet Query node to integrate',
      noDataSetQueryNodes: 'No DataSet Query nodes available',
      dataSetQueryNodeHelp: 'Only DataSet Query nodes with SELECT operation type will be shown in this list',
      aiProvider: 'AI Provider',
      aiProviderPlaceholder: 'Select the AI provider used to analyse user replies',
      aiProviderRequired: 'Please select an AI provider for AI fill mode',
      
      // Additional Prompt and JSON Result Variable configuration
      fillFormAdditionalPrompt: 'Additional Prompt (Form Filling Instructions)',
      fillFormAdditionalPromptHelp: 'Used to instruct AI how to understand the data source and fill the form. In multi-form mode, this instruction is used to plan multiple forms',
      fillFormAdditionalPromptPlaceholder: 'Example: The detail list from the data source may contain different company names and addresses, because it specifies where to deliver the goods within the details. So please understand correctly that each detail is actually a separate delivery note',
      additionalPrompt: 'Additional Prompt (JSON Generation Instructions)',
      additionalPromptHelp: 'Used to instruct AI how to generate JSON from the same data source (user input text/images/files), convenient for dataset nodes to use JSON for insert/update operations',
      additionalPromptPlaceholder: 'Example: Please generate JSON in the following format from the extracted data:\n{\n  "date": "2017-04-25",\n  "time": "18:27",\n  "amount": 1500.00,\n  "currency": "HKD",\n  "fromAccount": "661-050***-292",\n  "toAccount": "619-034457-888",\n  "toAccountName": "HUNG C** W**",\n  "reference": "5BCO"\n}',
      jsonResultVariable: 'JSON Result Process Data',
      jsonResultVariableHelp: 'Select a JSON type Process Data to store the AI-generated JSON data',
      jsonResultVariablePlaceholder: 'Select a JSON type Process Data',
      jsonResultAiSuggestionVariable: 'AI Suggestion Process Data',
      jsonResultAiSuggestionVariablePlaceholder: 'Select a text or string variable',
      jsonResultAiSuggestionVariableHelp: 'When the AI returns a JSON object with a "suggestion" field (same shape as validation AI), it is written to this variable after JSON extraction.',
      jsonResultAiFailReasonVariable: 'AI Fail Reason Process Data',
      jsonResultAiFailReasonVariablePlaceholder: 'Select a text or string variable',
      jsonResultAiFailReasonVariableHelp: 'When the AI returns a JSON object with a "reason" field, it is written to this variable. Only text or string variables (not json).',
      knowledgeBaseEnabled: 'Dataset as knowledge base',
      knowledgeBaseEnabledHelp: 'When enabled, the workflow loads the selected Dataset (with query conditions) before AI fill and sends the rows as JSON with the prompt so the model can map incoming text to master data.',
      knowledgeBaseHint: 'At runtime, query results are passed to the AI as JSON (same controls as the DataSet Query node). Use conditions to limit rows if the dataset is large.',
      knowledgeBaseDataSet: 'Knowledge base Dataset',
      knowledgeBaseQueryConditions: 'Query conditions',
      
      // Dependency check
      dependencyCheck: 'Dependency Check',
      waitReplyDependency: 'Previous node must be waitReply',
      dataSetQueryDependency: 'Specified DataSet Query node must complete execution',
      noDependency: 'No dependency on other nodes',
      
      // Warning messages
      warningNoWaitReply: 'Warning: Previous node is not waitReply, cannot use AI fill function',
      warningNoDataSetQuery: 'Warning: Cannot find specified DataSet Query node or query results',
      warningInvalidMode: 'Warning: Selected filling mode does not match workflow structure',
      
      // Notification message
      sendNotificationToRecipients: 'Send notification to recipients',
      sendNotificationToRecipientsHelp: 'When off, only fill form without sending notification (recipients and message need not be set). Manual fill mode must be on.',
      sendNotificationOn: 'On',
      sendNotificationOff: 'Off',
      notificationMessage: 'Notification Message',
      notificationMessagePlaceholder: 'Enter notification message, can use {formName} and {formUrl} variables',
      notificationMessageHelp: 'Supported variables: {formName} - Form Name, {formUrl} - Form Link',
      defaultNotificationMessage: 'Your {formName} is ready. Please click the following link to fill it out:\n\n{formUrl}',
      customMessage: 'Custom Message',
      useDefaultMessage: 'Use Default Message',
      messageTemplate: 'Message Template',
      messageTemplatePlaceholder: 'Enter message template',
      variablePlaceholder: 'Variable Placeholder',
      formNameVariable: 'Form Name Variable',
      formUrlVariable: 'Form Link Variable',
      
      // Approval settings
      approvalSettingDescription: 'eForm can be configured to require approval or not. If "Yes" is selected, the workflow will wait for user response; if "No" is selected, the form will be automatically set to approved immediately after submission.',
      requireApproval: 'Require Approval',
      approveButtonLabel: 'Approve display label',
      approveButtonLabelPlaceholder: 'Example: Passed, WON (leave blank to use default)',
      rejectButtonLabel: 'Reject display label',
      rejectButtonLabelPlaceholder: 'Example: Failed, LOST (leave blank to use default)'
    },
    artifact: {
      generationMode: 'Data source',
      documentFormat: 'Output format',
      storageKind: 'Storage',
      storageLocal: 'WhatoFlow local',
      comingSoon: 'Coming soon',
      sendNotification: 'Send notification to recipients',
      reportNameVariable: 'Report name (from task name)',
      reportUrlVariable: 'Report URL (full link after sign-in)',
      docNameVariable: 'Document file name',
      docUrlVariable: 'Document page URL (full link to download after sign-in)',
      defaultHtmlReportNotification: 'Your report "{reportName}" is ready. Open after sign-in:\n\n{reportUrl}',
      defaultDocumentNotification: 'Your document "{docName}" is ready. Download after sign-in:\n\n{docUrl}',
      knowledgeBaseEnabled: 'Dataset as knowledge base',
      knowledgeBaseEnabledHelp: 'When enabled, the workflow loads the selected Dataset (with query conditions) before generating the HTML report or Office file and appends rows as JSON to the AI system prompt so the model can align content with master data (e.g. product or customer codes).',
      knowledgeBaseHint: 'Query results are passed to the AI as JSON (same editor as the DataSet Query node). Use conditions to limit rows if the dataset is large.',
      attachmentBatchMode: 'Attachments sent to AI',
      attachmentBatchModeHelp: 'When there are multiple attachments: All converts and merges every file for the model; First only processes the first path (saves tokens). This is not the same as eForm multi-instance / multi-form mode.',
      attachmentBatchModeAll: 'All attachments',
      attachmentBatchModeFirst: 'First attachment only',
      attachmentAiInputFormat: 'Input format',
      attachmentAiInputFormatHelp: 'Keep only attachments whose extension matches this format. Filter runs before "Attachments sent to AI". If nothing is left after filtering, the node fails.',
      attachmentAiInputFormatAny: 'No filter',
      documentFormatPdfHelp: 'Use input PDF (or Office) files as templates: LibreOffice converts each to FODG for AI editing, then exports back to PDF. Multiple inputs produce multiple outputs one-to-one, each with its own notification.',
      embeddedImages: 'Embedded Images',
      embeddedImageDesc: 'Commonly used for company chops, authorised signatures, and other images to be printed on documents. After uploading, specify the image name and placement in the additional prompt — the AI will automatically embed the image in the corresponding field.',
      embeddedImageUpload: 'Upload Image',
      embeddedImageHint: 'Supports jpg/png/gif/bmp/webp/svg; reference the image by name in the additional prompt to specify placement',
      embeddedImageName: 'Image name (referenced in prompt)',
      embeddedImageEmpty: 'No images uploaded yet',
      embeddedImageNoWorkflowId: 'Please save the workflow definition before uploading images',
      embeddedImageInvalidType: 'Only jpg/png/gif/bmp/webp/svg formats are supported',
      embeddedImageUploaded: 'Image uploaded successfully',
      embeddedImageUploadFailed: 'Image upload failed'
    },
    
    // Activation method configuration
    activationConfig: 'Activation Method Configuration',
    activationType: 'Activation Method',
    manualActivation: 'Manual Activation',
    metaWebhookCall: 'Start from WhatsApp',
    scheduledTableWatch: 'Scheduled Table Watch',
    emailMonitor: 'Email Monitor',
    emailProvider: 'Email Service Provider',
    emailProviderPlaceholder: 'Select email service provider',
    emailNoProviderConfigured: 'No email provider configured. Add one in API Management.',
    emailMonitorMailbox: 'Monitored Email Box (email address)',
    emailMonitorMailboxPlaceholder: 'Mailbox address to monitor, e.g. user@company.com; leave empty to use provider default',
    emailFilterSender: 'Filter by sender',
    emailFilterSenderPlaceholder: 'Leave empty to skip; partial match supported',
    emailFilterSubject: 'Filter keywords (any match)',
    emailFilterSubjectPlaceholder: 'Leave empty to skip; any keyword in subject or body passes',
    emailFilterKeywordsRequired: 'Required keywords (all must match)',
    emailFilterKeywordsRequiredPlaceholder: 'Leave empty to skip; every keyword must appear in subject or body',
    emailFilterKeywordsMatchHint: 'Combined with AND: any-match first, then all-required; keywords are searched in subject and body',
    emailFilterSenderNot: 'Sender does not contain',
    emailFilterSenderNotPlaceholder: 'Leave empty to skip; exclude if any matches',
    emailFilterSubjectNot: 'Subject does not contain',
    emailFilterSubjectNotPlaceholder: 'Leave empty to skip; exclude if any matches',
    emailFilterBodyKeywordsNot: 'Body does not contain',
    emailFilterBodyKeywordsNotPlaceholder: 'Leave empty to skip; exclude if any matches',
    emailFilterHasAttachment: 'Only emails with attachments',
    emailFilterAttachmentExtensions: 'Filter by attachment extension',
    emailFilterAttachmentExtensionsPlaceholder: 'Leave empty for all; multiple = OR (any extension)',
    emailFilterAttachmentFileName: 'Filter by filename contains',
    emailFilterAttachmentFileNamePlaceholder: 'Leave empty for all; multiple = OR (filename contains any)',
    emailFilterAttachmentFileNameNot: 'Filename does not contain',
    emailFilterAttachmentFileNameNotPlaceholder: 'Leave empty to skip; exclude if filename contains any',
    emailMonitorInfo: 'Email Monitor Info',
    emailMonitorDescription1: '1. System will periodically check the selected mailbox; emails matching filters will trigger this workflow.',
    emailMonitorDescription2: '2. After trigger, email body and attachments are stored in the workflow; use with "Integrate Email Monitor (AI Fill)" node.',
    watchTable: 'Watch Table',
    queryCondition: 'Query Condition',
    checkInterval: 'Check Interval (seconds)',
    
    // Webhook related
    webhookToken: 'Webhook Token',
    webhookTokenPlaceholder: 'Please enter Webhook Token',
    whatsAppMenuName: 'WhatsApp Menu Name',
    whatsAppMenuNamePlaceholder: 'Optional. Name shown in WhatsApp menu (leave empty to use workflow name)',
    webhookInfo: 'Webhook Information',
    webhookDescription1: '1. Please configure Meta Webhook URL in company settings page',
    webhookDescription2: '2. When WhatsApp message is received, system will reply with menu for user to select function',
    webhookDescription3: 'Webhook Token is configured at company level, workflow will automatically use company\'s webhook settings',

    // Webhook access control (who can start this workflow from WhatsApp)
    webhookAccess: {
      modalTitle: 'Select contacts allowed to start this workflow',
      modalIntro: 'Only contacts whose phone numbers match one of the following will see and be able to start this workflow from WhatsApp.',
      modeLabel: 'Access',
      modePublic: 'Public',
      modeRestricted: 'Restricted to specific contacts',
      allowedRecipientsLabel: 'Allowed contacts / groups / hashtags',
      allowedRecipientsHelp: 'Tick individual contacts, broadcast groups, or contact hashtags. A user is allowed if they match ANY of these.',
      restrictedInfo: 'This workflow is restricted. WhatsApp users outside the allowed list will not see this option.',
      fieldPlaceholder: 'No contacts / groups / hashtags selected yet',
      fieldButton: 'Select',
      selectedSummary: 'Selected allow list',
      summaryGroups: '{count} group(s)',
      summaryHashtags: '{count} hashtag(s)',
      summaryContacts: '{count} contact(s)',
    },

    // Scheduled watch related
    scheduledTable: 'Watch Table',
    scheduledTablePlaceholder: 'Example: dbo.SoOrderManage',
    scheduledQuery: 'Query Condition',
    scheduledQueryPlaceholder: 'Example: WHERE status = \'PENDING\' AND created_at > @lastCheckTime',
    scheduledInterval: 'Check Interval',
    seconds: 'seconds',
    scheduledInfo: 'Dataset schedule (trigger + write-back)',
    scheduledDataSet: 'Dataset to watch',
    scheduledTriggerConditions: 'Trigger conditions (which rows start a run)',
    scheduledFieldMapping: 'Map row fields to Process Data',
    scheduledPostSuccessWriteBack: 'After run is created — write back to row',
    scheduledPostSuccessSetWriteBack: 'Set write-back fields',
    scheduledPostSuccessWriteBackSummary: '{count} field(s) will be updated on the row after the workflow run is created.',
    scheduledPostSuccessOperationSaved: 'Write-back fields saved.',
    scheduledLegacySqlDeprecated: 'This workflow still has the old free-text table/SQL fields. Please select a Dataset and build trigger conditions below; the legacy fields are ignored by the server.',
    scheduledDescription1: '1. Pick a Dataset (like a table you uploaded from Excel). The scheduler scans its rows on an interval you set.',
    scheduledDescription2: '2. Trigger conditions: use the same query-condition groups as the DataSet node. Example: Status equals Pending AND Department equals Sales — only those rows start a new workflow run.',
    scheduledDescription3: '3. Field mapping: copy columns from the matching row into Process Data (e.g. OrderId, CustomerName) so the rest of the flow can use them.',
    scheduledDescription4: '4. Write-back: after a run is successfully created, the system updates the same row (e.g. set Status to Processing) so the next scan does not pick it again. Configure at least one write-back field to avoid duplicate runs.',
    scheduledDescription5: 'Example: Dataset Orders has columns Status, Amount. Trigger when Status = New. Write-back Status = InProgress. After one run starts for that row, Status changes and it will not match New anymore.',
    
    // Configuration descriptions
    metaWebhookConfigTitle: 'Meta Webhook Configuration Description',
    metaWebhookConfig1: '1. Please configure Meta Webhook URL in company settings page',
    metaWebhookConfig2: '2. When WhatsApp message is received, system will reply with menu for user to select function',
    metaWebhookConfig3: '3. According to user selection, corresponding workflow will be activated',
    metaWebhookConfig4: '4. This workflow will execute after user selection',
    scheduledWatchTitle: 'Scheduled Watch Description',
    scheduledWatchDescription: 'This feature is under development and will be implemented in future versions',
    
    // Modal dialogs
    selectWhatsAppTemplate: 'Select WhatsApp Template',
    selectUser: 'Select User',
    selectEForm: 'Select e-Form',
    noTemplatesAvailable: 'No templates available, please create templates first',
    noUsersAvailable: 'No users available, please add users first',
    noEFormsAvailable: 'No e-Form templates available, please create forms first',
    internalTemplate: 'Internal Templates',
    
    // Meta Template
    metaTemplate: {
      title: 'Meta Official Templates',
      approved: 'Approved',
      pending: 'Pending',
      rejected: 'Rejected',
    },
    templateLibraryTab: 'Template Library',
    templateLibrarySearchPlaceholder: 'Search templates',
    templateLibraryTopic: 'Topic',
    templateLibraryUsecase: 'Use case',
    templateLibraryIndustry: 'Industry',
    templateLibraryLanguage: 'Language code',
    templateLibraryApplyFilters: 'Apply filters',
    templateLibraryHint: 'Selecting one submits creation to your WABA (with company suffix). After Meta approves, it works like any Meta template.',
    templateLibraryCatalog: 'Catalog',
    templateLibraryLoadFailed: 'Failed to load template library',
    templateLibraryCreateFailed: 'Failed to create from library (templates with buttons may need URL/phone in Meta)',
    templateLibraryEmpty: 'No templates match the filters',

    libTopic_ACCOUNT_UPDATE: 'Account Update',
    libTopic_CUSTOMER_FEEDBACK: 'Customer Feedback',
    libTopic_ORDER_MANAGEMENT: 'Order Management',
    libTopic_PAYMENTS: 'Payments',

    libUsecase_ACCOUNT_CREATION_CONFIRMATION: 'Account Creation Confirmation',
    libUsecase_AUTO_PAY_REMINDER: 'Auto Pay Reminder',
    libUsecase_DELIVERY_CONFIRMATION: 'Delivery Confirmation',
    libUsecase_DELIVERY_FAILED: 'Delivery Failed',
    libUsecase_DELIVERY_UPDATE: 'Delivery Update',
    libUsecase_FEEDBACK_SURVEY: 'Feedback Survey',
    libUsecase_FRAUD_ALERT: 'Fraud Alert',
    libUsecase_LOW_BALANCE_WARNING: 'Low Balance Warning',
    libUsecase_ORDER_CONFIRMATION: 'Order Confirmation',
    libUsecase_ORDER_DELAY: 'Order Delay',
    libUsecase_PAYMENT_DUE_REMINDER: 'Payment Due Reminder',
    libUsecase_SHIPMENT_CONFIRMATION: 'Shipment Confirmation',
    libUsecase_TRANSACTION_ALERT: 'Transaction Alert',

    libIndustry_E_COMMERCE: 'E-Commerce',
    libIndustry_FINANCIAL_SERVICES: 'Financial Services',

    libLang_af: 'Afrikaans',
    libLang_sq: 'Albanian',
    libLang_ar: 'Arabic',
    libLang_az: 'Azerbaijani',
    libLang_bn: 'Bengali',
    libLang_bg: 'Bulgarian',
    libLang_ca: 'Catalan',
    libLang_zh_CN: 'Chinese (Simplified)',
    libLang_zh_HK: 'Chinese (Hong Kong)',
    libLang_zh_TW: 'Chinese (Taiwan)',
    libLang_hr: 'Croatian',
    libLang_cs: 'Czech',
    libLang_da: 'Danish',
    libLang_nl: 'Dutch',
    libLang_en: 'English',
    libLang_en_GB: 'English (UK)',
    libLang_en_US: 'English (US)',
    libLang_et: 'Estonian',
    libLang_fil: 'Filipino',
    libLang_fi: 'Finnish',
    libLang_fr: 'French',
    libLang_ka: 'Georgian',
    libLang_de: 'German',
    libLang_el: 'Greek',
    libLang_gu: 'Gujarati',
    libLang_ha: 'Hausa',
    libLang_he: 'Hebrew',
    libLang_hi: 'Hindi',
    libLang_hu: 'Hungarian',
    libLang_id: 'Indonesian',
    libLang_ga: 'Irish',
    libLang_it: 'Italian',
    libLang_ja: 'Japanese',
    libLang_kn: 'Kannada',
    libLang_kk: 'Kazakh',
    libLang_rw_RW: 'Kinyarwanda',
    libLang_ko: 'Korean',
    libLang_ky_KG: 'Kyrgyz',
    libLang_lo: 'Lao',
    libLang_lv: 'Latvian',
    libLang_lt: 'Lithuanian',
    libLang_mk: 'Macedonian',
    libLang_ms: 'Malay',
    libLang_ml: 'Malayalam',
    libLang_mr: 'Marathi',
    libLang_nb: 'Norwegian',
    libLang_fa: 'Persian',
    libLang_pl: 'Polish',
    libLang_pt_BR: 'Portuguese (Brazil)',
    libLang_pt_PT: 'Portuguese (Portugal)',
    libLang_pa: 'Punjabi',
    libLang_ro: 'Romanian',
    libLang_ru: 'Russian',
    libLang_sr: 'Serbian',
    libLang_sk: 'Slovak',
    libLang_sl: 'Slovenian',
    libLang_es: 'Spanish',
    libLang_es_AR: 'Spanish (Argentina)',
    libLang_es_ES: 'Spanish (Spain)',
    libLang_es_MX: 'Spanish (Mexico)',
    libLang_sw: 'Swahili',
    libLang_sv: 'Swedish',
    libLang_ta: 'Tamil',
    libLang_te: 'Telugu',
    libLang_th: 'Thai',
    libLang_tr: 'Turkish',
    libLang_uk: 'Ukrainian',
    libLang_ur: 'Urdu',
    libLang_uz: 'Uzbek',
    libLang_vi: 'Vietnamese',
    libLang_zu: 'Zulu',

    // Message Mode
    directMessage: 'Direct Message',
    useTemplate: 'Use Template',
    sendEmail: 'Send Email',
    
    // Email configuration
    email: {
      provider: 'Email Provider',
      providerRequired: 'Please select an email provider',
      selectProvider: 'Select Email Provider',
      noProviderConfigured: 'No email provider configured. Please add one in API Management.',
      subject: 'Email Subject',
      subjectRequired: 'Please enter email subject',
      subjectPlaceholder: 'Enter email subject',
      body: 'Email Body',
      bodyRequired: 'Please enter email body',
      bodyPlaceholder: 'Enter email body content (supports Process Data like ${variableName}; for JSON, use ${JsonName.JsonFieldName})',
      bodyHelp: 'You can use Process Data in the email body. Click on the variable tags above to insert them. Rich text formatting (bold, italic, colors, etc.) is supported. If a Process Data is JSON, use ${JsonName.JsonFieldName} to read a field.',
      insertReceivedMediaTokenButton: 'Received Media',
      insertReceivedMediaTokenTitle: 'Insert received media token',
      richTextToolbarBold: 'Bold',
      richTextToolbarItalic: 'Italic',
      richTextToolbarUnderline: 'Underline',
      richTextToolbarStrike: 'Strikethrough',
      richTextToolbarHeader: 'Heading level',
      richTextToolbarTextColor: 'Text color',
      richTextToolbarBackgroundColor: 'Background color',
      richTextToolbarOrderedList: 'Numbered list',
      richTextToolbarBulletList: 'Bulleted list',
      richTextToolbarAlign: 'Text alignment',
      richTextToolbarLink: 'Insert link',
      richTextToolbarClean: 'Clear formatting (remove bold, colors, links, etc.)'
    },
    
    // Other UI elements
    inDevelopment: 'In Development',
    loadingWorkflow: 'Loading workflow…',
    clickToSelectConnection: 'Click to select connection',
    template: 'Template',
    templateInfo: 'Template Information',
    templatePreview: 'Template Preview',
    templateContent: 'Template Content',
    templatePreviewNoData: 'No template data to preview',
    templateId: 'Template ID:',
    templateName: 'Template Name:',
    // Template Image/Document URL Configuration
    templateImageUrl: 'Image URL',
    templateDocumentUrl: 'Document URL',
    templateImageUrlPlaceholder: 'e.g.: https://example.com/images/${InvoiceNo}.jpg',
    templateDocumentUrlPlaceholder: 'e.g.: https://example.com/pdf/${InvoiceNo}.pdf',
    templateHeaderUrlHelp: 'Supports Process Data, e.g.: ${InvoiceNo}. For JSON variables, use ${JsonName.JsonFieldName}. Will be replaced with actual values at runtime.',
    templateImageSource: 'Image Source',
    templateImageSourceUrl: 'Use URL',
    templateImageSourceInstance: 'Use Instance Image',
    templateImageSourceHelp: 'Select to use a URL or an image from the current workflow instance folder (excludes qr_scan_success_* files, uses the earliest image if multiple exist).',
    templateDocumentFilename: 'Filename',
    templateDocumentFilenamePlaceholder: 'e.g.: ${InvoiceNo}.pdf',
    templateDocumentFilenameHelp: 'Supports Process Data, e.g.: ${InvoiceNo}. For JSON variables, use ${JsonName.JsonFieldName}. Will be replaced with actual values at runtime.',
    formInfo: 'Form Information',
    formId: 'Form ID:',
    formName: 'Form Name:',
    formDescription: 'Description:',
    
    // Default values and hints
    enterValidContent: 'Please enter valid content',
    inputIncorrectRetry: 'Input incorrect, please re-enter',
    dateFormatExample: 'Example: Please enter leave date, format: YYYY-MM-DD',
    formatExample: 'Example: Format incorrect, please re-enter, example: 2024-01-15',
    tableExample: 'Example: dbo.SoOrderManage',
    queryExample: 'Example: WHERE status = \'PENDING\' AND created_at > @lastCheckTime',
    
    // Default node data
    defaultStartNode: 'Start',
    defaultEndNode: 'End',
    defaultSendWhatsAppNode: 'Send Message',
    defaultSendTemplateNode: 'Send WhatsApp Template',
    defaultWaitReplyNode: 'Wait for User Reply',
    defaultWaitForQRCodeNode: 'Wait for QR Code Scan',
    defaultWaitForLocationNode: 'Request Geolocation',
    defaultLocationRequestBody: 'Please tap the button below to share your location.',
    defaultWaitForEmailReplyNode: 'Wait for Email Reply',
    defaultQRCodeMessage: 'Please upload an image containing QR Code',
    defaultSwitchNode: 'Condition Branch',
    defaultDataSetQueryNode: 'DataSet Query/Update',
    defaultCallApiNode: 'Trigger External API',
    defaultSendEFormNode: 'Send e-Form',
    defaultGenerateHtmlReportNode: 'Generate HTML Report',
    defaultGenerateDocumentNode: 'Generate Document',
    defaultEFormResultNode: 'e-Form Approved/Rejected',
    
    // Validation messages
    defaultReplyMessage: 'Please enter your reply',
    defaultValidationPrompt: 'Please enter valid content',
    defaultRetryMessage: 'Input is incorrect, please re-enter',
    
    // Comment descriptions
    specifiedUsersComment: 'Phone numbers of specified personnel, separated by commas',
    scheduledIntervalComment: '5 minutes',
    
    // Status and other labels
    statusEnabled: 'Enabled',
    statusDisabled: 'Disabled',
    designer: 'Designer',
    functionDescription: 'Function Description',
    
    // Error messages
    saveFailed: 'Save failed',
    updateFailed: 'Update failed',
    createFailed: 'Create failed',
    getTemplatesFailed: 'Failed to get templates',
    unknownError: 'Unknown error',
    
    // Validation error messages
    missingStartNode: 'Missing start node (Start)',
    missingEndNode: 'Missing end node (End)',
    noConnections: 'No connections',
    circularConnection: 'Circular connection detected: node "{nodeName}" is involved in a cycle',
    isolatedNodes: 'Isolated nodes detected: {nodeNames}',
    startNodeNoOutput: 'Start node "{nodeName}" has no output connection',
    endNodeNoInput: 'End node "{nodeName}" has no input connection',
    
    // Node type descriptions
    nodeDescriptions: {
      start: 'Start point of workflow, only one allowed',
      end: 'End point of workflow, multiple allowed',
      waitReply: 'Node that waits for user reply',
      sendMessage: 'Node that sends message to user',
      condition: 'Node that decides workflow direction based on conditions',
      form: 'Node that displays form for user to fill',
      webhook: 'Node that calls external API'
    },
    // Node configuration descriptions
    nodeConfigDescriptions: {
      waitReply: '1. When workflow execution reaches this node, it will pause and wait for user reply\n2. Only specified user replies will continue workflow execution',
      sendMessage: '1. Send message to user\n2. Can include text, images, files, etc.\n3. Supports variable substitution',
      condition: '1. Decide next workflow step based on conditions\n2. Supports multiple branches\n3. Can judge based on user input, time, and other conditions',
      form: '1. Display form for user to fill\n2. Supports multiple form types\n3. After form submission, subsequent workflow will be triggered',
      webhook: '1. Call external API\n2. Can send data to other systems\n3. Decide workflow direction based on API response'
    },
    // Workflow initiator options
    initiatorOptions: {
      initiator: 'Workflow Initiator',
      anyUser: 'Any User',
      specificUser: 'Specific User'
    },
    
    // Missing translation keys
    conditionLabel: 'Condition Label',
    conditionLabelPlaceholder: 'Please enter condition label (optional)',
    cancel: 'Cancel',
    add: 'Add',
    selectDefaultPath: 'Select Default Path',
    defaultPath: 'Default Path',
    defaultPathDescription: 'When all condition groups are not met, this default path will be executed',
    conditionValuePlaceholder: 'Please enter condition value',
    selectProcessVariable: 'Select Process Data',
    qrCodeVariable: 'QR Code Variable',
    qrCodeMessagePlaceholder: 'Enter prompt message, e.g.: Please upload an image containing QR Code',
    qrCodeAiValidatorPromptHelp: 'AI will validate the value in the "QR Code Variable" extracted from the QR Code image. Please describe the validation rules, e.g., "QR Code content must be a 6-digit verification code".',
    qrCodeAiValidatorPromptPlaceholder: 'Describe the validation conditions that the QR Code variable value must meet, e.g., "QR Code content must be a 6-digit verification code".',
    qrCodeDescription1: 'This node will wait for user to upload an image containing QR Code',
    qrCodeDescription2: 'System will automatically scan the QR Code in the image and extract content',
    qrCodeDescription3: 'Scan result will be saved to the specified Process Data for use by subsequent nodes',
    waitForLocationHint: 'Select a Meta template first (to open the customer service window), then set the body text for the location request.',
    waitForLocationPromptMessageHelp: 'Before the user shares their location, the system sends the prompt below (direct message or template), then sends the interactive location request.',
    locationRequestBody: 'Location request body text',
    locationRequestBodyPlaceholder: 'Shown on the interactive location request (max 1024 characters)',
    locationRequestBodyRequired: 'Please enter the location request body text',
    locationResultVariable: 'Location JSON Process Data',
    waitForLocationDesc1: 'The prompt can be a direct message or a template (same as Wait for Reply), then the system sends the location-request interactive message. When the user shares their location, coordinates and address are saved to the selected Process Data as JSON.',
    waitForLocationDesc2: 'Must be sent within the customer service window; a template is usually required to open the conversation.',
    qrCodeSuccessMessage: 'QR Code Success Message',
    qrCodeErrorMessage: 'QR Code Error Message',
    seconds: 'seconds',
    messageWithVariablesPlaceholder: 'Enter message content, use ${variableName} to reference Process Data; for JSON variables, use ${JsonName.JsonFieldName}',
    availableVariables: 'Available Variables',
    variableSyntaxHelp: 'Click variable tags to insert into message, use ${variableName} syntax; for JSON Process Datas use ${JsonName.JsonFieldName}',
    // Process Data Cell node
    processDataCellNode: 'Process Data Cell Operation',
    defaultProcessDataCellNode: 'Update Process Data',
    processDataCell: {
      title: 'Assignment Rules',
      addRule: 'Add Rule',
      mode: 'Operation',
      modeCopyPv: 'Copy Data',
      modeFixedValue: 'Fixed Value',
      modeJsonToPv: 'Extract from JSON',
      modePvToJson: 'Write to JSON',
      modeAi: 'AI Smart Fill',
      sourceVariable: 'Source Process Data',
      sourceVariablePlaceholder: 'Select source process data',
      sourceJsonKey: 'Source JSON field name',
      sourceJsonKeyPlaceholder: 'e.g. Estate_Name',
      targetVariable: 'Target Process Data',
      targetVariablePlaceholder: 'Select target process data',
      targetJsonKey: 'Target JSON field name',
      targetJsonKeyPlaceholder: 'e.g. Estate_Name',
      fixedValue: 'Fixed Value',
      fixedValuePlaceholder: 'Enter fixed value, ${variableName} supported',
      jsonFieldMappings: 'JSON Field Mappings',
      jsonFieldMappingsAdd: 'Add JSON Field',
      jsonKey: 'JSON Field Name',
      jsonKeyPlaceholder: 'e.g. Estate_Name',
      valueSource: 'Value Source',
      valueSourcePv: 'Process Data',
      valueSourceFixed: 'Fixed Value',
      noRules: 'No rules yet — click "Add Rule" to start',
      ruleLabel: 'Rule {index}',
      aiSources: 'AI Data Sources',
      aiAdditionalPrompt: 'JSON Generation Prompt',
      aiAdditionalPromptPlaceholder: 'Tell the AI what data to extract from the conversation and return as JSON',
      aiOutputVariable: 'Write to Process Data',
      aiOutputVariablePlaceholder: 'Select process data (text or json type)',
      modeEFormToPv: 'From eForm Field',
      eFormNode: 'eForm Node',
      eFormNodePlaceholder: 'Select upstream sendEForm node',
      eFormFieldName: 'eForm Field',
      eFormFieldNamePlaceholder: 'e.g. Estate_Name (matches form input name)',
      eFormFieldsNotLoaded: 'Field list not loaded — ensure the eForm node has a form ID set, or type the field name manually',
      multiInstanceMode: 'Multiple forms handling',
      multiInstanceFirst: 'Use first form',
      multiInstanceLast: 'Use last form',
      multiInstanceJoin: 'Join all (text)',
      multiInstanceAllJson: 'Write all as JSON array',
      joinSeparator: 'Separator',
      validationNoMode: 'Please select an operation type',
      validationNoSource: 'Please select a source',
      validationNoTarget: 'Please select a target',
    },

    switchConditions: 'Condition Settings',
    equals: 'Equals',
    notEquals: 'Not Equals',
    greaterThan: 'Greater Than',
    lessThan: 'Less Than',
    contains: 'Contains',
    isEmpty: 'Is Empty',
    isNotEmpty: 'Is Not Empty',
    conditionValue: 'Condition Value',
    conditionLabel: 'Condition Label',
    remove: 'Remove',
    addCondition: 'Add Condition',
    newCondition: 'New Condition',
    defaultPath: 'Default Path',
    defaultPathPlaceholder: 'Path when all conditions are not met',
    switchDescription1: 'This node decides execution path based on Process Data values',
    switchDescription2: 'Can set multiple conditions, system will check each condition in order',
    switchDescription3: 'If all conditions are not met, default path will be executed',
    timeout: 'Timeout',
    condition1: 'Condition 1',
    
    // Switch node new UI translation keys
    conditionGroups: 'Condition Groups',
    conditionGroup: 'Condition Group',
    conditions: 'Conditions',
    outputPath: 'Output Path',
    selectOutputPath: 'Select Output Path',
    selectDefaultPath: 'Select Default Path',
    addConditionGroup: 'Add Condition Group',
    
    // Image related
    loadingImages: 'Loading images...',
    noImagesReceived: 'No images received',
    imagePreview: 'Image Preview',
    previewImage: 'Preview Image',
    downloadImage: 'Download Image',
    imageLoadFailed: 'Image load failed',
    imageStatusSuccess: 'Success',
    imageStatusFailed: 'Failed',
    imageStatusProcessing: 'Processing',
    imageStatusPending: 'Pending',
    imagesApiNotExists: 'Images API does not exist',
    imagesApiNotImplemented: 'Images API not implemented',
    loadImagesFailed: 'Load images failed',
    loadedImagesData: 'Loaded images data',
    loadingImagesData: 'Loading images data',
    previousImage: 'Previous Image',
    nextImage: 'Next Image',
    flipVertical: 'Flip Vertical',
    flipHorizontal: 'Flip Horizontal',
    rotateLeft: 'Rotate Left',
    rotateRight: 'Rotate Right',
    zoomOut: 'Zoom Out',
    zoomIn: 'Zoom In',
    editCondition: 'Edit Condition',
    operator: 'Operator',
    operatorRequired: 'Please select operator',
    selectProcessVariableRequired: 'Please select Process Data',
    noProcessVariables: 'No Process Data available',
    noProcessVariablesHint: 'Please create Process Data in Process Data management first',
    conditionValueRequired: 'Please enter condition value',
    conditionValuePlaceholder: 'Please enter condition value',
    conditionLabelPlaceholder: 'Please enter condition label (optional)',
    jsonPvMapping: 'JSON Process Data Mapping',
    jsonKeyPlaceholder: 'Enter JSON key name (e.g. amount, status, date)',
    jsonKeyDescription: 'When the Process Data is of JSON type, enter the key name to extract from the JSON object. The system will extract the value for that key and compare it against the condition value. Nested keys separated by "." are supported, e.g. "order.amount".',
    cancel: 'Cancel',
    update: 'Update',
    add: 'Add',
    
    // Switch node new UI translation keys
    conditionGroups: 'Condition Groups',
    conditionGroup: 'Condition Group',
    addConditionGroup: 'Add Condition Group',
    clickToSelectDefaultPath: 'Click to select default path',
    
    // QR Code node translation keys
    qrCodeErrorMessage: 'QR Code Error Message',
    waitReplySuccessMessage: 'Wait Reply Success Message',
    waitReplyErrorMessage: 'Wait Reply Error Message',
    waitReplySuccessMessagePlaceholder: 'Enter message to send when validation succeeds',
    waitReplyErrorMessagePlaceholder: 'Enter message to send when validation fails',
    
    // Common translations
    yes: 'Yes',
    no: 'No',
    
    // Alignment functions
    alignNodes: 'Align Nodes',
    alignLeft: 'Left Align',
    alignCenter: 'Center Align',
    alignRight: 'Right Align',
    alignTop: 'Top Align',
    alignMiddle: 'Vertical Center',
    alignBottom: 'Bottom Align',

    multiSelectHintTitle: 'Tip',
    multiSelectHint: 'Hold {key} + click on nodes to multi-select, then use the align buttons above',
    gotIt: 'Got it',

    unsavedChangesTitle: 'Unsaved changes',
    unsavedChangesContent: 'The workflow has been modified. Do you want to save before leaving?',
    saveAndLeave: 'Save and leave',
    leaveWithoutSaving: 'Leave without saving',
    cancel: 'Cancel'
  },

  // Document Library
  documentLibrary: {
    treeTitle: 'Document Catalog',
    collapseTree: 'Collapse catalog',
    expandTree: 'Expand document catalog',
    resizeTree: 'Drag to resize catalog panel',
    clearLocationFilter: 'Clear location filter',
    noData: 'No data',
    searchPlaceholder: 'Search file name, PV values, form fields, user…',
    filterType: 'Type',
    filterUser: 'User',
    filterModifiedDate: 'Modified date',
    typeEForm: 'Form eForm',
    typeDoc: 'Document Doc',
    typeReport: 'Report',
    totalDocuments: '{count} document(s)',
    totalRows: '{count} row(s)',
    noDocuments: 'No documents',
    loadMore: 'Load more',
    colThumbnail: 'Thumbnail',
    colNameKeyValues: 'Name / Key values',
    noPreviewImage: 'No Image',
    colWorkflow: 'Workflow',
    colUser: 'User',
    colStatus: 'Status',
    colUpdated: 'Updated',
    colActions: 'Actions',
    definitionFallback: 'Definition #{id}',
    executionLabel: 'Execution #{id}',
    open: 'Open',
    download: 'Download',
    emptyValue: '—',
    datePresetToday: 'Today',
    datePreset7d: 'Last 7 days',
    datePreset30d: 'Last 30 days',
    datePresetThisYear: 'This year',
    datePresetLastYear: 'Last year',
    treeEFormCount: 'eForm×{count}',
    treeDocCount: 'Doc×{count}',
    treeReportCount: 'Report×{count}',
    errorTreeLoad: 'Failed to load catalog tree',
    errorSearch: 'Search failed',
    statusApproved: 'Approved',
    statusCompleted: 'Completed',
    statusRejected: 'Rejected',
    statusPending: 'Pending',
    statusSubmitted: 'Submitted',
    valueSeparator: ': ',
    exportPdfSuccess: 'PDF exported successfully',
    exportPdfFailed: 'PDF export failed',
    metaFlowsPdfNotSupported: 'MetaFlows forms cannot be exported to PDF',
    saveSuccess: 'Form saved',
    saveFailed: 'Save failed',
    selectedCount: '{count} selected',
    batchDownloadZip: 'Download ZIP',
    clearSelection: 'Clear selection',
  },
  
  // Workflow Monitor (Running Apps)
    workflowMonitor: {
    title: 'Running Apps',
    description: 'Monitor and manage your WhatsApp workflow instances',
    runningAppsTitle: 'Running Apps',
    runningAppsDescription: 'Monitor the status of running workflow applications',
    overview: 'Overview',
    startLoadingInstances: 'Loading workflow instances (sort: {sortBy}, order: {sortOrder})',
    requestUrl: 'Request URL',
    requestParams: 'Request parameters',
    currentPaginationParams: 'Current pagination parameters',
    dataFromMonitorApi: 'Data received from monitor API',
    instanceDataStructure: 'Instance data structure',
    paginationInfo: 'Pagination information',
    firstInstanceCompleteData: 'First instance full data',
    inputJsonField: 'Input JSON field',
    inputJsonType: 'Input JSON type',
    parsedInputJson: 'Parsed Input JSON',
    parseInputJsonFailed: 'Failed to parse Input JSON',
    activeInstances: 'Active Instances',
    completedInstances: 'Completed Instances',
    failedInstances: 'Failed Instances',
    totalInstances: 'Total Instances',
    runningInstances: 'Running Instances',
    waitingInstances: 'Waiting Instances',
    errorInstances: 'Error Instances',
    
    // Instance List
    instanceList: 'Instance List',
    horizontalBoardTab: 'Workflow Activity Board',
    instanceListTab: 'Instance List',
    selectWorkflowName: 'Select Workflow Name',
    horizontalBoardDescription: 'Shows started nodes for each workflow instance in real time; newly started nodes appear automatically.',
    loadingHorizontalBoard: 'Loading activity board...',
    loadHorizontalBoardFailed: 'Failed to load activity board',
    noHorizontalBoardSteps: 'No started workflow nodes at the moment',
    viewChatBotConversation: 'View Conversation',
    viewChatOrderingCartConversation: 'View Cart Conversation',
    chatBotConversationTitle: 'Chat Bot Conversation',
    chatOrderingCartConversationTitle: 'Chat Ordering Cart Conversation',
    chatBotSessions: 'Sessions',
    chatBotMessages: 'messages',
    chatBotStateCollecting: 'Active',
    chatBotStateDone: 'Ended',
    chatBotAiStaff: 'AI Staff',
    chatBotUser: 'User',
    chatBotNoMessages: 'No messages yet',
    chatBotInputPlaceholder: 'Type a message (Enter to send, Shift+Enter for newline)',
    chatBotMessageSent: 'Message sent',
    chatBotMessageSendFailed: 'Failed to send message',
    chatBotMessageFailed: 'Send failed',
    chatBotMissingWaId: 'This session has no WhatsApp ID; cannot send',
    chatBotAdminIntervention: 'Admin',
    chatBotAdminInterventionHint: 'Messages sent here are admin interventions and are not written to the ChatBot conversation history',
    chatOrderingCartAdminInterventionHint: 'Messages sent here are admin interventions and are not written to the Chat Ordering Cart conversation history',
    noChatBotSessions: 'No conversation records for this node',
    noChatOrderingCartSessions: 'No ordering-cart conversation records for this node',
    loadChatBotSessionsFailed: 'Failed to load chat bot conversations',
    loadChatOrderingCartSessionsFailed: 'Failed to load chat ordering cart conversations',
    send: 'Send',
    artifactLinks: 'Artifact Links',
    htmlReport: 'HTML Report',
    htmlReportInstances: 'HTML Report Instances',
    generatedDocument: 'Generated Document',
    generatedDocumentInstances: 'Generated Document Instances',
    loadingReportInstances: 'Loading HTML report instances...',
    loadingDocInstances: 'Loading generated document instances...',
    loadReportInstancesFailed: 'Failed to load HTML report instances',
    loadDocInstancesFailed: 'Failed to load generated document instances',
    openHtmlReport: 'Open HTML Report',
    openGeneratedDocument: 'Open Generated Document',
    noReportInstances: 'No HTML report instances',
    noDocInstances: 'No generated document instances',
    artifactPreview: 'Artifact Preview',
    executionTime: 'Execution Time',
    waitingFor: 'Waiting For',
    workflowName: 'Workflow Name',
    instanceId: 'Instance ID',
    status: 'Status',
    currentStep: 'Current Step',
    startedAt: 'Started At',
    endedAt: 'Ended At',
    duration: 'Duration',
    createdBy: 'Created By',
    errorMessage: 'Error Message',
    
    // Statistics Cards
    totalInstancesCount: 'Total Instances',
    runningCount: 'Running',
    completedCount: 'Completed',
    successRate: 'Success Rate',
    
    // Status
    statusRunning: 'Running',
    statusCompleted: 'Completed',
    statusFailed: 'Failed',
    statusWaiting: 'Waiting',
    statusPaused: 'Paused',
    statusCancelled: 'Cancelled',
    statusPending: 'Pending',
    statusSent: 'Sent',
    statusDelivered: 'Delivered',
    statusRead: 'Read',
    statusPartiallyFailed: 'Partially Failed',
    
    // Actions
    viewDetails: 'View Details',
    pause: 'Pause',
    resume: 'Resume',
    cancel: 'Cancel',
    retry: 'Retry',
    viewLogs: 'View Logs',
    
    // Filters
    filterAll: 'All',
    filterRunning: 'Running',
    filterCompleted: 'Completed',
    filterFailed: 'Failed',
    filterWaiting: 'Waiting',
    searchPlaceholder: 'Search workflow name, instance ID...',
    selectStatus: 'Select Status',
    startDateRange: 'Start Date Range',
    endDateRange: 'End Date Range',
    refresh: 'Refresh',
    clearFilters: 'Clear',
    autoRefreshSettings: 'Auto Refresh Settings',
    
    // Instance Details
    instanceDetails: 'Instance Details',
    basicInfo: 'Basic Information',
    triggerSource: 'Trigger Source',
    executionHistory: 'Execution History',
    triggerSourceEmail: 'Email',
    triggerSourceWhatsApp: 'WhatsApp Message',
    triggerSourceUnknown: 'Unknown',
    triggerSourceFrom: 'From',
    triggerSourceTo: 'To',
    triggerSourceSubject: 'Subject',
    triggerSourceBody: 'Body',
    triggerSourceReceivedAt: 'Received At',
    triggerSourceMessageId: 'Message ID',
    triggerSourceAttachments: 'Attachments',
    triggerSourceContact: 'Contact',
    triggerSourceMessageText: 'Message Text',
    triggerSourceTimestamp: 'Timestamp',
    triggerSourceNoInput: 'No trigger data',
    triggerSourceRawJson: 'Raw JSON',
    triggerSourceStructured: 'Trigger payload (table)',
    triggerSourcePublishedManual: 'Published app (manual)',
    triggerSourceUserMessage: 'User message',
    manualTrigger: 'Manual Trigger',
    stepDetails: 'Step Details',
    formInstances: 'Form Instances',
    receivedImages: 'Received Images',
    inputData: 'Input Data',
    outputData: 'Output Data',
    processVariables: 'Process Data',
    workflowStarted: 'Workflow Started',
    workflowCompleted: 'Workflow Completed',
    openWhatsAppChat: 'Opening WhatsApp chat',
    availableFields: 'Available fields',
    noInputJsonField: 'Input JSON field is empty',
    sendMessage: 'Send message',
    executionStep: 'Execution Step',
    stepStatus: 'Status',
    stepStartTime: 'Start Time',
    stepEndTime: 'End Time',
    information: 'Information',
    error: 'Error',
    switchEvaluationResult: 'Condition Branch Result',
    evaluatedAt: 'Evaluated At',
    conditionGroupsCount: 'Condition Groups',
    defaultPathUsed: 'Default Path Used',
    conditionMatched: 'Condition Matched',
    selectedPathTarget: 'Selected Path',
    
    // Message Send Details
    viewMessageSendStatus: 'View Send Status',
    viewFormInstance: 'View Form Instance',
    viewEmbedded: 'View Form Instance',
    loadingFormInstance: 'Loading form instance...',
    close: 'Close',
    openInNewTab: 'Open in new tab',
    viewDataSet: 'View Dataset',
    messageSendDetails: 'Message Send Details',
    messageSendStatusDetails: 'Message Send Status Details',
    sendOverview: 'Send Overview',
    loadingEmbeddedFormInstance: 'Loading embedded form instance...',
    loadedEmbeddedFormInstance: 'Embedded form instance loaded',
    loadEmbeddedFormInstanceFailed: 'Failed to load embedded form instance',
    recipientDetails: 'Recipient Details',
    statusAnalysis: 'Status Analysis',
    totalRecipients: 'Total Recipients',
    sentCount: 'Sent',
    deliveredCount: 'Delivered',
    readCount: 'Read',
    failedCount: 'Failed',
    pendingCount: 'Pending',
    sendBasicInfo: 'Send Basic Information',
    sendRecordId: 'Send Record ID',
    messageSendId: 'Message Send ID',
    workflowExecutionId: 'Workflow Execution ID',
    nodeId: 'Node ID',
    nodeType: 'Node Type',
    messageType: 'Message Type',
    totalRecipientsCount: 'Total Recipients',
    successSendCount: 'Success Send Count',
    successCount: 'Success Count',
    failedSendCount: 'Failed Send Count',
    startTime: 'Start Time',
    endTime: 'End Time',
    completedAt: 'Completed At',
    messageContent: 'Message Content',
    errorInfo: 'Error Information',
    recipient: 'Recipient',
    recipientName: 'Recipient',
    recipientType: 'Type',
    recipientStatus: 'Status',
    type: 'Type',
    whatsAppMessageId: 'WhatsApp Message ID',
    whatsappMessageId: 'WhatsApp Message ID',
    sentAt: 'Sent At',
    sendTime: 'Send Time',
    deliveredAt: 'Delivered At',
    deliveredTime: 'Delivered Time',
    readAt: 'Read At',
    readTime: 'Read Time',
    retryCount: 'Retry Count',
    errorMessage: 'Error Message',
    sendStatusDistribution: 'Send Status Distribution',
    timeAnalysis: 'Time Analysis',
    sendStartTime: 'Send Start Time',
    sendEndTime: 'Send End Time',
    sendCompleteTime: 'Send Complete Time',
    totalSendTime: 'Total Send Time',
    sendSuccessRate: 'Success Rate',
    deliveryRate: 'Delivery Rate',
    user: 'User',
    contact: 'Contact',
    group: 'Group',
    hashtag: 'Hashtag',
    initiator: 'Initiator',
    phoneNumber: 'Phone Number',
    recipientTypeUser: 'User',
    recipientTypeContact: 'Contact',
    recipientTypeGroup: 'Group',
    recipientTypeHashtag: 'Hashtag',
    recipientTypeInitiator: 'Initiator',
    recipientTypePhoneNumber: 'Phone Number',
    pending: 'Pending',
    sent: 'Sent',
    delivered: 'Delivered',
    read: 'Read',
    failed: 'Failed',
    retrying: 'Retrying',
    
    // Status labels
    statusRunning: 'Running',
    statusCompleted: 'Completed',
    statusFailed: 'Failed',
    statusWaiting: 'Waiting',
    statusPaused: 'Paused',
    statusCancelled: 'Cancelled',
    
    // Time units
    minutes: 'minutes',
    hours: 'hours',
    
    // Operation results
    operationSuccess: 'Operation successful',
    operationFailed: 'Operation failed',
    loadInstancesFailed: 'Failed to load instances',
    loadStatisticsFailed: 'Failed to load statistics',
    loadDetailsFailed: 'Failed to load details',
    loadMessageSendDetailsFailed: 'Failed to load message send details',
    loadMessageSendStatusFailed: 'Failed to load message send status',
    
    // Form status
    pendingApproval: 'Pending Approval',
    approved: 'Approved',
    rejected: 'Rejected',
    
    // eForm status
    eformStatusPending: 'Pending',
    eformStatusApproved: 'Approved',
    eformStatusRejected: 'Rejected',
    eformStatusSubmitted: 'Submitted',
    
    // Boolean values
    yes: 'Yes',
    no: 'No',
    
    // Variable related
    variableName: 'Variable Name',
    dataType: 'Data Type',
    description: 'Description',
    currentValue: 'Current Value',
    defaultValue: 'Default Value',
    setTime: 'Set Time',
    setBy: 'Set By',
    sourceType: 'Source Type',
    sourceReference: 'Source Reference',
    required: 'Required',
    hasValue: 'Has Value',
    noValue: 'No Value',
    
    // Form instances
    formInstance: 'Form Instance',
    exportPdfSuccess: 'PDF exported successfully',
    exportPdfFailed: 'PDF export failed',
    metaFlowsPdfNotSupported: 'MetaFlows forms cannot be exported to PDF',
    formBasicInfo: 'Form Basic Information',
    formContent: 'Form Content',
    formReplyContent: 'Form Reply Content',
    formName: 'Form Name',
    instanceName: 'Instance Name',
    fillType: 'Fill Type',
    createdAt: 'Created At',
    userInput: 'User Input',
    approvalBy: 'Approval By',
    approvalTime: 'Approval Time',
    approvalNote: 'Approval Note',
    unnamedForm: 'Unnamed Form',
    unnamed: 'Unnamed',
    loadingEformInstances: 'Loading form instances...',
    loadingEmbeddedFormInstance: 'Loading embedded form instance...',
    loadedEmbeddedFormInstance: 'Embedded form instance loaded',
    loadEmbeddedFormInstanceFailed: 'Failed to load embedded form instance',
    loadFormInstanceFailed: 'Failed to load form instance',
    cannotLoadFormInstance: 'Cannot load form instance',
    setAt: 'Set At',
    
    // Others
    noStepExecutionRecords: 'No step execution records',
    loadingProcessVariables: 'Loading Process Data...',
    loadingFormInstances: 'Loading form instances...',
    noProcessVariables: 'No Process Data',
    noEformInstances: 'No form instances',
    noFormInstances: 'No form instances',
    selectedInstances: 'Selected {count} instances',
    paginationTotal: 'Showing {start} to {end} of {total} items',
    pageRange: 'Page {start}-{end} of {total} items',
    itemsPerPage: '/ page',
    jumpTo: 'Go to',
    page: 'Page',
    confirm: 'OK',
    tableChange: 'Table change event',
    sorterDetails: 'Sorter details',
    paginationChange: 'Pagination changed',
    sortField: 'Sort field',
    sortOrder: 'Sort order',
    paginationOnlyDefaultSort: 'Pagination change with default sort',
    whatsappChat: 'WhatsApp Chat',
    openSettingsModal: 'Open settings modal',
    cannotFindMessageSendId: 'Cannot find message send record ID, please check backend data',
    
    // MessageSendStatusModal translations
    messageSendStatus: 'Message Send Status',
    loadingMessageSendRecords: 'Loading message send records...',
    loadMessageSendRecordsFailed: 'Failed to load message send records',
    normalSend: 'Normal Send',
    retrySend: 'Reminder Send',
    escalationNotification: 'Escalation Notification',
    normalSendRecords: 'Normal Message Send Records',
    retrySendRecords: 'Reminder Message Send Records',
    escalationSendRecords: 'Escalation Message Send Records',
    totalSendCount: 'Total Send Count',
    successCount: 'Success Count',
    failureCount: 'Failure Count',
    currentRecord: 'Current',
    messageSendId: 'Message Send ID',
    nodeId: 'Node ID',
    sendReason: 'Send Reason',
    sendReasonNormal: 'Normal Send',
    sendReasonRetry: 'Reminder Send',
    sendReasonEscalation: 'Escalation Notification',
    sendReasonOverdue: 'Overdue Notification',
    status: 'Status',
    totalRecipients: 'Total Recipients',
    successCount: 'Success Count',
    failedCount: 'Failed Count',
    creator: 'Creator',
    startTime: 'Start Time',
    viewDetails: 'View Details',
    noMessageSendRecords: 'No message send records',
    recipientDetails: 'Recipient Details',
    recipient: 'Recipient',
    whatsAppMessageId: 'WhatsApp Message ID',
    sendTime: 'Send Time',
    deliveredTime: 'Delivered Time',
    readTime: 'Read Time',
    retryCount: 'Retry Count',
    errorMessage: 'Error Message',
    createTime: 'Create Time',
    normal: 'Normal',
    retry: 'Retry',
    escalation: 'Escalation',
    overdue: 'Overdue',
    pending: 'Pending',
    inProgress: 'In Progress',
    completed: 'Completed',
    failed: 'Failed',
    partiallyFailed: 'Partially Failed',
    sent: 'Sent',
    delivered: 'Delivered',
    read: 'Read',
    retrying: 'Retrying',
    operation: 'Operation',
    person: 'person',
    time: 'Time',
    userResponse: 'User Response',
    outputUserRepliedContinuing: 'User replied, continuing workflow',
    outputUserProvidedResponse: 'User provided response',
    locationMapTitle: 'Shared location',
    locationMapClickToEnlarge: 'Click to enlarge',
    locationName: 'Place name',
    locationAddress: 'Address',
    error: 'Error',
    step: 'Step',
    
    // Instance list
    instanceList: 'Instance List',
    workflowName: 'Workflow Name',
    instanceId: 'Instance ID',
    status: 'Status',
    currentStep: 'Current Step',
    startedAt: 'Started At',
    endedAt: 'Ended At',
    duration: 'Execution Time',
    createdBy: 'Created By',
    errorMessage: 'Error Message',
    
    // Status
    statusRunning: 'Running',
    statusCompleted: 'Completed',
    statusFailed: 'Failed',
    statusWaiting: 'Waiting',
    statusPaused: 'Paused',
    statusCancelled: 'Cancelled',
    
    // Actions
    viewDetails: 'View Details',
    pause: 'Pause',
    resume: 'Resume',
    cancel: 'Cancel',
    retry: 'Retry',
    viewLogs: 'View Logs',
    
    // Filters
    filterAll: 'All',
    filterRunning: 'Running',
    filterCompleted: 'Completed',
    filterFailed: 'Failed',
    filterWaiting: 'Waiting',
    searchPlaceholder: 'Search workflow name, instance ID...',
    
    // Instance details
    instanceDetails: 'Instance Details',
    basicInfo: 'Basic Information',
    executionHistory: 'Execution History',
    stepDetails: 'Step Details',
    formInstances: 'Form Instances',
    inputData: 'Input Data',
    outputData: 'Output Data',
    
    // Step details
    stepIndex: 'Step Index',
    stepType: 'Step Type',
    stepStatus: 'Step Status',
    stepStartedAt: 'Started At',
    stepEndedAt: 'Ended At',
    stepDuration: 'Execution Time',
    stepInput: 'Input Data',
    stepOutput: 'Output Data',
    stepError: 'Error Message',
    
    // Form instances
    formName: 'Form Name',
    formStatus: 'Form Status',
    formSubmittedAt: 'Submitted At',
    formApprovedAt: 'Approved At',
    formRejectedAt: 'Rejected At',
    formApprovedBy: 'Approved By',
    formRejectedBy: 'Rejected By',
    formApprovalNote: 'Approval Note',
    formRejectNote: 'Rejection Note',
    
    // Statistics
    statistics: 'Statistics',
    todayInstances: 'Today Instances',
    weekInstances: 'This Week Instances',
    monthInstances: 'This Month Instances',
    averageExecutionTime: 'Average Execution Time',
    successRate: 'Success Rate',
    errorRate: 'Error Rate',
    
    // Action confirmations
    confirmPause: 'Are you sure you want to pause this workflow instance?',
    confirmResume: 'Are you sure you want to resume this workflow instance?',
    confirmCancel: 'Are you sure you want to cancel this workflow instance?',
    confirmRetry: 'Are you sure you want to retry this workflow instance?',
    cancelConfirmTitle: 'Cancel Workflow Instance',
    cancelConfirmMessage: 'Are you sure you want to cancel this workflow instance? The workflow will stop immediately.',
    
    // Action results
    pauseSuccess: 'Workflow instance paused',
    resumeSuccess: 'Workflow instance resumed',
    cancelSuccess: 'Workflow instance cancelled',
    retrySuccess: 'Workflow instance retry started',
    operationFailed: 'Operation failed',
    whatsappChat: 'WhatsApp Chat',
    pause: 'Pause',
    resume: 'Resume',
    retry: 'Retry',
    cancel: 'Cancel',
    delete: 'Delete',
    deleteSuccess: 'Workflow instance deleted',
    deleteFailed: 'Failed to delete workflow instance',
    deleteConfirmTitle: 'Delete Workflow Instance',
    deleteConfirmMessage: 'Are you sure you want to delete instance {instanceId} ({workflowName})? This action cannot be undone and related records will be removed.',
    
    // Real-time updates
    realTimeUpdate: 'Real-time Updates',
    autoRefresh: 'Auto Refresh',
    refreshInterval: 'Refresh Interval',
    lastUpdated: 'Last Updated',
    
    // Export functionality
    exportData: 'Export Data',
    exportToExcel: 'Export to Excel',
    exportToCsv: 'Export to CSV',
    exportToPdf: 'Export to PDF',
    
    // Batch operations
    batchOperations: 'Batch Operations',
    batchPause: 'Batch Pause',
    batchResume: 'Batch Resume',
    batchCancel: 'Batch Cancel',
    batchRetry: 'Batch Retry',
    batchDelete: 'Batch Delete',
    clearSelection: 'Clear Selection',
    selectInstances: 'Select Instances',
    selectedCount: 'Selected {count} instances',
    batchNoApplicableInstances: 'No applicable instances for "{action}" in selection',
    batchOperationSuccess: 'Successfully applied "{action}" to {count} instance(s)',
    batchOperationPartialFail: 'Partial failure: {success} succeeded, {fail} failed',
    batchCancelConfirmTitle: 'Batch Cancel Workflow Instances',
    batchCancelConfirmMessage: 'Are you sure you want to cancel the selected {count} running instance(s)? Workflows will stop immediately and cannot be recovered.',
    batchDeleteConfirmTitle: 'Batch Delete Workflow Instances',
    batchDeleteConfirmMessage: 'Are you sure you want to delete the selected {count} instance(s)? This will remove related records and cannot be undone.',
    emailDeleteConfirmTitle: 'Delete Email-Triggered Instance',
    emailDeleteConfirmContent: 'This execution was triggered by email. After deletion, do you want to allow this email to trigger the workflow again?',
    emailDeleteAllowRetrigger: 'Yes, allow this email to trigger again',
    emailDeleteKeepProcessed: 'No, keep record (email will not trigger again)',
    batchDeleteEmailConfirmTitle: 'Batch Delete (Email-Triggered Included)',
    batchDeleteEmailConfirmContent: 'Among the {total} selected, {emailCount} are email-triggered. After deletion, do you want to allow those emails to trigger the workflow again?',
    deleteFilesChoiceTitle: 'Delete Related Files As Well?',
    deleteFilesChoiceContentSingle: 'Instance {instanceId} ({workflowName}) may contain received images, videos, documents, etc. By default these files remain on the server after the instance record is deleted (they are not removed automatically). Please choose how to proceed:',
    deleteFilesChoiceContentBatch: 'The {count} selected instance(s) may contain received images, videos, documents, etc. By default these files remain on the server after the instance records are deleted (they are not removed automatically). Please choose how to proceed:',
    deleteFilesChoiceKeepFiles: 'Delete record only, keep files',
    deleteFilesChoiceDeleteFiles: 'Delete record and files',
    deleteFilesChoiceDownloadThenDelete: 'Download backup first, then delete record and files',
    deleteFilesBackupSuccess: 'Backup downloaded',
    deleteFilesBackupEmpty: 'No files to back up in this scope, continuing with deletion',
    deleteFilesBackupFailed: 'Failed to package backup files',
    
    // Log viewing
    executionLogs: 'Execution Logs',
    logLevel: 'Log Level',
    logTime: 'Time',
    logMessage: 'Message',
    logDetails: 'Details',
    
    // Performance monitoring
    performanceMetrics: 'Performance Metrics',
    responseTime: 'Response Time',
    throughput: 'Throughput',
    resourceUsage: 'Resource Usage',
    memoryUsage: 'Memory Usage',
    cpuUsage: 'CPU Usage',
    
    // Error handling
    errorHandling: 'Error Handling',
    errorCount: 'Error Count',
    errorTrend: 'Error Trend',
    errorDetails: 'Error Details',
    errorResolution: 'Error Resolution',
    
    // Notification settings
    notifications: 'Notification Settings',
    emailNotifications: 'Email Notifications',
    smsNotifications: 'SMS Notifications',
    webhookNotifications: 'Webhook Notifications',
    notificationEvents: 'Notification Events',
    notifyOnError: 'Notify on Error',
    notifyOnCompletion: 'Notify on Completion',
    notifyOnDelay: 'Notify on Delay',
    
    // Media files related
    receivedMedia: 'Received Media',
    uploadMedia: 'Upload',
    uploading: 'Uploading…',
    mediaUploadSuccess: 'Files uploaded successfully',
    mediaUploadFailed: 'Upload failed',
    loadingMediaFiles: 'Loading media files...',
    noMediaFiles: 'No media files',
    mediaFilesApiNotExists: 'Media files API does not exist',
    mediaFilesApiNotImplemented: 'Media files API not implemented',
    loadMediaFilesFailed: 'Load media files failed',
    loadedMediaFilesData: 'Loaded media files data',
    rootFolder: 'Root Folder',
    files: 'files',
    totalFiles: 'Total Files',
    image: 'Image',
    video: 'Video',
    audio: 'Audio',
    document: 'Document',
    file: 'File',
    view: 'View',
    download: 'Download',
    unnamed: 'Unnamed',
    
    // Lightbox toolbar
    rotateLeft: 'Rotate Left',
    rotateRight: 'Rotate Right',
    flipHorizontal: 'Flip Horizontal',
    flipVertical: 'Flip Vertical',
    zoomIn: 'Zoom In',
    zoomOut: 'Zoom Out',
    reset: 'Reset',
    
    // User replies (message validations)
    userReplies: 'User Replies',
    validationPassed: 'Valid',
    validationFailed: 'Invalid',
    others: 'Others',
    caption: 'Caption: ',
    reply: 'reply',
    replies: 'replies'
  },

  // Workflow List Page
  workflowList: {
    add: 'Add',
    batchDelete: 'Batch Delete',
    batchEnable: 'Batch Enable',
    batchDisable: 'Batch Disable',
    clearFilter: 'Clear Filter',
    manualStart: 'Manual Start',
    select: 'Select',
    clear: 'Clear',
    confirmBatchDelete: 'Confirm Batch Delete',
    confirmBatchEnable: 'Confirm Batch Enable',
    confirmBatchDisable: 'Confirm Batch Disable',
    confirmDelete: 'Confirm Delete',
    cancel: 'Cancel',
    confirmDeleteSelected: 'Are you sure you want to delete the selected',
    confirmEnableSelected: 'Are you sure you want to enable the selected',
    confirmDisableSelected: 'Are you sure you want to disable the selected',
    workflows: ' workflows',
    cannotBeUndone: 'This action cannot be undone!',
    successfullyDeleted: 'Successfully deleted',
    successfullyEnabled: 'Successfully enabled',
    successfullyDisabled: 'Successfully disabled',
    batchDeleteFailed: 'Batch delete failed',
    batchOperationFailed: 'Batch operation failed',
    pleaseSelectWorkflows: 'Please select workflows to delete',
    pleaseSelectWorkflowsToOperate: 'Please select workflows to operate on',
    workflowStarted: 'Successfully started',
    manualStartMessage: 'Manually started workflow',
    deleteWithRelatedRecords: 'Delete workflow and related records',
    confirmDeleteWithRelatedRecords: 'Are you sure you want to delete workflow "{name}"?',
    relatedRecordsWillBeDeleted: 'Deleting this workflow will also delete the following related records:',
    executionInstances: 'Execution instances',
    stepExecutions: 'Step execution records',
    messageSends: 'Message send records',
    messageRecipients: 'Message recipient records',
    queryResults: 'Dataset query results',
    queryRecords: 'Dataset query records',
    eformInstances: 'Form instances',
    messageValidations: 'Message validation records',
    chatMessages: 'Chat messages',
    processVariableValues: 'Process Data values',
    processVariableDefinitions: 'Process Data definitions',
    noRelatedRecords: 'This workflow has no related records and can be deleted directly.',
    loadingRelatedRecords: 'Loading related records...',
    warningDeleteTitle: '⚠️ CRITICAL WARNING: Deletion Cannot Be Undone!',
    warningDeleteDescription: 'Deleting this workflow definition will permanently delete all related data, including: the workflow definition itself, all workflow execution instances, form instances, form approval records, message send records, step execution records, dataset query records, Process Data, message validation records, etc. All data will be permanently deleted and cannot be recovered!',
    criticalWarning: '⚠️ This operation cannot be undone! Please confirm you really want to delete this data.',
    confirmStatusChange: 'Confirm Status Change',
    confirmStatusChangeContent: 'Are you sure you want to change the status of workflow "{name}" to "{action}"?',
    successfullyChangedStatus: 'Status successfully changed to',
    statusChangeFailed: 'Status change failed'
  },

  // Process Data Management
  processVariables: {
    title: 'Process Data Management',
    variableList: 'Process Data List',
    addVariable: 'Add Variable',
    editVariable: 'Edit Variable',
    deleteVariable: 'Delete Variable',
    createVariable: 'Create Variable',
    updateVariable: 'Update Variable',
    cancel: 'Cancel',
    save: 'Save',
    
    // Variable Properties
    variableName: 'Variable Name',
    displayName: 'Display Name',
    dataType: 'Data Type',
    description: 'Description',
    isRequired: 'Is Required',
    defaultValue: 'Default Value',
    validationRules: 'Validation Rules',
    jsonSchema: 'JSON Schema',
    
    // Data Type Options
    dataTypeString: 'String (string)',
    dataTypeInt: 'Integer (int)',
    dataTypeDecimal: 'Decimal (decimal)',
    dataTypeDatetime: 'Date Time (datetime)',
    dataTypeBoolean: 'Boolean (boolean)',
    dataTypeText: 'Long Text (text)',
    dataTypeJson: 'JSON Object (json)',
    
    // Form Placeholders
    variableNamePlaceholder: 'e.g.: customer_name',
    displayNamePlaceholder: 'e.g.: Customer Name',
    descriptionPlaceholder: 'Describe the purpose of this variable',
    defaultValuePlaceholder: 'Default value for the variable',
    validationRulesPlaceholder: 'JSON format validation rules',
    jsonSchemaPlaceholder: 'JSON Schema definition (required for JSON type only)',
    
    // Validation Messages
    variableNameRequired: 'Please enter variable name',
    variableNamePattern: 'Variable name can only contain letters, numbers and underscores, and cannot start with a number',
    dataTypeRequired: 'Please select data type',
    
    // Status Labels
    required: 'Required',
    optional: 'Optional',
    
    // Operation Results
    createSuccess: 'Process Data created successfully',
    updateSuccess: 'Process Data updated successfully',
    deleteSuccess: 'Process Data deleted successfully',
    createFailed: 'Process Data creation failed',
    updateFailed: 'Process Data update failed',
    deleteFailed: 'Process Data deletion failed',
    saveFailed: 'Save Process Data failed',
    fetchFailed: 'Failed to fetch Process Data',
    
    // Confirmation Dialogs
    confirmDelete: 'Are you sure you want to delete this Process Data?',
    confirmDeleteOk: 'Confirm',
    confirmDeleteCancel: 'Cancel',
    
    // Empty States
    noVariables: 'No Process Data yet, click "Add Variable" to start creating',
    noDisplayName: 'No display name',
    selectVariableToEdit: 'Please select a Process Data to edit, or click "Add Variable" to create a new Process Data',
    
    // Management Button
    manageProcessVariables: 'Manage Process Data',

    // PV Display Settings (used by PendingTasks expanded row)
    displaySection: 'List Display Settings',
    showInList: 'Show in Form List',
    showInFormList: 'Show in Form List',
    showInFormListHelp: 'When enabled, this PV appears in the "Process Data" section of PendingTasks/eForm lists.',
    showInListHelp: 'When enabled, this PV appears in the "Process Data" section of PendingTasks/eForm lists.',
    shownInList: 'Shown in Form List',
    shownInFormList: 'Shown in Form List',
    showInInstanceList: 'Show in Instance List',
    showInInstanceListHelp: 'When enabled, this PV value appears in the Activity Board instance header row and can be used as a filter.',
    shownInInstanceList: 'Shown in Instance List',
    displayLabel: 'Display Label',
    displayLabelHelp: 'If empty, falls back to DisplayName / VariableName.',
    displayLabelPlaceholder: 'e.g.: Customer Total',
    displayOrder: 'Display Order',
    displayOrderHelp: 'Lower values appear first. Usually the ↑/↓ buttons in the list are enough; manual entry rarely needed.',
    jsonKeyDisplay: 'JSON Key Display Settings',
    jsonKeyDisplayHelp: 'Define which keys to surface for this JSON variable. Each row becomes one column in the list.',
    noJsonKeys: 'No JSON Keys added yet',
    addJsonKey: 'Add JSON Key',
    jsonKeyPlaceholder: 'e.g., customerName',
    jsonKeyDisplayLabelPlaceholder: 'e.g., Customer Name',
    listColumnLabel: 'List column:',
    moveUp: 'Move Up',
    moveDown: 'Move Down'
  },

  // Calendar Page (Application → Calendar)
  calendar: {
    title: 'Calendar',
    viewDay: 'Day',
    viewWeek: 'Week',
    viewMonth: 'Month',
    viewYear: 'Year',
    today: 'Today',
    jumpToDate: 'Jump to date',
    jumpToMonth: 'Jump to month',
    jumpToYear: 'Jump to year',
    refresh: 'Refresh',
    newEvent: 'New Event',
    editEvent: 'Edit Event',
    filterAll: 'All Workflows',
    fromWorkflow: 'Workflow',
    fieldTitle: 'Title',
    fieldAllDay: 'All Day',
    fieldTime: 'Start / End',
    fieldWorkflow: 'Workflow Definition',
    fieldWorkflowPlaceholder: 'Optional: link this event to a workflow definition',
    fieldResources: 'Resources',
    fieldResourcesPlaceholder: 'Select contacts as event resources / workers',
    selectResources: 'Select resources',
    resourcePickerTitle: 'Select resources',
    resourcePickerSearchPlaceholder: 'Search name / phone / email / department / group / tag',
    resourceName: 'Name',
    resourcePosition: 'Position / Department',
    resourceCompany: 'Company',
    resourcePhone: 'Phone',
    resourceEmail: 'Email',
    resourceGroup: 'Group',
    resourceTags: 'Tags',
    filterGroup: 'Group',
    filterTag: 'Tag',
    clearFilters: 'Clear filters',
    apply: 'Apply',
    fieldLocation: 'Location',
    fieldColor: 'Color',
    fieldStatus: 'Status',
    fieldEventType: 'Calendar Type',
    fieldEventTypePlaceholder: 'Select or enter a calendar type',
    eventTypeDeleted: 'Calendar type deleted',
    eventTypeDeleteFail: 'Failed to delete calendar type',
    eventTypeDeleteInUse: 'This calendar type is still used by events and cannot be deleted',
    eventTypeDeleteInUseCount: 'This calendar type is still used by {count} event(s) and cannot be deleted',
    sidebarEventTypes: 'Calendar Types',
    untypedEvents: 'Untyped',
    noEventTypesYet: 'No calendar types yet. Enter one when creating an event.',
    fieldTypeColor: 'Type Color',
    editTypeColor: 'Set type color',
    typeColorSidebarHint: 'Adjust type color from the left sidebar',
    eventTypeColorUpdateFail: 'Failed to update calendar type color',
    collapseSidebar: 'Collapse sidebar',
    expandSidebar: 'Expand sidebar',
    fieldDescription: 'Description',
    statusConfirmed: 'Confirmed',
    statusTentative: 'Tentative',
    statusCancelled: 'Cancelled',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    saved: 'Saved',
    saveFail: 'Save failed',
    deleted: 'Deleted',
    deleteFail: 'Delete failed',
    confirmDelete: 'Delete this event?',
    requireTitle: 'Title is required',
    requireTime: 'Please select start and end time',
    loadFail: 'Failed to load events',
  },

  // Published Apps Page
  publishedApps: {
    title: 'Published Apps',
    description: 'Display all enabled workflow applications that support manual startup',
    totalApps: 'Total Apps',
    manualTriggerWorkflows: 'Manual Trigger Workflows',
    autoTriggerWorkflows: 'Auto Trigger Workflows',
    noManualWorkflows: 'No manual trigger workflows available',
    noAutoWorkflows: 'No auto trigger workflows available',
    loading: 'Loading published apps...',
    executionCount: 'Execution Count',
    creator: 'Creator',
    clickToStart: 'Click to Start',
    manualMessagePlaceholder: 'Type a message…',
    manualSend: 'Send',
    manualSendHint: 'Type a message, then tap the green send; use the paperclip or drag files into the dashed box',
    manualComposerDropHint: 'Drag files into this dashed area, or tap the paperclip to add files',
    manualAttachTooltip: 'Choose files from your device (multiple allowed)',
    manualDropOnIconHint: 'Drop files here or click to browse; you can also use the dashed box below',
    manualSendNeedContent: 'Enter a message or upload at least one file',
    starting: 'Starting...',
    autoOnly: 'Auto Only',
    unknown: 'Unknown',
    manual: 'Manual',
    auto: 'Auto',
    startWorkflowSuccess: 'Workflow "{name}" started successfully',
    startWorkflowQueued: 'Workflow "{name}" was submitted and is running in the background; check the workflow monitor for status and errors',
    startWorkflowFailed: 'Failed to start workflow',
    loadAppsFailed: 'Failed to load published apps',
    noDescription: 'No description',
    mockCustomerService: 'Customer Service Workflow',
    mockCustomerServiceDesc: 'Standardized process for handling customer inquiries and complaints',
    mockOrderProcess: 'Order Processing Workflow',
    mockOrderProcessDesc: 'Complete process from order receipt to shipment',
    mockPaymentConfirm: 'Payment Confirmation Workflow',
    mockPaymentConfirmDesc: 'Process for handling payment confirmation and invoice generation',
    mockAutoNotification: 'Auto Notification Workflow',
    mockAutoNotificationDesc: 'System automatically sends notifications'
  },

  // Data Set Management Page
  dataSetManagement: {
    title: 'Dataset Management',
    add: 'Add',
    createDataSet: 'Create Data Set',
    editDataSet: 'Edit Data Set',
    createDataSetTitle: 'Create Data Set',
    editDataSetTitle: 'Edit Data Set',
    save: 'Save',
    cancel: 'Cancel',
    
    // Table column headers
    name: 'Name',
    dataSourceType: 'Data Source Type',
    status: 'Status',
    recordCount: 'Record Count',
    lastUpdate: 'Last Update',
    neverSynced: 'Never Synced',
    actions: 'Actions',
    
    // Status labels
    active: 'Active',
    inactive: 'Inactive',
    error: 'Error',
    
    // Sync status labels
    idle: 'Idle',
    running: 'Running',
    completed: 'Completed',
    failed: 'Failed',
    paused: 'Paused',
    
    // Sync progress
    syncStatus: 'Sync Status',
    syncProgress: 'Sync Progress',
    syncInProgress: 'Dataset is currently syncing, please try again later',
    syncStarted: 'Sync started',
    syncCompleted: 'Sync completed - Inserted: {inserted}, Updated: {updated}, Deleted: {deleted}',
    syncFailed: 'Sync failed',
    inserted: 'Inserted',
    updated: 'Updated',
    deleted: 'Deleted',
    skipped: 'Skipped',
    processed: 'Processed',
    total: 'Total',
    syncPaused: 'Sync paused',
    readyToSync: 'Ready to sync',
    syncing: 'Syncing...',
    processingSpeed: 'Speed',
    remaining: 'Remaining',
    
    // Data source types
    sql: 'SQL',
    excel: 'EXCEL',
    googleDocs: 'GOOGLE_DOCS',
    
    // Data source type options (complete text)
    sqlQuery: 'SQL Query',
    excelFile: 'EXCEL File',
    googleDocsOption: 'GOOGLE_DOCS',
    
    // Action buttons
    viewRecords: 'View Records',
    syncData: 'Sync Data',
    edit: 'Edit',
    delete: 'Delete',
    deleteRecord: 'Delete Record',
    editRecord: 'Edit Record',
    editRecordTitle: 'Edit Record',
    recordUpdated: 'Record updated successfully',
    recordUpdateFailed: 'Failed to update record',
    
    // Confirmation dialogs
    confirmDelete: 'Are you sure you want to delete this DataSet?',
    confirmDeleteDescription: 'This will permanently delete the dataset "{datasetName}" and all {recordCount} records. This action cannot be undone.',
    confirmDeleteOk: 'Confirm',
    confirmDeleteCancel: 'Cancel',
    confirmDeleteRecord: 'Are you sure you want to delete this record?',
    confirmDeleteRecordDescription: 'This action cannot be undone. Please confirm to continue.',
    recordDeleted: 'Record deleted successfully',
    recordDeleteFailed: 'Failed to delete record',
    
    // Pagination
    totalRecords: 'Total {total} records',
    pageRange: 'Page ',
    total: ' records',
    pageSizeOptions: ['10', '20', '50', '100'],
    
    // Tabs
    basicInfo: 'Basic Information',
    dataSourceConfig: 'Data Source Configuration',
    columnDefinition: 'Column Definition',
    
    // Basic information form
    nameLabel: 'Name',
    namePlaceholder: 'Enter Data Set name',
    nameRequired: 'Please enter name',
    description: 'Description',
    descriptionPlaceholder: 'Enter description',
    isScheduled: 'Scheduled Update',
    updateInterval: 'Update Interval (minutes)',
    updateIntervalPlaceholder: 'e.g.: 60 (1 hour)',
    updateIntervalRequired: 'Please set update interval',
    syncDirection: 'Sync Direction',
    syncDirectionTooltip: 'Select the data synchronization direction: Inbound (read from external), Outbound (write to external), Bidirectional (write then read)',
    syncDirectionPlaceholder: 'Please select sync direction',
    syncDirectionInbound: 'Inbound (Read from external data source to internal)',
    syncDirectionOutbound: 'Outbound (Write from internal to external data source)',
    syncDirectionBidirectional: 'Bidirectional (Write to external, then read from external)',
    
    // Data source configuration
    dataSourceTypeLabel: 'Data Source Type',
    dataSourceTypePlaceholder: 'Select data source type',
    dataSourceTypeRequired: 'Please select data source type',
    dataSourceTypeInfo: 'Data Source Type Settings',
    dataSourceTypeDescription: 'Please select the data source type in the "Data Source Configuration" tab and configure accordingly.',
    
    // SQL configuration
    connectionType: 'Connection Type',
    usePresetConnection: 'Use Preset Connection',
    customConnection: 'Custom Connection',
    presetDatabaseConnection: 'Preset Database Connection',
    presetConnectionPlaceholder: 'Select database connection',
    erpDatabase: 'ERP Database',
    purpleRiceDatabase: 'Purple Rice Database',
    serverName: 'Server Name/IP',
    serverNamePlaceholder: 'e.g.: 192.168.1.100',
    serverNameRequired: 'Please enter server name or IP',
    port: 'Port',
    portPlaceholder: 'e.g.: 1433',
    databaseName: 'Database Name',
    databaseNamePlaceholder: 'e.g.: MyDatabase',
    databaseNameRequired: 'Please enter database name',
    authenticationType: 'Authentication Type',
    sqlServerAuth: 'SQL Server Authentication',
    windowsAuth: 'Windows Authentication',
    username: 'Username',
    usernamePlaceholder: 'e.g.: sa',
    usernameRequired: 'Please enter username',
    password: 'Password',
    passwordPlaceholder: 'Enter password',
    passwordRequired: 'Please enter password',
    additionalOptions: 'Additional Connection Options',
    additionalOptionsPlaceholder: 'e.g.: TrustServerCertificate=true;MultipleActiveResultSets=true',
    connectionTest: 'Connection Test',
    connectionTestDescription: 'After configuration, you can click the button below to test the connection.',
    testConnection: 'Test Connection',
    sqlQuery: 'SQL Query Statement',
    sqlQueryPlaceholder: 'SELECT * FROM table_name WHERE condition',
    sqlQueryRequired: 'Please enter SQL query statement',
    sqlParameters: 'SQL Parameters (JSON format)',
    sqlParametersPlaceholder: '{"param1": "value1", "param2": "value2"}',
    targetTableName: 'Target Table Name',
    targetTableNamePlaceholder: 'e.g., customers',
    targetTableNameRequired: 'Target table name is required for outbound or bidirectional sync',
    targetTableNameTooltip: 'Specify the SQL table name to write to during outbound sync (only required for outbound or bidirectional sync)',
    
    // Excel configuration
    excelFilePath: 'Excel File Path',
    excelFilePathPlaceholder: 'e.g.: C:/local/data.xlsx, /uploads/excel/data.xlsx, or \\\\\\\\server\\\\share\\\\folder\\\\file.xlsx (use UNC for network drives)',
    excelSheetName: 'Sheet Name',
    excelSheetNamePlaceholder: 'Select sheet',
    uploadExcelFile: 'Upload Excel File',
    excelUploadDescription: 'Excel Upload Instructions',
    excelUploadInfo: 'After successful upload, the file path will be automatically filled. After saving the DataSet, click the "Sync Data" button to import Excel data into the database. The system will automatically generate column definitions based on Excel headers.',
    selectSheetThenLoadColumns: 'Sheet list loaded. Please select a sheet and click "Load Column Definition" again.',
    
    // Google Docs configuration
    googleDocsUrl: 'Google Docs URL',
    googleDocsUrlPlaceholder: 'https://docs.google.com/spreadsheets/d/...',
    googleDocsUrlRequired: 'Please enter Google Docs URL',
    googleDocsSheetName: 'Sheet Name',
    googleDocsSheetNamePlaceholder: 'e.g.: Sheet1',
    googleDocsIntegration: 'Google Docs Integration Instructions',
    googleDocsIntegrationDescription: 'Please ensure that the Google Docs file is set to publicly readable, or configure appropriate authentication information.',
    loadColumnDefinition: 'Load Column Definition',
    tenantAdminOnly: 'Tenant_Admin only',
    sqlReadOnlyNotice: 'SQL queries are managed by Tenant_Admin. You can view but not modify.',
    
    // Auto update
    autoUpdate: 'Auto Update',
    autoUpdateInterval: 'Update Interval (minutes)',
    autoUpdateIntervalPlaceholder: 'e.g.: 60 (1 hour)',
    autoUpdateIntervalRequired: 'Please set update interval',
    
    // Column definition
    columnDefinitionDescription: 'Column Definition Instructions',
    columnDefinitionInfo: 'For Excel data sources, the system will automatically generate column definitions based on Excel headers. You can manually adjust column properties after syncing data.',
    columnName: 'Column Name',
    columnNamePlaceholder: 'e.g.: customer_id',
    columnNameRequired: 'Please enter column name',
    displayName: 'Display Name',
    displayNamePlaceholder: 'e.g.: Customer ID',
    dataType: 'Data Type',
    dataTypePlaceholder: 'Select data type',
    dataTypeRequired: 'Please select data type',
    string: 'String',
    text: 'Long text',
    int: 'Integer',
    decimal: 'Decimal',
    datetime: 'DateTime',
    boolean: 'Boolean',
    isPrimaryKey: 'Primary Key',
    isPrimaryKeyNormal: 'Normal',
    isSearchable: 'Searchable',
    isSearchableNot: 'Not Searchable',
    isSortable: 'Sortable',
    isSortableNot: 'Not Sortable',
    isIndexed: 'Indexed',
    isIndexedNot: 'Not Indexed',
    defaultValue: 'Default Value',
    defaultValuePlaceholder: 'Default value',
    displayFormat: 'Display Format',
    displayFormatPlaceholder: 'Select or enter format',
    displayFormatTooltip: 'Display format for numeric columns, e.g. $#,###.## for currency',
    displayFormatCustomHint: 'You can also type a custom format',
    sortOrder: 'Sort Order',
    addColumn: 'Add Column',
    removeColumn: 'Remove',
    
    // Record viewing
    dataRecords: 'Data Records',
    advancedSearch: 'Advanced Search',
    refresh: 'Refresh',
    recordId: 'ID',
    primaryKeyValue: 'Primary Key Value',
    recordStatus: 'Status',
    createdAt: 'Created At',
    nA: 'N/A',
    
    // Advanced search
    advancedSearchTitle: 'Advanced Search',
    searchConditions: 'Search Conditions',
    columnNameLabel: 'Column Name',
    columnNamePlaceholder: 'Select column',
    columnNameRequired: 'Please select column',
    operator: 'Operator',
    operatorPlaceholder: 'Select operator',
    operatorRequired: 'Please select operator',
    equals: 'Equals',
    contains: 'Contains',
    greaterThan: 'Greater Than',
    lessThan: 'Less Than',
    dateRange: 'Date Range',
    value: 'Value',
    valuePlaceholder: 'Enter search value',
    valueRequired: 'Please enter value',
    addSearchCondition: 'Add Search Condition',
    removeSearchCondition: 'Remove',
    sortBy: 'Sort By',
    sortByPlaceholder: 'Select sort column',
    sortOrder: 'Sort Order',
    ascending: 'Ascending',
    descending: 'Descending',
    executeSearch: 'Execute Search',
    
    // Operation result messages
    deleteSuccess: 'Delete successful',
    deleteFailed: 'Delete failed',
    syncSuccess: 'Sync successful! Processed {count} records',
    syncFailed: 'Sync failed',
    createSuccess: 'Create successful',
    updateSuccess: 'Update successful',
    operationFailed: 'Operation failed',
    fetchFailed: 'Failed to fetch DataSet list',
    fetchRecordsFailed: 'Failed to fetch records',
    processFailed: 'Processing failed',
    searchFailed: 'Search failed',
    foundRecords: 'Found {count} records',
    
    // Error messages
    pleaseSelectDataSourceType: 'Please select data source type',
    pleaseEnterName: 'Please enter name',
    pleaseEnterServerName: 'Please enter server name or IP',
    pleaseEnterDatabaseName: 'Please enter database name',
    pleaseEnterUsername: 'Please enter username',
    pleaseEnterPassword: 'Please enter password',
    pleaseEnterSqlQuery: 'Please enter SQL query statement first',
    pleaseSelectPresetConnection: 'Please select preset connection',
    pleaseEnterGoogleDocsUrl: 'Please enter Google Docs URL',
    pleaseEnterColumnName: 'Please enter column name',
    pleaseSelectDataType: 'Please select data type',
    pleaseSelectColumn: 'Please select column',
    pleaseSelectOperator: 'Please select operator',
    pleaseEnterValue: 'Please enter value',
    
    // File upload
    onlyExcelFiles: 'Only Excel files can be uploaded!',
    fileSizeLimit: 'File size cannot exceed 10MB!',
    uploadSuccess: 'Upload successful',
    uploadFailed: 'Upload failed',
    processingFile: 'Processing file, please wait...',
    getSheetNamesFailed: 'Failed to get sheet names',
    getColumnPreviewFailed: 'Failed to get column preview',
    autoGeneratedColumns: 'Auto-generated {count} column definitions',
    cannotAutoGenerateColumns: 'Cannot auto-generate column definitions',
    pleaseManuallyConfigure: 'Please configure manually',
    
    // Connection test
    testingConnection: 'Testing connection...',
    connectionTestSuccess: 'Connection test successful! Getting column definitions...',
    connectionTestFailed: 'Connection test failed',
    presetConnectionConfigured: 'Preset connection configured',
    whatoFlowDatabase: 'WhatoFlow Database',
    
    // Pagination
    pageRange: 'Records {start}-{end} of {total}',
    recordPageSizeOptions: ['20', '50', '100', '200'],
    recordsPerPage: 'Records per page:',
    previousPage: 'Previous',
    nextPage: 'Next',
    datasetNotFound: 'Dataset with ID {id} not found'
  },

  // Contact List Management
  contactList: {
    title: 'Contact Management',
    management: 'Contact Management',
    description: 'Manage your contact list and broadcast groups',
    searchPlaceholder: 'Search contacts...',
    allGroups: 'All Groups',
    allTags: 'All Tags',
    reset: 'Reset',
    import: 'Import',
    addContact: 'Add Contact',
    editContact: 'Edit Contact',
    deleteContact: 'Delete Contact',
    batchDelete: 'Batch Delete',
    selectedContacts: 'Selected {count} contacts',
    noContactsFound: 'No contacts found',
    noContactsDescription: 'Please add contacts or adjust search criteria',
    name: 'Name',
    title: 'Title',
    contactInfo: 'Contact Info',
    company: 'Company/Department',
    group: 'Group',
    tags: 'Tags',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    confirmDelete: 'Confirm Delete',
    confirmDeleteMessage: 'Are you sure you want to delete contact "{name}"? This action cannot be undone.',
    cancel: 'Cancel',
    deleteSuccess: 'Contact deleted successfully',
    deleteError: 'Failed to delete contact',
    batchDeleteSuccess: 'Successfully deleted {count} contacts',
    batchDeleteError: 'Failed to batch delete contacts',
    updateSuccess: 'Contact updated successfully',
    createSuccess: 'Contact created successfully',
    updateError: 'Failed to update contact',
    createError: 'Failed to create contact',
    loadError: 'Failed to load contact list',
    whatsappNumber: 'WhatsApp Number',
    email: 'Email',
    companyName: 'Company Name',
    department: 'Department',
    position: 'Position',
    occupation: 'Occupation',
    noGroup: '-',
    noDescription: 'No description',
    // Form fields
    broadcastGroup: 'Broadcast Group',
    hashtags: 'Tags',
    // Form placeholders
    namePlaceholder: 'Enter name',
    titlePlaceholder: 'Enter title',
    occupationPlaceholder: 'Enter occupation',
    positionPlaceholder: 'Enter position',
    whatsappPlaceholder: 'Enter WhatsApp number',
    emailPlaceholder: 'Enter email',
    companyPlaceholder: 'Enter company name',
    departmentPlaceholder: 'Enter department',
    broadcastGroupPlaceholder: 'Select broadcast group',
    hashtagsPlaceholder: 'Enter tags, separated by commas',
    // Validation messages
    nameRequired: 'Please enter name',
    whatsappNumberRequired: 'Please enter WhatsApp number',
    broadcastGroupRequired: 'Please select broadcast group',
    formValidationFailed: 'Form validation failed, please check required fields',
    // Buttons
    back: 'Back',
    save: 'Save',
    update: 'Update',
    create: 'Create',
    // Sidebar
    quickAddTags: 'Quick Add Tags',
    preview: 'Preview',
    currentTags: 'Current tags:',
    tagsLabel: 'Tags:',
    tabBasic: 'Basic',
    tabAttachments: 'Attachments',
    contactAvatar: 'Contact photo',
    uploadAvatar: 'Upload photo',
    changeAvatar: 'Change photo',
    attachmentHint: 'Upload personal documents such as ID or certificates (PNG, JPG, PDF)',
    saveBeforeUpload: 'Save the contact first to upload a photo or attachments',
    attachmentUpload: 'Upload file',
    openFile: 'Open',
    removeFile: 'Remove',
    uploadSuccess: 'Uploaded successfully',
    uploadError: 'Upload failed',
    removeSuccess: 'Removed',
    removeError: 'Remove failed',
    imageOnlyHint: 'Images only (jpg, png, gif, webp)',
    docTypesHint: 'PNG, JPG, or PDF only'
  },

  // Broadcast Groups Management
  broadcastGroups: {
    title: 'Broadcast Groups Management',
    description: 'Manage contact groups for easy categorization and broadcasting',
    addGroup: 'Add Group',
    editGroup: 'Edit Group',
    deleteGroup: 'Delete Group',
    groupName: 'Group Name',
    groupDescription: 'Group Description',
    groupColor: 'Group Color',
    contactCount: 'Contact Count',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    confirmDelete: 'Confirm Delete',
    confirmDeleteMessage: 'Are you sure you want to delete group "{name}"? This action cannot be undone.',
    cancel: 'Cancel',
    create: 'Create',
    update: 'Update',
    createSuccess: 'Group created successfully',
    updateSuccess: 'Group updated successfully',
    deleteSuccess: 'Group deleted successfully',
    createError: 'Failed to create group',
    updateError: 'Failed to update group',
    deleteError: 'Failed to delete group',
    loadError: 'Failed to load group list',
    noGroupsFound: 'No groups found',
    noGroupsDescription: 'Please add a group',
    quickSelect: 'Quick Select:',
    namePlaceholder: 'Enter group name',
    descriptionPlaceholder: 'Enter group description',
    nameRequired: 'Please enter group name',
    formValidationFailed: 'Form validation failed, please check required fields'
  },

  // Hashtags Management
  hashtags: {
    title: 'Tag Management',
    description: 'Manage contact tags for easy categorization and filtering',
    addTag: 'Add Tag',
    editTag: 'Edit Tag',
    deleteTag: 'Delete Tag',
    tagName: 'Tag Name',
    description: 'Description',
    color: 'Color',
    usageCount: 'Usage Count',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    confirmDelete: 'Confirm Delete',
    confirmDeleteMessage: 'Are you sure you want to delete tag "{name}"?',
    cannotDeleteMessage: 'This tag is still used by {count} contacts and cannot be deleted.',
    cancel: 'Cancel',
    create: 'Create',
    update: 'Update',
    createSuccess: 'Tag created successfully',
    updateSuccess: 'Tag updated successfully',
    deleteSuccess: 'Tag deleted successfully',
    createError: 'Failed to create tag',
    updateError: 'Failed to update tag',
    deleteError: 'Failed to delete tag',
    loadError: 'Failed to load tag list',
    noTagsFound: 'No tags found',
    adjustSearch: 'Please adjust search criteria',
    searchPlaceholder: 'Search tags...',
    quickSelect: 'Quick Select:',
    namePlaceholder: 'Enter tag name',
    descriptionPlaceholder: 'Enter tag description',
    nameRequired: 'Please enter tag name',
    formValidationFailed: 'Form validation failed, please check required fields'
  },
  
  // Broadcast Groups Management
  broadcastGroupsOld: {
    title: 'Broadcast Groups',
    description: 'Manage contact groups for easy categorization and broadcasting',
    addGroup: 'Add Group',
    editGroup: 'Edit Group',
    deleteGroup: 'Delete Group',
    groupName: 'Group Name',
    description: 'Description',
    color: 'Color',
    contactCount: 'Contact Count',
    createdAt: 'Created At',
    noGroupsFound: 'No groups found',
    noGroupsDescription: 'Please add groups',
    confirmDelete: 'Confirm Delete',
    confirmDeleteMessage: 'Are you sure you want to delete group "{name}"? This action cannot be undone.',
    createSuccess: 'Group created successfully',
    updateSuccess: 'Group updated successfully',
    deleteSuccess: 'Group deleted successfully',
    createError: 'Failed to create group',
    updateError: 'Failed to update group',
    deleteError: 'Failed to delete group',
    loadError: 'Failed to load group list',
    quickSelect: 'Quick Select:',
    noDescription: 'No description'
  },

  // Contact Import
  contactImport: {
    title: 'Contact Import',
    selectSource: 'Select Data Source',
    selectSourceDesc: 'Choose the data source to import from',
    mapFields: 'Field Mapping',
    mapFieldsDesc: 'Map data fields to contact fields',
    importData: 'Import Data',
    importDataDesc: 'Confirm and start importing',
    
    // Data source options
    selectDataSource: 'Select Data Source',
    excelFile: 'Excel File',
    excelFileDesc: 'Import data from Excel file',
    googleSheets: 'Google Sheets',
    sqlDatabase: 'SQL Database',
    uploadExcel: 'Upload Excel File',
    uploadExcelFile: 'Upload Excel File',
    connectGoogle: 'Connect Google Sheets',
    connectSQL: 'Connect SQL Database',
    supportedFormats: 'Supports .xlsx, .xls, .csv formats',
    googleSheetsDesc: 'Import data from Google Sheets',
    sqlDatabaseDesc: 'Import data from SQL database',
    
    // Excel configuration
    excelConfig: 'Excel File Configuration',
    excelFilePath: 'Excel File Path',
    selectSheet: 'Select Sheet',
    
    // Google Docs configuration
    googleDocsConfig: 'Google Docs Configuration',
    googleDocsUrl: 'Google Docs URL',
    
    // SQL configuration
    sqlConfig: 'SQL Connection Configuration',
    server: 'Server',
    database: 'Database',
    username: 'Username',
    password: 'Password',
    tableName: 'Table Name',
    customQuery: 'Custom Query',
    testConnection: 'Test Connection',
    loadData: 'Load Data',
    sqlPreviewTotalRows: 'Matching rows (count): {count}',
    sqlPreviewTopNote: 'Preview uses TOP {n} for speed; the actual import loads all matching rows.',
    sqlPreviewWithCteNote: 'This query uses WITH/CTE; TOP was not auto-added. Preview may be slower.',
    sqlLoadingFullForImport: 'Loading full SQL result for import…',
    sqlFullLoadFailed: 'Failed to load full SQL data',
    nextStep: 'Next Step',
    
    // Field mapping
    dataPreview: 'Data Preview',
    fieldMapping: 'Field Mapping',
    selectColumn: 'Select Column',
    selectGroup: 'Select Group',
    dataSourceType: 'Data Source Type',
    sheetName: 'Sheet Name',
    name: 'Name',
    title: 'Title',
    occupation: 'Occupation',
    position: 'Position',
    whatsappNumber: 'WhatsApp Number',
    email: 'Email',
    companyName: 'Company Name',
    department: 'Department',
    hashtags: 'Tags',
    broadcastGroup: 'Broadcast Group',
    
    // Import process
    importing: 'Importing...',
    importSuccess: 'Import Successful!',
    successCount: 'Successfully imported {count} contacts',
    failedCount: 'Failed {count} records',
    errors: 'Error Details',
    backToList: 'Back to Contact List',
    importMore: 'Import More',
    previous: 'Previous',
    startImport: 'Start Import',
    
    // Schedule related
    saveAsSchedule: 'Save as Scheduled Import',
    scheduleNamePlaceholder: 'Enter schedule name',
    scheduleNameRequired: 'Please enter schedule name',
    everyXMinutes: 'Every X Minutes',
    daily: 'Daily',
    weekly: 'Weekly',
    scheduleName: 'Schedule Name',
    manageSchedule: 'Manage Scheduled Imports',
    scheduleManagement: 'Contact Import Schedules',
    executionFrequency: 'Execution Frequency',
    importType: 'Import Type',
    lastExecution: 'Last Execution',
    nextExecution: 'Next Execution',
    editSchedule: 'Edit Schedule',
    manualExecute: 'Manual Execute',
    importExecutionProgress: 'Import progress',
    confirmDeleteSchedule: 'Are you sure you want to delete this schedule?',
    scheduleSaved: 'Schedule saved successfully!',
    scheduleSavedDesc: 'Your import has been saved as a scheduled task. You can view and manage it in the "Manage Scheduled Imports" section.',
    saveScheduleFailed: 'Failed to save schedule',
    pleaseEnterGoogleSheetsUrl: 'Please enter Google Sheets URL',
    detectedExcelFile: 'Excel file detected, using default sheet',
    googleSheetsVerified: 'Google Sheets URL verified successfully!',
    googleSheetsVerificationFailed: 'Google Sheets URL verification failed: ',
    pleaseUploadExcelFile: 'Please upload Excel file first',
    urlVerified: 'URL verified',
    fileUploaded: 'File uploaded',
    useDefaultSheet: 'The system will automatically use the default sheet for data import, no need to select sheet name.',
    basicSettings: 'Basic Settings',
    loadingPreview: 'Loading preview data...',
    noPreviewData: 'Unable to load preview data, you can manually edit field mapping',
    pleaseConnectGoogleSheets: 'Please connect to Google Sheets first',
    getSheetsList: 'Please connect to Google Sheets to get the sheet list',
    noMatchingSheet: 'No matching sheet found',
    scheduleNameExists: 'Schedule name already exists, please use a different name',
    
    // Duplicate confirmation
    duplicateConfirmation: 'Duplicate Records Confirmation',
    duplicateWarning: 'Duplicate WhatsApp numbers found',
    duplicateDescription: 'The following records have WhatsApp numbers that already exist in the system. If you continue, existing records will be overwritten. Please confirm if you want to update these records.',
    confirmUpdate: 'Confirm Update',
    rowNumber: 'Row',
    newData: 'New Data',
    existingData: 'Existing Data'
  },

  // Hashtags Management
  hashtags: {
    title: 'Tag Management',
    description: 'Manage contact tags for easy categorization and filtering',
    addTag: 'Add Tag',
    editTag: 'Edit Tag',
    deleteTag: 'Delete Tag',
    tagName: 'Tag Name',
    description: 'Description',
    color: 'Tag Color',
    usageCount: 'Usage Count',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    actions: 'Actions',
    searchPlaceholder: 'Search tags...',
    noTagsFound: 'No tags found',
    noTagsDescription: 'Please add tags',
    noTagsSearchDescription: 'Please adjust search criteria',
    confirmDelete: 'Confirm Delete',
    confirmDeleteMessage: 'Are you sure you want to delete tag "{name}"?',
    cannotDeleteInUse: 'This tag is still used by {count} contacts and cannot be deleted.',
    createSuccess: 'Tag created successfully',
    updateSuccess: 'Tag updated successfully',
    deleteSuccess: 'Tag deleted successfully',
    createError: 'Failed to create tag',
    updateError: 'Failed to update tag',
    deleteError: 'Failed to delete tag',
    loadError: 'Failed to load tag list',
    quickSelect: 'Quick Select:',
    noDescription: 'No description'
  },


  // Contact Edit Page
  contactEdit: {
    title: 'Add Contact',
    editTitle: 'Edit Contact',
    back: 'Back',
    save: 'Save',
    create: 'Create',
    update: 'Update',
    cancel: 'Cancel',
    name: 'Name',
    nameRequired: 'Please enter name',
    title: 'Title',
    occupation: 'Occupation',
    position: 'Position',
    whatsappNumber: 'WhatsApp Number',
    email: 'Email',
    companyName: 'Company Name',
    department: 'Department',
    broadcastGroup: 'Broadcast Group',
    selectGroup: 'Select Group',
    tags: 'Tags',
    tagsPlaceholder: 'Enter tags, separated by commas',
    currentTags: 'Current Tags:',
    quickAddTags: 'Quick Add Tags',
    preview: 'Preview',
    createSuccess: 'Contact created successfully',
    updateSuccess: 'Contact updated successfully',
    createError: 'Failed to create contact',
    updateError: 'Failed to update contact',
    loadError: 'Failed to load contact data',
    loadOptionsError: 'Failed to load options data'
  },

  apiProviders: {
    pageTitle: 'API Provider Management',
    pageDescription: 'Centralize management of AI and cloud document APIs, configure provider endpoints, models, and credentials for team-wide reuse and future expansion.',
    actions: {
      refresh: 'Refresh'
    },
    messages: {
      loadFailed: 'Failed to load API providers. Please try again later.',
      saveSuccess: 'Settings updated successfully.',
      saveFailed: 'Failed to save settings. Please check your input or try again later.',
      loadDetailFailed: 'Failed to load provider details. Please try again later.',
      validationFailed: 'Form validation failed. Please check your input.'
    },
    empty: 'No API providers available yet.',
    category: {
      ai: 'AI Services',
      clouddoc: 'Cloud Documents',
      emailserver: 'Email Server',
      erp: 'ERP Systems',
      voice: 'Voice AI',
      embedding: 'Embedding / RAG',
      rag: 'Managed RAG (Collections)'
    },
    noDescription: 'No description provided.',
    description: {
      'xai': 'Elon AI Grok official API',
      'xai-stt': 'xAI Speech-to-Text API',
      'xai-embed': 'xAI Embeddings (⚠️ xAI currently has no embedding model — unusable; use OpenAI/Gemini Embeddings, or switch to "Managed RAG → xAI Collections")',
      'xai-collections': 'xAI Collections (managed RAG): documents are uploaded to the xAI cloud where xAI auto chunks/embeds/indexes them, queried via /v1/documents/search. Requires an xAI API Key.',
      'openai-embeddings': 'OpenAI Embeddings (knowledge base RAG – model: text-embedding-3-small)',
      'gemini-embeddings': 'Google Gemini Embeddings (knowledge base RAG – model: text-embedding-004)',
      'deepseek-embeddings': 'DeepSeek Embeddings (⚠️ no official embedding API – use xai-embed / openai-embeddings instead)',
      'copilot-embeddings': 'GitHub Models Embeddings (requires GitHub PAT with models:read scope)',
      'openai': 'OpenAI Chat Completions',
      'openai-whisper': 'OpenAI Whisper Speech-to-Text API',
      'deepseek': 'DeepSeek official Chat API',
      'copilot': 'Copilot Chat API (requires enterprise license)',
      'gemini': 'Google AI Gemini API',
      'google-docs': 'Google Docs read/write API (Dataset import, document sync)',
      'microsoft-graph': 'Send emails via Office 365 using Microsoft Graph API. Requires OAuth 2.0 authentication and Mail.Send permission.',
      'odoo': 'Odoo 19 ERP integration (PO / Quotation / SO / Invoice / Delivery / Receipt / Return / Credit Note / Payment). Supports both XML-RPC and JSON-2 protocols.'
    },
    status: {
      active: 'Active',
      inactive: 'Inactive',
      activeTip: 'This provider is currently enabled for workflows and tools.',
      inactiveTip: 'This provider is currently disabled.'
    },
    apiKey: {
      set: 'API Key Configured',
      missing: 'API Key Missing',
      setTip: 'A key is stored and ready to use.',
      missingTip: 'No key configured; the provider cannot authenticate.'
    },
    configure: 'Configure',
    modal: {
      title: 'Configure {name}',
      loadingTitle: 'Loading settings…',
      save: 'Save Settings',
      cancel: 'Cancel',
      providerKeyLabel: 'Provider Key',
      defaultUrl: 'Default API URL',
      defaultModel: 'Recommended Model'
    },
    form: {
      active: 'Active Status',
      apiUrl: 'API URL',
      apiUrlRequired: 'Please enter the API URL.',
      apiUrlEmailServerTip: 'The {userPrincipalName} placeholder in Microsoft Graph API URL will be automatically replaced with the sender\'s email address when sending emails.',
      model: 'Model',
      modelRequired: 'Please choose or enter a model.',
      modelPlaceholder: 'Enter model name',
      temperature: 'Temperature',
      temperatureTip: 'Controls randomness; higher values yield more creative output.',
      topP: 'Top P',
      topPTip: 'Controls sampling range; lower values keep outputs conservative.',
      enableStreaming: 'Enable Streaming Output',
      apiKey: 'API Key',
      apiKeyPlaceholder: 'Enter new API key',
      clearApiKey: 'Clear stored API key',
      maskedKey: 'Current stored key: {key}',
      managementApiKey: 'Management API Key',
      managementApiKeyHint: 'Used to create / manage xAI Collections (requires Management Key permission). Only Tenant Admins can configure this.',
      managementApiKeyPlaceholder: 'Enter xAI Management API Key',
      clearManagementApiKey: 'Clear stored Management API Key',
      extraHeaders: 'Extra HTTP Headers (JSON)',
      extraHeadersTip: 'Provide custom headers in JSON format, e.g. {"X-Custom-Header":"value"}.',
      authType: 'Authentication Type',
      authTypeTip: 'Choose how this provider authenticates. Defaults to the vendor recommendation.',
      authTypePlaceholder: 'Select authentication type',
      authTypeOptions: {
        apiKey: 'API Key',
        bearerToken: 'Bearer Token',
        serviceAccount: 'Service Account JSON',
        oauth: 'OAuth 2.0'
      },
      authConfigJson: 'Auth Configuration (JSON)',
      authConfigTip: 'Store tenant, client ID, service account JSON, or other auth metadata.',
      authConfigJsonEmailServer: 'OAuth 2.0 Configuration (JSON)',
      authConfigTipEmailServer: 'Microsoft Graph API requires OAuth 2.0 authentication. Enter JSON format: {"tenantId":"your-tenant-id","clientId":"your-client-id","clientSecret":"your-client-secret"}',
      oauthConfig: 'OAuth 2.0 Authentication Settings',
      tenantId: 'Tenant ID',
      tenantIdRequired: 'Please enter Tenant ID',
      tenantIdTip: 'Azure AD tenant ID, can be found in Azure Portal',
      clientId: 'Application (client) ID',
      clientIdRequired: 'Please enter Application (client) ID',
      clientIdTip: 'Application (client) ID, can be found in Azure Portal app registration',
      clientSecret: 'Client Secret',
      clientSecretRequired: 'Please enter Client Secret',
      clientSecretTip: 'Application secret value, can be created in Azure Portal app registration',
      emailSettings: 'Email Sending Settings',
      fromEmail: 'Send & Receive Email Address',
      fromEmailRequired: 'Please enter send & receive email address',
      fromEmailInvalid: 'Please enter a valid email address',
      fromEmailTip: 'Used for: sender address when sending mail; mailbox to monitor (receive) when using Start node Email monitoring.',
      replyTo: 'Reply To Address',
      replyToInvalid: 'Please enter a valid email address',
      replyToTip: 'Email address for replies (optional)',
      saveToSentItems: 'Save to Sent Items',
      saveToSentItemsTip: 'Whether to save sent emails to sender\'s Sent Items folder',
      enabled: 'Enabled',
      disabled: 'Disabled',
      testEmail: 'Send Test Email',
      testEmailModalTitle: 'Send Test Email',
      sendTestEmail: 'Send',
      testEmailTo: 'Recipient',
      testEmailToRequired: 'Please enter recipient email address',
      testEmailToInvalid: 'Please enter a valid email address',
      testEmailToTip: 'Test email will be sent to this address',
      testEmailSubjectLabel: 'Subject',
      testEmailSubject: 'WhattoFlow Email Test',
      testEmailSubjectRequired: 'Please enter email subject',
      testEmailBodyLabel: 'Body',
      testEmailBody: 'This is a test email to verify Microsoft Graph API email sending configuration.',
      testEmailBodyRequired: 'Please enter email body',
      testEmailSuccess: 'Test email sent successfully! Please check your inbox.',
      testEmailFailed: 'Test email failed. Please check your configuration.',
      testEmailValidationError: 'Please fill in required fields (Tenant ID, Client ID, Client Secret, From Email).',
      settingsJson: 'Advanced Settings (JSON)',
      settingsJsonTip: 'Override provider-specific parameters such as temperature, top_p, or top_k.',
      settingsJsonEmailServer: 'Email Settings (JSON)',
      settingsJsonTipEmailServer: 'Email sending configuration, e.g.: {"fromEmail":"sender@example.com","replyTo":"reply@example.com","saveToSentItems":true}',
      resetSettings: 'Apply Default Settings',
      resetSettingsHint: 'Restores vendor default values and overrides current changes.',
      jsonInvalid: 'Please provide valid JSON text.',
      odooSettings: 'Odoo Connection Settings',
      odooProtocol: 'Protocol',
      odooProtocolTip: 'XML-RPC: supported by all Odoo deployments. JSON-2: only Odoo Custom plan; for other plans pick XML-RPC (the system will auto-fallback).',
      odooDatabase: 'Database',
      odooDatabaseRequired: 'Please enter the Odoo database name.',
      odooDatabaseTip: 'Same as the db name shown on the Odoo login page.',
      odooDefaultLogin: 'Service Account Login',
      odooDefaultLoginRequired: 'Please enter the service account login.',
      odooDefaultLoginTip: 'Use a dedicated integration user and create an API Key in Odoo Settings → Users → API Keys.',
      odooDefaultCompanyId: 'Default Company ID (multi-company)',
      odooDefaultCompanyIdTip: 'Forces Odoo context.allowed_company_ids; leave empty for single-company.',
      odooPort: 'Port',
      odooPortTip: 'Default 443 (HTTPS); self-hosted Odoo often uses 8069.',
      odooTimeoutSeconds: 'Timeout (seconds)',
      odooApiKeyHint: 'API Key: create one under Odoo Settings → Users → API Keys (Odoo 14+). When using JSON-2, rotate the key every 3 months.',
      testOdoo: 'Test Odoo Connection',
      testOdooSuccess: 'Odoo connection test succeeded',
      testOdooFailed: 'Odoo connection test failed',
      testOdooValidationError: 'Please provide API URL, Database and service account login first.',
      voiceSettings: 'Speech-to-Text Settings',
      embeddingSettings: 'Embedding Settings',
      testEmbedding: 'Test Embedding',
      testEmbeddingOk: 'Embedding OK (model: {model}, dimensions: {dimensions})',
      testEmbeddingFailed: 'Embedding test failed',
      queryAvailableModels: 'Query available models from provider',
      embeddingModelsTitle: 'Available Embedding Models',
      embeddingModelsHint: 'Copy a model name below and paste it into the Model field above.',
      embeddingModelsEmpty: 'No embedding models found. Please check your API key.',
      embeddingExperimentalHint: 'GitHub Models (copilot-embeddings) requires a GitHub PAT with models:read scope. For self-hosted RAG use openai-embeddings or gemini-embeddings; for xAI use "Managed RAG → xAI Collections".',
      voiceLanguage: 'Default Language Code',
      voiceLanguageTip: 'Language code for ITN text formatting only (e.g. en, ja, ko, fr, de). x.ai does NOT support zh (Chinese) for formatting. Leave blank for Chinese / Cantonese — the model auto-detects and transcribes accurately without a language hint.',
      voiceFormat: 'Enable ITN Formatting (format)',
      voiceFormatTip: 'When enabled, spoken numbers and currencies are converted to written form (e.g. "one hundred dollars" → "$100"). Requires a language code.',
      voiceApiKeyHint: 'API Key: x.ai STT uses the same Bearer API key as the Chat API.',
      testStt: 'Test Speech-to-Text',
      testSttSuccess: 'Speech-to-text test succeeded',
      testSttFailed: 'Speech-to-text test failed',
      advanced: 'Advanced'
    }
  },

  // WhatsApp Phone Number Verification Management
  phoneVerification: {
    title: 'WhatsApp Phone Number Verification Management',
    pageDescription: 'Manage WhatsApp phone number verification',
    refresh: 'Refresh',
    uploadCertificate: 'Upload Certificate',
    currentCompany: 'Current Company: {name}',
    allCompaniesBanner: 'The table below lists WhatsApp phone verifications for all companies.',
    tenantAdminHint: 'Verifications from all companies are shown. When uploading a certificate, pick the target company in the dialog (current default context: {name}).',
    filterByCompany: 'Filter by company',
    filterCompanyPlaceholder: 'All companies',
    loadVerificationsForbidden: 'You are not allowed to load verifications. Sign in and ensure you are Tenant_Admin.',
    phoneNumber: 'Phone Number',
    status: 'Status',
    certificateExpiry: 'Certificate Expiry',
    codeExpiry: 'Verification Code Expiry',
    phoneNumberId: 'Phone Number ID',
    createdAt: 'Created At',
    actions: 'Actions',
    view: 'View',
    copyUrl: 'Copy URL',
    delete: 'Delete',
    deleteConfirmTitle: 'Delete this verification record?',
    deleteConfirmDesc: 'This cannot be undone. Any old verification links will stop working.',
    deleteOk: 'Delete',
    deleteSuccess: 'Verification record deleted',
    deleteFailed: 'Delete failed',
    deleteForbidden: 'Not allowed to delete. Sign in and ensure you are Tenant_Admin.',
    uploadModalTitle: 'Upload Certificate and Phone Number',
    company: 'Company',
    companyRequired: 'Please select a company',
    companySelectPlaceholder: 'Select company',
    currentCompanyPlaceholder: 'Current Company',
    phoneNumberIdSelectLabel: 'Phone Number ID (select from company master)',
    phoneNumberIdSelectFromCompany: 'Company master',
    phoneNumberIdSelectPlaceholder: 'Select or enter Phone Number ID',
    certificate: 'Digital Certificate (Base64)',
    certificateRequired: 'Please enter certificate',
    certificateFormatError: 'Certificate format may be incorrect',
    certificateHelp: 'Please copy the base64-encoded digital certificate from Meta Business Suite',
    certificatePlaceholder: 'Paste base64-encoded certificate...',
    submit: 'Submit',
    cancel: 'Cancel',
    uploadSuccess: 'Certificate uploaded',
    uploadSuccessTitle: 'Upload Successful',
    uploadSuccessMessage: 'Certificate uploaded successfully, please send the following URL to the customer:',
    verificationUrl: 'Verification URL',
    copyUrlButton: 'Copy URL',
    urlCopied: 'URL copied to clipboard',
    uploadFailed: 'Upload failed',
    loadFailed: 'Load failed',
    loadVerificationsFailed: 'Failed to load verification records',
    viewDetails: 'View Details',
    loadDetailsFailed: 'Failed to load details',
    verificationRecordDetails: 'Verification Record Details',
    verificationMethod: 'Verification Method',
    updatedAt: 'Updated At',
    errorMessage: 'Error Message',
    na: 'N/A',
    detailTitle: 'Verification Record Details',
    detailPhoneNumber: 'Phone Number:',
    detailStatus: 'Status:',
    detailCertificateExpiry: 'Certificate Expiry:',
    detailCodeExpiry: 'Verification Code Expiry:',
    detailVerificationMethod: 'Verification Method:',
    detailPhoneNumberId: 'Phone Number ID:',
    detailCreatedAt: 'Created At:',
    detailUpdatedAt: 'Updated At:',
    detailErrorMessage: 'Error Message:',
    detailVerificationUrl: 'Verification URL:',
    verificationUrlCopied: 'Verification URL copied to clipboard',
    totalRecords: 'Total {total} records',
    
    // Status labels
    statusPending: 'Pending',
    statusRequested: 'Code Requested',
    statusVerified: 'Verified',
    statusExpired: 'Expired',
    statusFailed: 'Failed',
    
    // Form validation and hints
    phoneNumberRequired: 'Please enter phone number (Company.WA_PhoneNo_ID not configured)',
    phoneNumberInvalid: 'Please enter a valid phone number (e.g., +85296062000 or 85296062000)',
    phoneNumberOptional: 'Optional: If left empty, system will automatically get from Meta API or Company.Phone',
    phoneNumberRequiredWhenNoId: 'Required: Because Company.WA_PhoneNo_ID is not configured',
    phoneNumberPlaceholderOptional: 'Optional: Leave empty to auto-get from Meta API',
    phoneNumberPlaceholderRequired: 'e.g., +85296062000 or 85296062000',
    
    // Error messages
    loadCompanyInfoFailed: 'Failed to load company information',
    cannotGetCompanyId: 'Cannot get company ID',
    cannotGetCompanyInfo: 'Cannot get company information, please login again',
    cannotLoadVerifications: 'Cannot load verification records: Company ID is empty',
    unknownError: 'Unknown error',
    
    // Country code detection
    duplicateCountryCodeDetected: 'Duplicate country code detected, automatically removed'
  },

  // Permission Management
  permissionManagement: {
    title: 'Permission Management',
    roleName: 'Role Name',
    description: 'Description',
    pageDescription: 'Manage roles and interface permissions',
    interfaces: 'Interface Permissions',
    actions: 'Actions',
    systemDefault: 'System Default',
    companyCustom: 'Company Custom',
    selectCompany: 'Select Company',
    noPermissions: 'No Permissions',
    saveSuccess: 'Permissions saved successfully',
    saveFailed: 'Failed to save permissions',
    loadFailed: 'Failed to load permissions',
    editingCompany: 'Editing Company'
  },
  reports: {
    noPermission: 'You do not have permission to access reports',
    loadPermissionFailed: 'Failed to load permissions',
    unauthorized: 'Unauthorized',
    noDailyReportsPermission: 'You do not have permission to access any daily reports',
    noMonthlyReportsPermission: 'You do not have permission to access any monthly reports',
    noRealtimeReportsPermission: 'You do not have permission to access any realtime reports',
    noEformInstanceReportsPermission: 'You do not have permission to access eform instance reports',
    loadStatisticsFailed: 'Failed to load statistics',
    loadDataFailed: 'Failed to load report data',
    exportComingSoon: 'Export feature coming soon',
    exportSuccess: 'Export successful',
    exportFailed: 'Export failed',
    totalPending: 'Total Pending',
    overdue: 'Overdue',
    urgent: 'Urgent',
    todayNew: 'Today New',
    totalRecords: 'Total {total} records',
    phoneNumber: 'Phone Number',
    messageCount: 'Message Count',
    workflowTriggers: 'Workflow Triggers',
    formSubmissions: 'Form Submissions',
    activePhoneNumbers: 'Active Phone Numbers',
    totalMessages: 'Total Messages',
    totalWorkflowTriggers: 'Total Workflow Triggers',
    totalFormSubmissions: 'Total Form Submissions',
    firstMessageTime: 'First Message Time',
    lastMessageTime: 'Last Message Time',
    workflowName: 'Workflow Name',
    status: 'Status',
    running: 'Running',
    completed: 'Completed',
    failed: 'Failed',
    error: 'Error',
    waiting: 'Waiting',
    dateRange: 'Date range',
    eformInstancesTitle: 'EForm Instance Reports',
    eformInstancesDescription: 'Search and preview filled forms, export one form per PDF page',
    eformInstancesFilters: 'Filters',
    eformInstancesKeyword: 'Keyword',
    eformInstancesKeywordPlaceholder: 'Form name / Instance name / Form field content',
    eformInstancesStatus: 'Status',
    eformInstancesPreview: 'Preview',
    eformInstancesNoPreview: 'No preview content',
    eformInstancesNoData: 'No matching forms found',
    eformInstanceManualPending: 'Manual pending forms',
    eformInstanceManualResponded: 'Manual responded forms',
    // EForm Pivot Reports
    eformPivot: 'EForm Pivot Reports',
    eformPivotTitle: 'EForm Pivot Report',
    eformPivotDescription: 'Customise measures and dimensions for form instance group analysis',
    noEformPivotPermission: 'You do not have permission to access EForm Pivot Reports',
    pivotMeasure: 'Measure',
    pivotCount: 'Count',
    pivotRowDimension: 'Rows',
    pivotColDimension: 'Columns',
    pivotSystemFields: 'System Fields',
    pivotFormFields: 'Form Fields',
    pivotSwapAxes: 'Swap Rows/Columns',
    pivotTotal: 'Total',
    pivotRecords: 'records',
    pivotDrillDownTitle: 'Detail Records',
    pivotDateYear: 'Year',
    pivotDateQuarter: 'Quarter',
    pivotDateMonth: 'Month',
    pivotDateDay: 'Day',
    pivotFilterByForms: 'Select forms (multiple)',
    pivotFilterByFormsPlaceholder: 'Leave empty = all forms',
    exportExcel: 'Export Excel',
    exportExcelSuccess: 'Excel exported successfully',
    exportExcelFailed: 'Export Excel failed',
    noCommerceReportsPermission: 'You do not have permission to access commerce reports',
    commerce: {
      title: 'Commerce Reports',
      statement: 'Statement',
      salesPivot: 'Sales Order Pivot',
      noStatementPermission: 'No permission for Statement report',
      noSalesPivotPermission: 'No permission for Sales Order Pivot',
      monthRange: 'Delivery month range',
      month: 'Month',
      customers: 'Customers',
      allCustomers: 'All customers',
      selectCustomers: 'Select customers',
      loadFailed: 'Failed to load report',
      grandTotal: 'Grand Total',
      monthTotal: 'Month Total',
      customerTotal: 'Customer Total',
      orderNo: 'Order No.',
      deliveryDate: 'Delivery Date',
      amount: 'Amount',
      paymentTerm: 'Payment Terms',
      lineCount: 'Line Count',
      qty: 'Qty',
      total: 'Total',
      orderCount: 'Order Count',
      pivotMeasure: 'Measures',
      pivotRowDimension: 'Row dimension',
      pivotColDimension: 'Column dimension',
      pivotTotal: 'Total',
      exportExcel: 'Export Excel',
      exportPdf: 'Export PDF',
      exportSuccess: 'Export successful',
      exportFailed: 'Export failed',
      noData: 'No matching data',
      company: 'Company',
      selectCompany: 'Select company',
      dateRange: 'Delivery date range'
    },
    expandCollapseAll: 'Expand/Collapse all',
    noFieldSummary: 'No field summary configured',
    pdfExportCount: 'Export count',
    startedAt: 'Started At',
    endedAt: 'Ended At',
    duration: 'Duration',
    currentStep: 'Current Step',
    errorMessage: 'Error Message',
    totalExecutions: 'Total Executions',
    successRate: 'Success Rate',
    failureRate: 'Failure Rate',
    avgDuration: 'Average Duration',
    totalForms: 'Total Forms',
    approvalRate: 'Approval Rate',
    rejectionRate: 'Rejection Rate',
    avgApprovalTime: 'Average Approval Time',
    formTypeUsage: 'Form Type Usage',
    formCount: 'Form Count',
    approverWorkload: 'Approver Workload',
    weekdayVsWeekend: 'Weekday vs Weekend',
    weekday: 'Weekday',
    weekend: 'Weekend',
    approvalTrend: 'Approval Trend',
    approved: 'Approved',
    rejected: 'Rejected',
    hours: 'hours',
    totalProcessTypes: 'Total Process Types',
    avgEfficiency: 'Average Efficiency',
    bottleneckCount: 'Bottleneck Processes',
    optimizationSuggestions: 'Optimization Suggestions',
    processTypeDistribution: 'Process Type Distribution',
    efficiencyComparison: 'Efficiency Comparison',
    durationComparison: 'Duration Comparison',
    usageFrequencyTrend: 'Usage Frequency Trend',
    efficiencyVsDuration: 'Efficiency vs Duration',
    bottleneck: 'Bottleneck',
    optimization: 'Optimization',
    yes: 'Yes',
    no: 'No',
    activeUsers: 'Active Users',
    totalOperations: 'Total Operations',
    workflowUsage: 'Workflow Usage',
    formUsage: 'Form Usage',
    datasetUsage: 'Dataset Usage',
    whatsappUsage: 'WhatsApp Usage',
    functionName: 'Function Name',
    usageCount: 'Usage Count',
    growthRate: 'Growth Rate',
    functionUsageDistribution: 'Function Usage Distribution',
    functionUsageTrend: 'Function Usage Trend',
    workflows: 'Workflows',
    forms: 'Forms',
    datasets: 'Datasets',
    whatsapp: 'WhatsApp',
    datasetUsageRanking: 'Dataset Usage Ranking',
    queryCount: 'Query Count',
    updateCount: 'Update Count',
    userActivityRanking: 'User Activity Ranking',
    operationCount: 'Operation Count',
    totalSteps: 'Total Steps',
    avgStepDuration: 'Average Step Duration',
    totalWorkflows: 'Total Workflows',
    stepName: 'Step Name',
    stepType: 'Step Type',
    stepDurationComparison: 'Step Duration Comparison',
    hourlyWorkDistribution: 'Hourly Work Distribution',
    workflowStep3D: '3D Work Distribution Visualization',
    time: 'Time',
    workflow: 'Workflow',
    step: 'Step',
    selectWorkflow: 'Select Workflow',
    allWorkflows: 'All Workflows',
    minutes: 'minutes',
    workflowSuccessRate: 'Workflow Success Rate',
    formApprovalEfficiency: 'Form Approval Efficiency',
    whatsappResponseRate: 'WhatsApp Response Rate',
    systemAvailability: 'System Availability',
    kpiTrend: 'KPI Trend Comparison',
    anomalyEvents: 'Anomaly Events Summary',
    improvementSuggestions: 'Improvement Suggestions',
    suggestion: 'Suggestion',
    category: 'Category',
    priority: 'Priority',
    description: 'Description',
    approved: 'Approved',
    rejected: 'Rejected',
    totalForms: 'Total Forms',
    approvedAt: 'Approved At',
    approver: 'Approver',
    processingTime: 'Processing Time',
    active: 'Active',
    inactive: 'Inactive',
    successCount: 'Success Count',
    failedCount: 'Failed Count',
    healthScore: 'Health Score',
    lastExecutionTime: 'Last Execution Time',
    activeWorkflows: 'Active Workflows',
    inactiveWorkflows: 'Inactive Workflows',
    overallHealthScore: 'Overall Health Score',
    statusDistribution: 'Status Distribution',
    fillTypeDistribution: 'Fill Type Distribution',
    hourlyTrend: '24-Hour Trend',
    newTasks: 'New Tasks',
    detailTable: 'Detail Table',
    records: 'records',
    formTypes: 'form types',
    workflowTypes: 'workflow types',
    noData: 'No data',
    topWorkflows: 'Top 10 Workflow Execution Count',
    executionCount: 'Execution Count',
    executions: 'Executions',
    durationDistribution: 'Duration Distribution',
    processingFlow: 'Processing Flow',
    fillTypeProcessingTime: 'Average Processing Time by Fill Type',
    hourlySubmissionTrend: '24-Hour Submission Trend',
    submissions: 'Submissions',
    problemWorkflows: 'Problem Workflows (Lowest Health Score Top 10)',
    successRateVsDuration: 'Success Rate vs Duration',
    definitionTypes: 'definition types',
    topActivePhoneNumbers: 'Top 20 Active Phone Numbers',
    messageTypeDistribution: 'Message Type Distribution',
    messageTypeText: 'Text',
    messageTypeImage: 'Image',
    messageTypeFile: 'File',
    messageTypeAudio: 'Audio',
    hourlyInteractionHeatmap: '24-Hour Interaction Heatmap',
    interactionVsWorkflow: 'Interaction Frequency vs Workflow Triggers',
    loginRequired: 'Please login first',
    loginExpired: 'Login expired, please login again',
    daily: {
      pendingOverview: 'Pending Tasks Overview',
      workflowExecution: 'Workflow Execution Daily',
      formEfficiency: 'Form Processing Efficiency',
      workflowHealth: 'Workflow Health Monitor',
      whatsappInteraction: 'WhatsApp Interaction Analysis'
    },
    monthly: {
      workflowPerformance: 'Workflow Performance Monthly',
      formApproval: 'Form Approval Analysis Monthly',
      businessInsights: 'Business Process Insights',
      systemUsage: 'System Usage Statistics',
      operationalOverview: 'Operational Performance Overview',
      processStepExecution: 'Process Step Execution Analysis'
    },
    realtime: {
      workflowActivity: 'Workflow Activity Kanban',
      description: 'Real-time monitoring of all running step executions (auto-updates every 3 seconds)',
      totalActive: 'Active Steps',
      running: 'Running',
      waiting: 'Waiting',
      completed: 'Completed',
      failed: 'Failed',
      noActiveWorkflows: 'No active workflows at the moment',
      noActiveSteps: 'No active step executions at the moment',
      noItems: 'No items',
      selectWorkflow: 'Select Workflow Definition',
      allWorkflows: 'All Workflows',
      dateRange: 'Date Range:',
      workflowDefinition: 'Workflow Definition:',
      createdAt: 'Created At:',
      executionTime: 'Execution Time:',
      stepIndex: 'Step Index:',
      initiatedBy: 'Initiated By:',
      waitingFor: 'Waiting:',
      executionFailed: 'Execution Failed',
      failedAlert: '{count} workflow executions failed, please handle promptly',
      userReplies: 'User Replies:'
    },
    actionType: {
      startWorkflow: 'Start Workflow',
      replyQrcode: 'Reply QR Code',
      replyMsg: 'Reply Message',
      receiveNotification: 'Receive Notification',
      receiveEform: 'Receive Form',
      fillEform: 'Fill Form',
      unknown: 'Unknown Action'
    },
    actionTypes: 'action types',
    
    // Process Data Filters
    selectWorkflowFirst: 'Please select workflow name first to load Process Data',
    processVariableFilters: 'Process Data Filters (for grouping)',
    loadingProcessVariables: 'Loading Process Data...',
    noProcessVariables: 'No Process Data defined for this workflow',
    selectProcessVariablesForGrouping: 'Select Process Data for grouping',
    pvFilterHelp: 'Selected Process Data will be used to group media files',
    selectedForGrouping: 'Selected for grouping:',
    groupingNote: 'Media files will be grouped and displayed by the values of selected Process Data',
    removeFilter: 'Remove',
    columnName: 'Column Name',
    columnNameRequired: 'Please select column name',
    selectColumn: 'Select column',
    operator: 'Operator',
    operatorRequired: 'Please select operator',
    selectOperator: 'Select operator',
    equals: 'Equals',
    contains: 'Contains',
    greaterThan: 'Greater Than',
    lessThan: 'Less Than',
    notEquals: 'Not Equals',
    value: 'Value',
    valueRequired: 'Please enter search value',
    enterSearchValue: 'Enter search value',
    addSearchCondition: 'Add Search Condition',
    
    // Apps Media Reports
    appsMedia: 'App\'s Media Reports',
    eformInstances: 'EForm Instance Reports',
    eformPivotReports: 'EForm Pivot Reports',
    appsMediaDescription: 'Display image media files grouped by workflow execution and Process Data, with Windows Gallery layout and PDF, Word, or ZIP export',
    instanceFilters: 'Workflow Instance Filters',
    pleaseSetFilters: 'Please set filters first',
    loading: 'Loading...',
    processingGroup: 'Processing group',
    found: 'Found',
    groups: 'groups',
    statusSubGroups: 'status sub-groups',
    images: 'images',
    noMediaFound: 'No media files found matching the criteria',
    loadFailed: 'Load failed',
    noDataToExport: 'No data to export',
    exportingPdf: 'Exporting PDF...',
    exportSuccess: 'PDF export successful',
    exportFailed: 'PDF export failed',
    exportPdf: 'Export PDF',
    exportPdfLandscape: 'Export PDF (Landscape)',
    exportPdfPortrait: 'Export PDF (Portrait)',
    exportDocx: 'Export Docx',
    exportDocxTooltip: 'Export as Word document; remove images or adjust layout in Word',
    exportingDocx: 'Exporting Word...',
    exportDocxSuccess: 'Word export successful',
    exportDocxFailed: 'Word export failed',
    exportZip: 'Download ZIP',
    exportZipTooltip: 'Download all images in folders by group',
    exportingZip: 'Building ZIP...',
    exportZipSuccess: 'ZIP download successful',
    exportZipFailed: 'ZIP download failed',
    noMediaData: 'No media data, please set filters and click "Query"',
    
    // Gallery Settings
    gallerySettings: 'Gallery Settings',
    displaySettings: 'Display Settings',
    pdfExportSettings: 'PDF Export Settings',
    maxImagesPerPage: 'Max Images Per Page',
    maxImagesPerPageTooltip: 'Control the maximum number of images displayed per page, the actual number will be automatically adjusted based on image size',
    imageGap: 'Image Gap (mm)',
    imageGapTooltip: 'Spacing between images when exporting to PDF',
    minImageWidth: 'Min Image Width (mm)',
    minImageWidthTooltip: 'Prevent images from being too small to see clearly. Images in PDF export will not be smaller than this width',
    pdfOrientation: 'A4 Orientation',
    pdfOrientationTooltip: 'Paper orientation when exporting to PDF',
    landscape: 'Landscape',
    portrait: 'Portrait',
    imageQuality: 'Image Quality',
    imageQualityTooltip: 'Image compression quality when exporting to PDF (0.1-1.0), higher value means better quality but larger file size',
    expand: 'Expand',
    collapse: 'Collapse',
    
    // Instance Filters
    workflowName: 'Workflow Name',
    selectWorkflowName: 'Select workflow name',
    selectStatus: 'Select status',
    all: 'All',
    startedDateRange: 'Start Date Range',
    startDate: 'Start Date',
    endDate: 'End Date',
    
    // Process Data Filters - Grouping
    selectGroupingVariables: 'Select Process Data for Grouping',
    groupingVariablesHelp: 'Selected Process Data will be used to group media files. Process instances with the same PV combination will be merged into the same group',
    groupedProcessVariables: 'Grouped Process Data',
    filterConditions: 'Filter Conditions',
    filterConditionsHelp: 'Set filter conditions to filter process instances that match the criteria',
    selectWorkflowNameFirst: 'Please select workflow name first to start query',
    printOutSettings: 'Print Out Settings',
    excludeImage: 'Exclude from print',
    restoreImage: 'Restore image',
    excludedTag: 'Excluded',
    excludedCompanyShared: 'Click the top-right of an image to exclude it from print; exclusions are shared company-wide',
    excludedSaveFailed: 'Failed to save exclusion settings',
    excludedSaving: 'Saving exclusions...',
    eformInstancePdfSettings: 'PDF Export Settings',
    eformInstancePdfSettingsDescription: 'Layout follows form HTML/CSS and default margins.',
    eformInstancePdfFitToPage: 'Scale to fit one page (Fit to page)',
    eformInstancePdfFitToPageDescription: 'When on, each form is scaled to fit on one PDF page. (Fit to one page)',
    eformInstanceDisplaySettings: 'Display Settings',
    eformInstanceBaseFontSize: 'Base Font Size (px)',
    eformInstanceBaseFontSizeTooltip: 'Base font size for forms in PDF export, larger value means larger text',
    eformInstanceContentPadding: 'Content Padding (px)',
    eformInstanceContentPaddingTooltip: 'Padding between form content and edges in PDF export, larger value means more spacing',
    eformInstanceZoomScale: 'Zoom Scale',
    eformInstanceZoomScaleTooltip: 'Overall zoom scale for PDF export, larger value means larger content (recommended 1.0-2.0)',
    eformInstanceFillWidth: 'Fill Width First',
    eformInstanceFillWidthTooltip: 'When on, content fills the page width to reduce side margins; long forms will span multiple pages',
    eformInstanceAdvancedSettings: 'Advanced Settings',
    eformInstanceMargin: 'Page Margin (mm)',
    eformInstanceMarginTooltip: 'Page margin for PDF, smaller value means more available space',
    eformInstanceRenderViewportPx: 'Render viewport width (px)',
    eformInstanceRenderViewportPxTooltip: 'Virtual viewport width used when laying out HTML for PDF; too narrow causes header columns to collapse—increase until layout looks right',
    eformInstanceRenderScale: 'Render Resolution',
    eformInstanceRenderScaleTooltip: 'Resolution multiplier for HTML to image conversion, larger value means higher quality but longer processing time (recommended 2-3)'
  },
  
  // MetaFlowBuilder related
  metaFlowBuilder: {
    componentPropertyEditor: {
      labels: {
        inputType: 'Input Type',
        required: 'Required',
        validationPattern: 'Validation Pattern',
        helperText: 'Helper Text',
        defaultValue: 'Default Value',
        richTextContent: 'Rich Text Content',
        options: 'Options',
        maxSelectedItems: 'Max Selected Items',
        description: 'Description',
        image: 'Image',
        width: 'Width (width)',
        height: 'Height (height)',
        imageList: 'Image List',
        altText: 'Alt Text',
        aspectRatio: 'Aspect Ratio',
        scaleType: 'Scale Type',
        componentId: 'Component ID',
        fieldName: 'Field Name (Name)',
        title: 'Title',
        maxLength: 'Max Length',
        actionType: 'Action Type',
        targetScreen: 'Target Screen',
        payload: 'Payload',
        httpMethod: 'HTTP Method',
        endpointUrl: 'Endpoint URL',
        commerceCollection: 'Commerce Collection',
        metaCollectionLimit: 'Max items to return'
      },
      placeholders: {
        patternExample: 'e.g.: [0-9]+',
        helperTextHint: 'Hint text displayed below the input field',
        defaultValueHint: 'Pre-filled value when user opens the form, e.g. area code 852',
        richTextContentHint: 'Enter rich text content, supports Markdown syntax\nFor example:\n# Title\nThis is *bold* and _italic_ text\n~strikethrough~',
        optionId: 'Option ID',
        optionTitle: 'Option Title',
        maxSelectedItemsExample: 'e.g.: 2',
        descriptionHint: 'Selector description text',
        widthHeightExample: 'e.g.: 200',
        altTextHint: 'Image description (for accessibility)',
        fieldNameExample: 'e.g.: customer_name',
        selectScreen: 'Select Screen',
        payloadHint: 'Optional payload data',
        endpointUrlHint: 'API endpoint URL',
        selectCommerceCollection: 'Please select a Commerce Collection'
      },
      tooltips: {
        bold: 'Bold (**text**)',
        italic: 'Italic (*text*)',
        strikethrough: 'Strikethrough (~~text~~)',
        code: 'Inline Code (`code`)',
        heading1: 'Heading 1 (# Title)',
        heading2: 'Heading 2 (## Title)',
        list: 'Unordered List (- Item)',
        link: 'Link ([text](URL))',
        richTextHint: 'Supports Markdown syntax: *bold*, _italic_, ~strikethrough~, # heading, etc. Each line will be an element in the array.',
        imageUpload: 'Upload image, will automatically convert to base64 format and generate as src attribute in JSON',
        fieldNameHint: 'This name will be used in Meta Flow JSON and webhook reply data. Recommended to use meaningful names like \'customer_name\', \'order_date\', etc.',
        targetScreenHint: 'Select the Screen ID to navigate to',
        textAreaMaxLength: 'Default 600 characters, official max 600'
      },
      selectOptions: {
        inputTypes: {
          text: 'Text',
          email: 'Email',
          phone: 'Phone',
          number: 'Number',
          url: 'URL'
        },
        actionTypes: {
          navigate: 'Navigate to Screen',
          submit: 'Submit',
          call: 'Call',
          url: 'Open URL'
        },
        scaleTypes: {
          contain: 'Contain (Full Display)',
          cover: 'Cover (Fill)'
        },
        httpMethods: {
          get: 'GET',
          post: 'POST',
          put: 'PUT',
          delete: 'DELETE'
        }
      },
      buttons: {
        list: 'List',
        link: 'Link',
        addOption: 'Add Option',
        remove: 'Remove',
        uploadImage: 'Upload Image',
        deleteImage: 'Delete This Image',
        addImage: 'Add Image',
        saveChanges: 'Save Changes'
      },
      messages: {
        optionIdRequired: 'Option ID is required',
        optionTitleRequired: 'Option Title is required',
        altTextRequired: 'Alt Text is required',
        fieldNameRequired: 'Please enter field name',
        fieldNamePattern: 'Name can only contain letters, numbers, and underscores, and must start with a letter',
        titleRequired: 'Please enter title',
        imageReadFailed: 'Image read failed',
        imageFormatError: 'Only JPEG and PNG formats are supported!',
        imageSizeExceeded: 'Image size cannot exceed {maxSizeKB}KB (1MB)!',
        imageSizeWarning: 'Image size {fileSizeKB}KB exceeds recommended value 300KB, may affect performance',
        maxImagesWarning: 'Maximum 3 images can be added!'
      },
      helperText: {
        richTextHint: 'Tip: Each line will be an element in the array. Supports Markdown syntax. Select text and click buttons above to format.',
        imageConverted: 'Tip: Image has been converted to base64 format',
        photoPickerRequiredHint: 'Maps to PhotoPicker min-uploaded-photos: on = at least 1 (required), off = 0 (optional).',
        documentPickerRequiredHint: 'Maps to DocumentPicker min-uploaded-documents: on = at least 1 (required), off = 0 (optional).',
        commerceCollectionHint: 'Options come from products linked to the selected Commerce Collection. Display: "Product Name - Unit"; selected value: product id (commerce_products.Id).'
      },
      defaultValues: {
        richTextDefault: 'Please enter rich text content',
        richTextDefaultLine2: 'Supports *bold*, _italic_, ~strikethrough~, etc. Markdown syntax',
        imageAltDefault: 'Image {index}'
      },
      dividers: {
        actionSettings: 'Action Settings'
      }
    },
    screenEditor: {
      cardTitles: {
        header: 'Header (Optional)',
        body: 'Body (Required)',
        footer: 'Footer (Required)',
        actions: 'Actions (Action Components)'
      },
      labels: {
        headerType: 'Header Type:',
        headerText: 'Header Text:',
        mediaUrl: 'Media URL:',
        bodyExamplesTitle: 'Body Variable Examples (for Meta review)',
        flowHeaderText: 'Flow Screen Header (shown inside the Flow popup)',
        flowBodyText: 'Flow Screen Body (shown inside the Flow popup; static text recommended)',
        templateHeaderText: 'WhatsApp Message Header (Template; supports {{1}})',
        templateBodyText: 'WhatsApp Message Body (Template; supports {{N}} placeholders)'
      },
      selectOptions: {
        headerTypes: {
          text: 'Text',
          image: 'Image',
          video: 'Video',
          document: 'Document'
        }
      },
      placeholders: {
        headerText: 'Header Text',
        mediaUrl: 'Media URL',
        bodyContent: 'Enter Body content',
        footerContent: 'Enter Footer content (Required)',
        addComponent: 'Please enter component type (text_input, rich_text, date_picker, select, checkbox, radio):',
        dropZone: 'Drag a component from the palette on the left and drop here',
        bodyExampleValue: 'Example value for {{{n}}}',
        templateHeaderText: 'e.g. Hello {{1}}',
        templateBodyText: 'e.g. Product: {{1}}\\nQuantity: {{2}}\\nDate: {{3}}'
      },
      buttons: {
        removeHeader: 'Remove Header',
        addHeader: 'Add Header',
        addComponent: 'Add Component'
      },
      tooltips: {
        dragToReorder: 'Drag to reorder'
      },
      messages: {
        maxImagesError: 'Each screen can have a maximum of 3 images!',
        addRichTextSuccess: 'Added {componentType} component, automatically removed Header and Body',
        addComponentSuccess: 'Added {componentType} component',
        deleteRichTextSuccess: 'Deleted RichText component, automatically restored Header and Body',
        deleteComponentSuccess: 'Component deleted',
        richTextConflict1: 'RichText component can only be used with Footer, cannot coexist with other components',
        richTextConflict2: 'RichText component can only be used with Footer, please remove RichText first'
      },
      helperText: {
        footerRequired: '* Footer is required and cannot be empty',
        bodyExamplesHint: 'When the Body contains {{N}} placeholders, the values entered here are only used for Meta Flow Template review submission. At runtime, the actual values are still injected via the Process Data mapping on the send node.',
        flowHeaderHint: '{{N}} is not substituted here (it will render literally). Use a static title.',
        flowBodyHint: '{{N}} is not substituted here (it will render literally). Use static text such as "Please confirm the details and tap Reserve".',
        templateHeaderHint: 'Shown above the WhatsApp message bubble. {{1}} is replaced by body.parameters at send time (Meta limits HEADER to a single {{1}}). If empty, falls back to the Flow Screen Header (backward compatible).',
        templateBodyHint: 'Shown inside the WhatsApp message bubble. {{N}} is replaced by body.parameters at send time. {{N}} must match the indices of the send node\'s template variables. If empty, falls back to the Flow Screen Body (backward compatible).',
        templateHeaderTooManyPlaceholders: 'Meta API only supports a single {{1}} in HEADER. Extra placeholders will not be substituted; please keep only one.'
      },
      defaultValues: {
        headerText: 'Title',
        bodyText: 'Please enter content',
        footerText: 'Submit'
      }
    },
    componentRenderer: {
      placeholders: {
        button: 'Button',
        textInput: 'Text Input',
        textArea: 'Multi-line Text',
        richText: 'Rich Text Content (Supports Markdown)',
        select: 'Dropdown Selection',
        datePicker: 'Date Selection',
        option: 'Option',
        image: 'Image',
        imageIndex: 'Image {index}',
        addImages: 'Please add images (minimum 1, maximum 3)',
        unknownComponent: 'Unknown Component',
        component: 'Component'
      },
      cardTitles: {
        edit: 'Edit {componentType}'
      },
      buttons: {
        cancel: 'Cancel'
      },
      helperText: {
        imageCarouselSettings: 'Aspect Ratio: {aspectRatio}, Scale: {scaleType}'
      },
      altText: {
        preview: 'Preview'
      }
    },
    componentPalette: {
      componentLabels: {
        textInput: 'Text Input',
        textArea: 'Multi-line Text',
        datePicker: 'Date Selection',
        calendarPicker: 'Calendar Selection',
        select: 'Dropdown Selection',
        checkbox: 'Checkbox Group',
        radio: 'Radio Group',
        chipsSelector: 'Chips Selector',
        image: 'Image',
        imageCarousel: 'Image Carousel',
        photoPicker: 'Photo Picker',
        documentPicker: 'Document Picker',
        embeddedLink: 'Embedded Link',
        optIn: 'Opt In',
        if: 'Conditional (If)',
        switch: 'Conditional Render (Switch)',
        navigationList: 'Navigation List',
        richText: 'Rich Text Display'
      },
      categories: {
        input: 'Input',
        select: 'Selection',
        media: 'Media',
        mediaUpload: 'Media Upload',
        link: 'Link',
        logic: 'Logic',
        container: 'Container',
        textDisplay: 'Text Display',
        other: 'Other'
      },
      sectionTitles: {
        componentLibrary: 'Component Library'
      }
    },
    page: {
      formInfo: 'Form Information',
      flowName: 'Flow Name:',
      flowNamePlaceholder: 'Flow Name',
      description: 'Description:',
      descriptionPlaceholder: 'Description',
      screens: 'Screens',
      editScreen: 'Edit Screen: {title}',
      selectScreenToEdit: 'Please select a Screen to edit',
      componentProperties: 'Component Properties',
      back: 'Back',
      screenProperties: 'Screen Properties',
      screenId: 'Screen ID:',
      screenTitle: 'Screen Title:',
      screenTitlePlaceholder: 'Screen Title',
      componentList: 'Component List',
      noComponents: 'No components yet, please add from the component library on the left',
      delete: 'Delete',
      defaultFlowName: 'New Flow',
      defaultScreenTitle: 'New Screen',
      defaultComponentName: 'Component {index}',
      fieldDisplaySetting: 'Field Display Setting',
      messages: {
        flowNameRequired: 'Please enter Flow name',
        screenAdded: 'New Screen added',
        selectScreenFirst: 'Please select a Screen first',
        componentUpdated: 'Component updated',
        noFieldsToConfigure: 'Please design Flow and add input components first',
        fieldDisplaySettingPendingSave: 'Field display settings staged. Press Save to persist.'
      }
    },
    aiAssistant: {
      tabTitle: 'AI Assistant',
      chatEmptyHint: 'Enter your requirements and AI will help generate or modify the Meta Flow form',
      placeholderExample: 'e.g. Create a customer registration form with name, phone, and date fields',
      includeCurrentFlow: 'Include current Meta Flow JSON (edit mode)',
      generate: 'Generate form',
      pleaseEnterRequirements: 'Please enter a requirement description',
      generationFailed: 'Generation failed: ',
      generationSuccess: 'AI successfully generated the Meta Flow form',
      updatedSuccess: 'Meta Flow form updated based on your request',
      applyFailed: 'Failed to apply AI-generated form'
    },
    formTypeSelection: {
      title: 'Select Form Type',
      htmlFormDesigner: {
        title: 'HTML Form Designer',
        description: 'Use existing HTML form designer to create forms'
      },
      metaFlowBuilder: {
        title: 'Meta Flow Builder',
        description: 'Create WhatsApp Flows form (JSON format)'
      }
    }
  },

  wpaPermissions: {
    title: 'PWA Permission Management',
    pageTitle: 'PWA Permission Management',
    tabRoles: 'Roles',
    tabGroups: 'Groups',
    tabAccounts: 'PWA Accounts',
    rolesTitle: 'PWA Roles',
    groupsTitle: 'Permission Groups',
    accountsTitle: 'PWA Accounts',
    roleKey: 'Role Key',
    displayName: 'Display Name',
    description: 'Description',
    groupCount: 'Groups',
    contactCount: 'Accounts',
    accounts: 'Accounts',
    accountCount: 'Accounts',
    editRole: 'Edit Role',
    groupName: 'Group Name',
    role: 'Role',
    memberCount: 'Members',
    customerCount: 'Customers',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    disabled: 'Disabled',
    createGroup: 'Create Group',
    editGroup: 'Edit Group',
    members: 'Members',
    customers: 'Customers',
    addMember: 'Add Member',
    addMembers: 'Add Members',
    addCustomer: 'Add Customer',
    addCustomers: 'Add Customers',
    remove: 'Remove',
    search: 'Search',
    name: 'Name',
    phone: 'Phone',
    phonePlaceholder: 'e.g. 85291234567 (no +)',
    email: 'Email',
    customerNo: 'Customer No',
    branchNo: 'Branch No',
    customerName: 'Name',
    selectCustomersTable: 'Pick customers (table)',
    selectCustomersTableHint: 'Opens the same list as the customer master, with search, company filter (tenant admin) and multi-select.',
    selectDefaultCustomer: 'Select default customer',
    selectDefaultCustomerTable: 'Pick default customer (table)',
    selectDefaultCustomerOverrideHint: 'Must be one of the assigned customers; picking an unassigned one will also add it to the assignment list.',
    effectiveRole: 'Effective Role',
    roleSource: 'Source',
    override: 'Contact Setting',
    accountOverride: 'Account',
    group: 'Group',
    overrideCustomerCount: 'Assigned Customers',
    items: 'items',
    details: 'Details',
    // Account
    createAccount: 'Create Account',
    editAccountFor: 'Edit Account',
    deleteAccount: 'Delete Account',
    deleteAccountConfirm: 'Delete this PWA account? Related role / customers / group memberships will also be removed.',
    accountSaved: 'Account saved',
    saveAndSendNotification: 'Save & send notification',
    saveAndResendPassword: 'Save & resend password',
    saveAndResendPasswordConfirm: 'Save changes, generate a new password, and resend the welcome message (including email). Continue?',
    saveAndResendPasswordSuccess: 'Saved, password reset, and welcome message resent',
    accountDeleted: 'Account deleted',
    accountTabIdentity: 'Identity / Role',
    accountTabCustomers: 'Customers / Default',
    accountIdentityHint: 'PWA login account (decoupled from contact master). Phone is used for WhatsApp OTP login matching.',
    searchAccount: 'Search PWA accounts...',
    loginId: 'Login ID',
    loginIdField: 'Login ID',
    loginIdRequired: 'Please fill in the login ID',
    password: 'Password',
    passwordRequiredForCreate: 'Password is required to create an account',
    newPassword: 'New Password',
    newPasswordHint: 'Leave blank to keep current password',
    defaultCustomer: 'Default Customer',
    selectCustomers: 'Select Customers',
    selectRole: 'Select Role',
    removeMemberConfirm: 'Remove this member?',
    removeCustomerConfirm: 'Remove this customer?',
    deleteGroupConfirm: 'Delete this group?',
    memberAdded: 'Member added',
    memberRemoved: 'Member removed',
    customerAdded: 'Customer added',
    customerRemoved: 'Customer removed',
    groupSaved: 'Group saved',
    groupDeleted: 'Group deleted',
    groupCustomersUpdated: 'Customers updated',
    roleSaved: 'Role saved',
    contactName: 'Contact Name',
    loginName: 'Login Name',
    loginNamePlaceholder: 'Enter login name',
    hasPassword: 'Has Password',
    selectContact: 'Select Contact',
    noData: 'No Data',
    saveSuccess: 'Saved successfully',
    deleteSuccess: 'Deleted successfully',
    confirmDelete: 'Are you sure you want to delete?',
    tabOtpSettings: 'OTP',
    otpSettingsTitle: 'OTP Settings',
    otpTabWhatsapp: 'WhatsApp',
    otpTabEmail: 'Email Template',
    otpEmailHint: 'For PWA forgot-password email OTP. Subject or body must include {{1}}, replaced with a 6-digit code when sent.',
    otpEmailTemplateTitle: 'Email OTP Template',
    otpEmailSubject: 'Subject',
    otpEmailSubjectPlaceholder: 'e.g. [Company] Password reset code {{1}}',
    otpEmailBody: 'Body (HTML supported)',
    otpEmailBodyPlaceholder: '<p>Hello,</p><p>Your verification code is: <strong>{{1}}</strong></p><p>Valid for 5 minutes.</p>',
    otpEmailPreview: 'Preview ({{1}} → 123456)',
    otpEmailRequired: 'Please enter subject and body',
    otpEmailPlaceholderRequired: 'Subject or body must include {{1}} as the OTP placeholder',
    otpEmailSaved: 'Email OTP template saved',
    otpWhatsappSaved: 'WhatsApp OTP settings saved',
    tabWelcomeSettings: 'Welcome Message',
    welcomeSettingsTitle: 'Welcome Message',
    welcomeWhatsappHint: 'Sent after new PWA account creation (if phone + template configured). Use {{1}} for login ID and {{2}} for display name in the body.',
    welcomeWhatsappPolicyWarning: 'WhatsApp templates are for general notices, explanations, or introductions only. Do not send passwords or other sensitive credentials—use Welcome Message → Email for initial passwords.',
    welcomeActiveTemplate: 'Active welcome template',
    welcomeNoTemplate: 'No welcome template configured',
    welcomeCreateTemplate: 'Create welcome template',
    welcomeCatMarketing: 'Marketing',
    welcomeCatUtility: 'Utility',
    welcomeCatAuth: 'Authentication',
    welcomeAuthHint: 'AUTHENTICATION templates use Meta-generated security copy; not ideal for welcome messages.',
    welcomeTemplateList: 'Templates',
    welcomeSelectTemplate: 'Select an approved template first',
    welcomeWhatsappSaved: 'WhatsApp welcome settings saved',
    welcomeEmailRequired: 'Subject and body are required',
    welcomeEmailSaved: 'Email welcome template saved',
    welcomeBodyRequired: 'Body text is required',
    welcomeTplSubmitted: 'Template submitted to Meta for review',
    welcomeEmailHint: 'Sent when the new account has email. {{login_id}}/{{1}}=account, {{display_name}}/{{2}}=name, {{password}}/{{3}}=password at creation (one-time).',
    welcomeEmailTemplateTitle: 'Email welcome template',
    welcomeEmailRteHint: 'Use the toolbar for bold, links, etc. Buttons on the right insert account, name, and password placeholders.',
    welcomeInsertLoginId: 'Insert {{login_id}}',
    welcomeInsertDisplayName: 'Insert {{display_name}}',
    welcomeInsertPassword: 'Insert {{password}}',
    welcomeRteBold: 'Bold',
    welcomeRteItalic: 'Italic',
    welcomeRteUnderline: 'Underline',
    welcomeRteStrike: 'Strikethrough',
    welcomeRteHeader: 'Heading',
    welcomeRteColor: 'Text color',
    welcomeRteBackground: 'Background color',
    welcomeRteListOrdered: 'Numbered list',
    welcomeRteListBullet: 'Bullet list',
    welcomeRteAlign: 'Align',
    welcomeRteLink: 'Insert link',
    welcomeRteClean: 'Clear formatting'
  },
  chatBotInbox: {
    loadFailed: 'Failed to load conversation list',
    searchPlaceholder: 'Search contact or number…',
    filterAll: 'All',
    filterContact: 'Contacts',
    filterAnonymous: 'Anonymous',
    sourceAll: 'All sources',
    sourceChatBot: 'ChatBot',
    sourceChatOrderingCart: 'Ordering Cart',
    empty: 'No conversations yet',
    selectSession: 'Select a conversation from the left',
    pollingActive: 'Live updates active (checks every 30s)',
    newMessagesAvailable: 'New messages available, ',
    reloadNow: 'Load now'
  }
};

export default en; 